import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Swan account number */
  AccountNumber: { input: string; output: string };
  /**
   * The amount given with fractional digits, where fractions must be compliant to the currency definition. Up to 14 significant figures. Negative amounts are signed by minus. The decimal separator is a dot.
   *
   * Example: Valid representations for EUR with up to two decimals are:
   *
   * 1056
   * 5768.2
   * -1.50
   * 5877.78
   */
  AmountValue: { input: string; output: string };
  AuditId: { input: string; output: string };
  AuthorizationId: { input: string; output: string };
  /** Bank Identifier Code */
  BIC: { input: string; output: string };
  /** Country code alpha 2 (ISO 3166) */
  CCA2: { input: string; output: string };
  /** Country code alpha 3 (ISO 3166) */
  CCA3: { input: string; output: string };
  CardToken: { input: string; output: string };
  /** currency code alpha 3 (ISO 4217) */
  Currency: { input: string; output: string };
  /** Date with YYYY-MM-DD format */
  Date: { input: string; output: string };
  /**
   * Date time (ISO 8601 with time information)
   * ex: 2021-04-12T16:28:22.867Z
   */
  DateTime: { input: string; output: string };
  EmailAddress: { input: string; output: string };
  HexColorCode: { input: string; output: string };
  /** International Bank Account Number */
  IBAN: { input: string; output: string };
  /** 6 digits numeric passcode */
  PIN: { input: string; output: string };
  /**
   * E.164 standard format phone number
   *
   * Examples
   * +551155256325
   * +44207183875
   */
  PhoneNumber: { input: string; output: string };
  /**
   * SEPA Creditor Identifier
   * format :
   *     1 – 2: ISO Country Code
   *     3 – 4: Check Digit
   *     5 – 7: Creditor Business Code – you (Creditor) choose this. The default is ZZZ
   *     8 - 35: Creditor National Identifier – a consecutive number that will be assigned by country
   * example:
   *     FR11ABC123456
   */
  SepaCreditorIdentifier: { input: string; output: string };
  /**
   * SEPA Identifier
   * max 35 Latin characters as follow :
   *     a b c d e f g h i j k l m n o p q r s t u v w x y z
   *     A B C D E F G H I J K L M N O P Q R S T U V W X Y Z
   *     0 1 2 3 4 5 6 7 8 9
   *     / - ? : ( ) . , '  +
   * with some follow extra rules :
   *     Content must not start or end with a ‘/’
   *     Content must not contain ‘//’s
   */
  SepaReference: { input: string; output: string };
  TokenRequestorId: { input: string; output: string };
  /**
   * URL that follows the WHATWG URL Standard.
   *
   * [Examples of parsed URLs](https://url.spec.whatwg.org/#example-url-parsing) may be found in the Standard itself.
   */
  URL: { input: string; output: string };
  Upload: { input: unknown; output: unknown };
  WalletToken: { input: string; output: string };
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type Account = {
  __typename: "Account";
  /**
   * Bank Identifier Code
   * Only if the account membership has `canViewAccount=true` & this account has `paymentLevel=Unlimited`
   */
  BIC: Scalars["BIC"]["output"];
  /**
   * International Bank Account Number
   * Only if the account membership has `canViewAccount=true` & this account has `paymentLevel=Unlimited`
   */
  IBAN?: Maybe<Scalars["IBAN"]["output"]>;
  /** Download link to the main account iban's bank details */
  bankDetails?: Maybe<Scalars["String"]["output"]>;
  /** `true` if the main IBAN refuses all Sepa Direct Debit received */
  blockSDD?: Maybe<Scalars["Boolean"]["output"]>;
  /** Cash account type */
  cashAccountType: CashAccountType;
  /** Country of the account */
  country: AccountCountry;
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Currency */
  currency: Scalars["Currency"]["output"];
  /** Account holder */
  holder: AccountHolder;
  /** Unique identifier of an account */
  id: Scalars["ID"]["output"];
  /**
   * A list of invoices of an account.
   * The list is ordered by creation date (from newest to oldest)
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  invoices?: Maybe<InvoiceConnection>;
  /** Language used for account statements */
  language: AccountLanguage;
  /** Legal representative account membership */
  legalRepresentativeMembership: AccountMembership;
  /**
   * List of account membership for this account
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  memberships: AccountMembershipConnection;
  /** Account name */
  name: Scalars["String"]["output"];
  /** Unique account number */
  number: Scalars["AccountNumber"]["output"];
  /** Partnership status */
  partnershipStatusInfo?: Maybe<PartnershipStatusInfo>;
  /** Type of the account : EMoney if account holder has not finished the KYC requirements, PaymentService otherwise */
  paymentAccountType: PaymentAccountType;
  /** Payment level */
  paymentLevel: PaymentLevel;
  /**
   * A list of receive Direct Mandates of an account.
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  receivedDirectDebitMandates?: Maybe<ReceivedDirectDebitMandateConnection>;
  /** `true`if a consent is required to fetch new transactions */
  requiredConsentToFetchNewTransactions: Scalars["Boolean"]["output"];
  /** Settings of the account */
  settings: AccountSettings;
  /** Status of the account */
  statusInfo: AccountStatusInfo;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** Date of the account going from eMoney to PaymentService */
  upgradedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * List of Virtual IBAN
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  virtualIbanEntries: VirtualIbanEntryConnection;
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountInvoicesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountMembershipsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<MembershipsFilterInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<AccountMembershipOrderByInput>;
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountReceivedDirectDebitMandatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<AccountReceivedDirectDebitMandateFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<AccountReceivedDirectDebitOrderByInput>;
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountVirtualIbanEntriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<VirtualIbanEntriesFilterInput>;
  first?: Scalars["Int"]["input"];
};

/** Account Closed status information */
export type AccountClosedStatus = AccountStatusInfo & {
  __typename: "AccountClosedStatus";
  closedAt: Scalars["DateTime"]["output"];
  closingAt: Scalars["DateTime"]["output"];
  /**
   * Reason why the account is suspended
   * @deprecated Use `reasonInfo` instead.
   */
  reason: Scalars["String"]["output"];
  /** Reason why the account is currently closed */
  reasonInfo: CloseAccountStatusReason;
  /** Account status (always Closed for type AccountClosedStatus) */
  status: AccountStatus;
};

/** Account Closing status information */
export type AccountClosingStatus = AccountStatusInfo & {
  __typename: "AccountClosingStatus";
  closingAt: Scalars["DateTime"]["output"];
  /**
   * Reason why the account is suspended
   * @deprecated Use `reasonInfo` instead.
   */
  reason: Scalars["String"]["output"];
  /** Reason why the account is currently in closing */
  reasonInfo: CloseAccountStatusReason;
  /** Account status (always Closing for type AccountClosingStatus) */
  status: AccountStatus;
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type AccountConnection = Connection & {
  __typename: "AccountConnection";
  /** AccountEdge list */
  edges: Array<AccountEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/**
 * Refers to the country of the account. It will determine the country code of the local IBAN of the account.
 *
 * Available Account Country: CCA3
 */
export type AccountCountry =
  /** Belgian account with an Belgian IBAN, starting with BE (Coming Soon, not supported yet). */
  | "BEL"
  /** German account with a German IBAN, starting with DE. */
  | "DEU"
  /** Spanish account with a Spanish IBAN, starting with ES. */
  | "ESP"
  /** French account with a French IBAN, starting with FR. */
  | "FRA"
  /** Italian account with an Italian IBAN, starting with IT. */
  | "ITA"
  /** Dutch account with a Dutch IBAN, starting with NL. */
  | "NLD";

/** Implements the Relay Edge interface */
export type AccountEdge = Edge & {
  __typename: "AccountEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The account */
  node: Account;
};

export type AccountFundingLimitsReachedReason =
  /** Account Holder funding limit exceeded */
  | "FundingLimitExceededRejection"
  /** Global funding limit exceeded */
  | "GlobalFundingLimitExceededRejection"
  /** Global instant funding limit exceeded */
  | "GlobalInstantFundingLimitExceededRejection"
  /** Account Holder instant funding limit exceeded */
  | "InstantFundingLimitExceededRejection"
  /** Insufficient funds rejection */
  | "InsufficientFundsRejection"
  /** Project funding limit exceeded */
  | "ProjectFundingLimitExceededRejection"
  /** Project instant funding limit exceeded */
  | "ProjectInstantFundingLimitExceededRejection";

/** The account holder is the person who owns the money stored in the account. The account holder can be one of your customers, whether it is a natural person or a legal person, or quite simply you. */
export type AccountHolder = {
  __typename: "AccountHolder";
  /**
   * List of accounts owned by the account holder.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  accounts: AccountConnection;
  /** Created date. */
  createdDate: Scalars["DateTime"]["output"];
  /**
   * List of funding limit settings change request for an account holder
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  fundingLimitSettingsChangeRequests: FundingLimitSettingsChangeRequestConnection;
  /** Unique identifier of the account holder. */
  id: Scalars["ID"]["output"];
  /** Account holder type information. */
  info: AccountHolderInfo;
  /** Account holder onboarding */
  onboarding?: Maybe<Onboarding>;
  /**
   * A list of Payment Mandates for an account holder.
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  paymentMandates?: Maybe<PaymentMandateConnection>;
  /** Residency address. */
  residencyAddress: AddressInfo;
  /** Account holder risk info */
  riskInfo?: Maybe<AccountHolderRiskInfo>;
  /** Account holder status information. */
  statusInfo?: Maybe<AccountHolderStatusInfo>;
  /**
   * List of supporting document collection for an account holder
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  supportingDocumentCollections: SupportingDocumentCollectionConnection;
  /** Updated date. */
  updatedDate: Scalars["DateTime"]["output"];
  /**
   * Verification status.
   * *Banking regulations require financial institutions such as Swan to know and verify their customers in order to comply with their anti-money laundering and terrorist financing obligations. In banking jargon, we talk about KYC (Know Your Customers) procedure*
   */
  verificationStatus: VerificationStatus;
  /** Account holder verification Status information. */
  verificationStatusInfo: AccountHolderVerificationStatusInfo;
};

/** The account holder is the person who owns the money stored in the account. The account holder can be one of your customers, whether it is a natural person or a legal person, or quite simply you. */
export type AccountHolderAccountsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<AccountOrderByInput>;
};

/** The account holder is the person who owns the money stored in the account. The account holder can be one of your customers, whether it is a natural person or a legal person, or quite simply you. */
export type AccountHolderFundingLimitSettingsChangeRequestsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
};

/** The account holder is the person who owns the money stored in the account. The account holder can be one of your customers, whether it is a natural person or a legal person, or quite simply you. */
export type AccountHolderPaymentMandatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<PaymentMandateFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<PaymentMandateOrderByInput>;
};

/** The account holder is the person who owns the money stored in the account. The account holder can be one of your customers, whether it is a natural person or a legal person, or quite simply you. */
export type AccountHolderSupportingDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SupportingDocumentCollectionFilterInput>;
  first?: Scalars["Int"]["input"];
};

/** Account Holder Canceled Status Information */
export type AccountHolderCanceledStatusInfo = AccountHolderStatusInfo & {
  __typename: "AccountHolderCanceledStatusInfo";
  /** Reason why the account holder is suspended. */
  reason: Scalars["String"]["output"];
  /** Status of the account holder. */
  status: AccountHolderStatus;
};

export type AccountHolderCompanyInfo = AccountHolderInfo & {
  __typename: "AccountHolderCompanyInfo";
  /** Acquisition Channel to specify how the user joined, such as "InboundOrganic", "OutboundSales", etc. */
  acquisitionChannel?: Maybe<AcquisitionChannel>;
  /** Business activity. */
  businessActivity: BusinessActivity;
  /**
   * Business activity description.
   * This must be 1024 characters long maximum.
   */
  businessActivityDescription: Scalars["String"]["output"];
  /** Registration date of the company. */
  companyRegistrationDate?: Maybe<Scalars["Date"]["output"]>;
  /** Legal form of the company (SAS, SCI, SASU, ...). */
  companyType?: Maybe<CompanyType>;
  /**
   * The ultimate beneficiary is defined as the natural person (s) who own or control, directly or indirectly, the reporting company.
   *
   * The ultimate beneficiary is :
   * - either the natural person (s) who hold, directly or indirectly, more than 25% of the capital or the rights of vote of the reporting company;
   * - either the natural person (s) who exercise, by other means, a power of control of the company;
   */
  individualUltimateBeneficialOwners: Array<IndividualUltimateBeneficialOwner>;
  /** Legal representative personal address */
  legalRepresentativePersonalAddress?: Maybe<AddressInformation>;
  /** Estimated monthly payment volume (euro). */
  monthlyPaymentVolume: MonthlyPaymentVolume;
  /** Name of the company. */
  name: Scalars["String"]["output"];
  /**
   * Registration number of the company (for example, Système d'Identification du Répertoire des ENtreprises [SIREN] in France, ...).
   * - Length must be from 0 to 50 characters.
   */
  registrationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Returns the list of representatives of a company. */
  representatives: Array<Representative>;
  /** Tax Identification Number */
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Trade name of the company */
  tradeName?: Maybe<Scalars["String"]["output"]>;
  /** Account holder type (always Company for type AccountHolderCompanyInfo) */
  type: AccountHolderType;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT */
  vatNumber?: Maybe<Scalars["String"]["output"]>;
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([(Learn More)](https://docs.swan.io/developers/using-api/pagination/)) */
export type AccountHolderConnection = Connection & {
  __typename: "AccountHolderConnection";
  /** AccountHolderEdge list. */
  edges: Array<AccountHolderEdge>;
  /** Information about the current, the previous and the next page. */
  pageInfo: PageInfo;
  /** Total number of element in the list. */
  totalCount: Scalars["Int"]["output"];
};

export type AccountHolderDueDiligenceLevel = "Common" | "Enhanced" | "Refused" | "Simplified";

/** Implements the Relay Edge interface. */
export type AccountHolderEdge = Edge & {
  __typename: "AccountHolderEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism. */
  cursor: Scalars["String"]["output"];
  /** The account holder. */
  node: AccountHolder;
};

/** Account Holder Enabled Status Information */
export type AccountHolderEnabledStatusInfo = AccountHolderStatusInfo & {
  __typename: "AccountHolderEnabledStatusInfo";
  /** Status of the account holder. */
  status: AccountHolderStatus;
};

/** Filters that can be applied when listing account holders */
export type AccountHolderFilterInput = {
  /** Filter by birth date */
  birthDate?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search by first name
   *
   * @deprecated(reason: "use `search` instead")
   */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search by last name
   *
   * @deprecated(reason: "use `search` instead")
   */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Filter by registration number of the company
   * (for example, Système d'Identification du Répertoire des ENtreprises [SIREN] in France, ...).
   *
   * - Length must be from 0 to 50 characters.
   */
  registrationNumber?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   *  - First name
   *  - Last name
   *  - Company name
   *  - ID
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by status */
  status?: InputMaybe<Array<AccountHolderStatus>>;
  /** Filter by type */
  types?: InputMaybe<Array<AccountHolderType>>;
  /** Filter by verification status */
  verificationStatus?: InputMaybe<Array<VerificationStatus>>;
};

/** Individual account holder. */
export type AccountHolderIndividualInfo = AccountHolderInfo & {
  __typename: "AccountHolderIndividualInfo";
  /** Acquisition Channel to specify how the user joined, such as "InboundOrganic", "OutboundSales", etc. */
  acquisitionChannel?: Maybe<AcquisitionChannel>;
  /** Employment status of the account holder (regulatory questions). */
  employmentStatus: EmploymentStatus;
  /** Monthly income of the account holder (regulatory questions). */
  monthlyIncome: MonthlyIncome;
  /** Account Holder's first name and last name. */
  name: Scalars["String"]["output"];
  /** Tax Identification Number */
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Account holder type (always Individual for type AccountHolderIndividualInfo). */
  type: AccountHolderType;
  /** User of the individual account holder. */
  user: User;
};

/** Account holder types. */
export type AccountHolderInfo = {
  /** Account holder name */
  name: Scalars["String"]["output"];
  /** Account holder type */
  type: AccountHolderType;
};

/** Rejection returned when the Account Holder was not found */
export type AccountHolderNotFoundRejection = Rejection & {
  __typename: "AccountHolderNotFoundRejection";
  message: Scalars["String"]["output"];
};

export type AccountHolderNotStartedVerificationStatusInfo = AccountHolderVerificationStatusInfo & {
  __typename: "AccountHolderNotStartedVerificationStatusInfo";
  /** Verification Status of the account holder. */
  status: VerificationStatus;
};

/** Field we can use when ordering that can be applied when listing account holders */
export type AccountHolderOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing account holders */
export type AccountHolderOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<AccountHolderOrderByFieldInput>;
};

export type AccountHolderPendingVerificationStatusInfo = AccountHolderVerificationStatusInfo & {
  __typename: "AccountHolderPendingVerificationStatusInfo";
  /** ISO Date string at which the account holder status was set to Pending */
  pendingAt: Scalars["DateTime"]["output"];
  /** Verification Status of the account holder. */
  status: VerificationStatus;
};

export type AccountHolderRefusedVerificationStatusInfo = AccountHolderVerificationStatusInfo & {
  __typename: "AccountHolderRefusedVerificationStatusInfo";
  /** Reason for which the account holder was refused */
  reason: Scalars["String"]["output"];
  /** ISO Date string at which the account holder status was set to Refused */
  refusedAt: Scalars["DateTime"]["output"];
  /** Verification Status of the account holder. */
  status: VerificationStatus;
};

export type AccountHolderRiskInfo = {
  __typename: "AccountHolderRiskInfo";
  amlRiskLevel?: Maybe<AmlRiskLevel>;
  amlScore?: Maybe<Scalars["Int"]["output"]>;
  dueDiligenceLevel?: Maybe<AccountHolderDueDiligenceLevel>;
};

/** Account holder status. */
export type AccountHolderStatus =
  /** When the account holder is canceled. */
  | "Canceled"
  /** When the account holder is enabled. */
  | "Enabled"
  /** When the account holder is suspended. */
  | "Suspended";

/** Account Holder Status Information */
export type AccountHolderStatusInfo = {
  /** Status of the account holder. */
  status: AccountHolderStatus;
};

/** Account Holder Suspended Status Information */
export type AccountHolderSuspendedStatusInfo = AccountHolderStatusInfo & {
  __typename: "AccountHolderSuspendedStatusInfo";
  /** Reason why the account holder is suspended. */
  reason: Scalars["String"]["output"];
  /** Status of the account holder. */
  status: AccountHolderStatus;
};

/** Account holder type */
export type AccountHolderType =
  /** Company (Legal person) */
  | "Company"
  /** Individual (Natural person) */
  | "Individual";

/** Account Holder Verification Status Information */
export type AccountHolderVerificationStatusInfo = {
  /** Verification Status of the account holder. */
  status: VerificationStatus;
};

export type AccountHolderVerifiedVerificationStatusInfo = AccountHolderVerificationStatusInfo & {
  __typename: "AccountHolderVerifiedVerificationStatusInfo";
  /** Verification Status of the account holder. */
  status: VerificationStatus;
  /** ISO Date string at which the account holder status was set to Verified */
  verifiedAt: Scalars["DateTime"]["output"];
};

export type AccountHolderWaitingForInformationVerificationStatusInfo =
  AccountHolderVerificationStatusInfo & {
    __typename: "AccountHolderWaitingForInformationVerificationStatusInfo";
    /**
     * @deprecated(reason: "Use `waitingForInformationAt` instead")
     * @deprecated Use `waitingForInformationAt` instead
     */
    WaitingForInformationAt: Scalars["DateTime"]["output"];
    accountHolderId: Scalars["String"]["output"];
    /** Verification Status of the account holder. */
    status: VerificationStatus;
    verificationRequirements: Array<VerificationRequirement>;
    /** ISO Date string at which the account holder status was set to WaitingForInformation */
    waitingForInformationAt: Scalars["DateTime"]["output"];
  };

/** Language: ISO 639-1 language code */
export type AccountLanguage = "de" | "en" | "es" | "fi" | "fr" | "it" | "nl" | "pt";

/**
 * An account membership represents the rights of a user for a given account.
 *
 * *Each account is administered by an account membership having the capacity of legal representative. He has the possibility of delegating rights on this account to other users.*
 */
export type AccountMembership = {
  __typename: "AccountMembership";
  /** List of accepted identification level */
  acceptedIdentificationLevels: Array<Maybe<IdentificationLevel>>;
  /** account of the account membership */
  account?: Maybe<Account>;
  /** Unique identifier of the account of the account membership */
  accountId: Scalars["ID"]["output"];
  /** `true` if this account membership can initiate credit transfers */
  canInitiatePayments: Scalars["Boolean"]["output"];
  /** `true` if this account membership can invite, update, suspend or resume memberships */
  canManageAccountMembership: Scalars["Boolean"]["output"];
  /** `true` if this account membership can add or canceled beneficiaries */
  canManageBeneficiaries: Scalars["Boolean"]["output"];
  /** `true` if this account membership can manage cards for himself or to the memberships he manages */
  canManageCards: Scalars["Boolean"]["output"];
  /** `true` if this account membership can view account balances and transactions history */
  canViewAccount: Scalars["Boolean"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Disabled date */
  disabledAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** email */
  email: Scalars["String"]["output"];
  /** Indicate if the identity bound to the account membership has required identification level */
  hasRequiredIdentificationLevel?: Maybe<Scalars["Boolean"]["output"]>;
  /** Unique identifier of an account membership */
  id: Scalars["ID"]["output"];
  /** Language of the account membership */
  language?: Maybe<AccountLanguage>;
  /** `true` if this account membership having the capacity of the legal representative of the account holder. */
  legalRepresentative: Scalars["Boolean"]["output"];
  /** Residency address of the member */
  residencyAddress?: Maybe<AddressInfo>;
  /** Periodic Spending limit list */
  spendingLimits?: Maybe<Array<SpendingLimit>>;
  /** status of the account membership */
  statusInfo: AccountMembershipStatusInfo;
  /** Tax Identification Number of the member */
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** user of this account membership */
  user?: Maybe<User>;
  /** version of the account membership started from '1' and incremented at every updates */
  version: Scalars["String"]["output"];
};

/** when a user is bound with the error to the account membership */
export type AccountMembershipBindingUserErrorStatusInfo = AccountMembershipStatusInfo & {
  __typename: "AccountMembershipBindingUserErrorStatusInfo";
  /** `true` if the birth date of the bound user doesn't match with the invitation */
  birthDateMatchError: Scalars["Boolean"]["output"];
  /** `true` if the email of the bound user doesn't match with the invitation */
  emailVerifiedMatchError: Scalars["Boolean"]["output"];
  /** `true` if the first name of the bound user doesn't match with the invitation */
  firstNameMatchError: Scalars["Boolean"]["output"];
  /** `true` if Swan hasn't verified the user's identity */
  idVerifiedMatchError: Scalars["Boolean"]["output"];
  /** `true` if the last name of the bound user doesn't match with the invitation */
  lastNameMatchError: Scalars["Boolean"]["output"];
  /** `true` if the phone number of the bound user doesn't match with the invitation */
  phoneNumberMatchError: Scalars["Boolean"]["output"];
  /** restricted to a user */
  restrictedTo: RestrictedTo;
  /** AccountMembership status (always BindingUserError for type AccountMembershipBindingUserErrorStatusInfo) */
  status: AccountMembershipStatus;
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type AccountMembershipConnection = Connection & {
  __typename: "AccountMembershipConnection";
  /** AccountMembershipEdge list */
  edges: Array<AccountMembershipEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** when the user has to consent to invite a new account membership */
export type AccountMembershipConsentPendingStatusInfo = AccountMembershipStatusInfo & {
  __typename: "AccountMembershipConsentPendingStatusInfo";
  /** The consent required to invite this account membership */
  consent: Consent;
  /** restricted to a user */
  restrictedTo: RestrictedTo;
  /** AccountMembership status (always ConsentPending for type AccountMembershipConsentPendingStatusInfo) */
  status: AccountMembershipStatus;
};

/** when the account membership is disabled */
export type AccountMembershipDisabledStatusInfo = AccountMembershipStatusInfo & {
  __typename: "AccountMembershipDisabledStatusInfo";
  /** reason why the account membership is disabled */
  reason: Scalars["String"]["output"];
  /** AccountMembership status (always Disabled for type AccountMembershipDisabledStatusInfo) */
  status: AccountMembershipStatus;
};

/** Implements the Relay Edge interface */
export type AccountMembershipEdge = Edge & {
  __typename: "AccountMembershipEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The account membership */
  node: AccountMembership;
};

/** when the account membership is enabled */
export type AccountMembershipEnabledStatusInfo = AccountMembershipStatusInfo & {
  __typename: "AccountMembershipEnabledStatusInfo";
  /** AccountMembership status (always Enabled for type AccountMembershipEnabledStatusInfo) */
  status: AccountMembershipStatus;
};

/** when a new account membership is invited and there is no user bound yet */
export type AccountMembershipInvitationSentStatusInfo = AccountMembershipStatusInfo & {
  __typename: "AccountMembershipInvitationSentStatusInfo";
  /** restricted to a user */
  restrictedTo: RestrictedTo;
  /** AccountMembership status (always InvitationSent for type AccountMembershipInvitationSentStatusInfo) */
  status: AccountMembershipStatus;
};

/** Field we can use when ordering that can be applied when listing account memberships */
export type AccountMembershipOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing account memberships */
export type AccountMembershipOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<AccountMembershipOrderByFieldInput>;
};

/** AccountMembership enabled */
export type AccountMembershipStatus =
  /** when the user bound with errors to the account membership */
  | "BindingUserError"
  /** when the consent to invite the account membership is pending */
  | "ConsentPending"
  /** when the account membership is disabled */
  | "Disabled"
  /** when the account membership is enabled */
  | "Enabled"
  /** when the account membership is invited */
  | "InvitationSent"
  /** when the account membership is suspended */
  | "Suspended";

/** here are the different account membership status: */
export type AccountMembershipStatusInfo = {
  /** AccountMembership status */
  status: AccountMembershipStatus;
};

/** when the account membership is suspended */
export type AccountMembershipSuspendedStatusInfo = AccountMembershipStatusInfo & {
  __typename: "AccountMembershipSuspendedStatusInfo";
  /** reason why the account membership is suspended */
  reason: Scalars["String"]["output"];
  /** AccountMembership status (always Suspended for type AccountMembershipSuspendedStatusInfo) */
  status: AccountMembershipStatus;
};

/** Filters that can be applied when listing account memberships */
export type AccountMembershipsFilterInput = {
  /** Filter by account */
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Can the user initiate payments on this account */
  canInitiatePayments?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Can the user manage account membership */
  canManageAccountMembership?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Can the user manage beneficiaries */
  canManageBeneficiaries?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** `true` if this account membership can manage cards for himself or to the memberships he manages */
  canManageCards?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Can the user view account */
  canViewAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by email */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search by first name
   *
   * @deprecated(reason: "use `search` instead")
   */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search by last name
   *
   * @deprecated(reason: "use `search` instead")
   */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   * - First name
   * - Last name
   * - Email
   * - ID
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Account memberships status/statuses we're looking for */
  status?: InputMaybe<Array<AccountMembershipStatus>>;
};

/** Thrown when an related account is not eligible to the feature */
export type AccountNotEligibleRejection = Rejection & {
  __typename: "AccountNotEligibleRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned if the account was not found or if the user does not have the rights to know that the card exists */
export type AccountNotFoundRejection = Rejection & {
  __typename: "AccountNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Account Opened status information */
export type AccountOpenedStatus = AccountStatusInfo & {
  __typename: "AccountOpenedStatus";
  /** Account status (always Opened for type AccountOpenedStatus) */
  status: AccountStatus;
};

/** Fields that can be used when ordering accounts */
export type AccountOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing accounts */
export type AccountOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<AccountOrderByFieldInput>;
};

/** Filter that can be passed to get the received direct debit mandate in a specific data range */
export type AccountReceivedDirectDebitMandateFiltersInput = {
  /** To filter on scheme values */
  scheme?: InputMaybe<Array<ReceivedDirectDebitMandateScheme>>;
  /** To filter on status values */
  status?: InputMaybe<Array<ReceivedDirectDebitMandateStatus>>;
};

/** Field we can use when ordering that can be applied when listing receives direct debit mandate results */
export type AccountReceivedDirectDebitOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing receives direct debit mandate results */
export type AccountReceivedDirectDebitOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<AccountReceivedDirectDebitOrderByFieldInput>;
};

export type AccountSettings = {
  __typename: "AccountSettings";
  /** Wether or not the account is allowed to initiate bulk payment transfers without the beneficiary verification */
  allowBulkCreditTransfersWithoutBeneficiaryVerification?: Maybe<Scalars["Boolean"]["output"]>;
};

export type AccountStatus =
  /** When the account is closed */
  | "Closed"
  /** When the account is currently closing */
  | "Closing"
  /** When the account is opened */
  | "Opened"
  /** When the account is suspended */
  | "Suspended";

export type AccountStatusInfo = {
  /** Account status */
  status: AccountStatus;
};

/** Account Suspended status information */
export type AccountSuspendedStatus = AccountStatusInfo & {
  __typename: "AccountSuspendedStatus";
  /**
   * Reason why the account is suspended
   * @deprecated Use `reasonInfo` instead.
   */
  reason: Scalars["String"]["output"];
  /** Reason why the account is currently suspend */
  reasonInfo: SuspendAccountStatusReason;
  /** Account status (always Suspended for type AccountSuspendedStatus) */
  status: AccountStatus;
};

/** Account Verification */
export type AccountVerification = {
  /** Creation date of the account verification */
  createdAt: Scalars["DateTime"]["output"];
  /** Unique identifier of the Account Verification */
  id: Scalars["ID"]["output"];
  /** Account Verification Status Information */
  statusInfo: AccountVerificationStatusInfo;
  /** Last update date of the account verification */
  updatedAt: Scalars["DateTime"]["output"];
};

/**
 * Rejection returned when the external account has already been rejected.
 *
 * In such a case, contact Swan directly to resolve the situation for this specific account holder.
 */
export type AccountVerificationAlreadyRejectedRejection = Rejection & {
  __typename: "AccountVerificationAlreadyRejectedRejection";
  message: Scalars["String"]["output"];
};

/** Account Verification Status */
export type AccountVerificationStatus =
  /**
   * We could not automatically match the external iban based on last received transfer.
   * Manuel review process is underway
   */
  | "PendingReview"
  /** We are waiting for the end user to send a credit transfer from his external iban to any Swan owned iban */
  | "PendingVerification"
  /** Account verification has been rejected */
  | "Rejected"
  /** Account has been verified */
  | "Verified";

/** Account Verification Status Information */
export type AccountVerificationStatusInfo = {
  /** Account verification status */
  status: AccountVerificationStatus;
};

/** Rejection returned when the Account Verification is not in the expected status */
export type AccountVerificationWrongStatusRejection = Rejection & {
  __typename: "AccountVerificationWrongStatusRejection";
  message: Scalars["String"]["output"];
};

/** Acquisition channel. */
export type AcquisitionChannel =
  | "InboundOrganic"
  | "InboundReferral"
  | "OutboundAccountingFirm"
  | "OutboundSales";

export type ActiveMerchantPaymentLinkStatusInfo = MerchantPaymentLinkStatusInfo & {
  __typename: "ActiveMerchantPaymentLinkStatusInfo";
  /**
   * The date when the payment link expires.
   * By default the payment link expires 120 days after it was created.
   */
  expiresAt: Scalars["DateTime"]["output"];
  status: MerchantPaymentLinkStatus;
};

export type AdditionalInformation = DefaultAdditionalInformation | OtherAdditionalInformation;

export type AdditionalInformationInput = {
  defaultInformation?: InputMaybe<DefaultAdditionalInformationInput>;
  otherInformation?: InputMaybe<OtherAdditionalInformationInput>;
};

export type AdditionalInformationRequirements = {
  __typename: "AdditionalInformationRequirements";
  additionalInformation: Array<AdditionalInformationType>;
};

export type AdditionalInformationType =
  | "NumberOfEmployees"
  | "NumberOfOwners"
  | "NumberOfProperties";

/** Address Information */
export type Address = {
  __typename: "Address";
  /** address line 1 */
  addressLine1?: Maybe<Scalars["String"]["output"]>;
  /** addressLine2 */
  addressLine2?: Maybe<Scalars["String"]["output"]>;
  /** city */
  city?: Maybe<Scalars["String"]["output"]>;
  /** country */
  country?: Maybe<Scalars["CCA3"]["output"]>;
  /** postal code (max 10 characters) */
  postalCode?: Maybe<Scalars["String"]["output"]>;
  /** state */
  state?: Maybe<Scalars["String"]["output"]>;
};

/** Address information. */
export type AddressInfo = {
  __typename: "AddressInfo";
  /** Address line 1. */
  addressLine1?: Maybe<Scalars["String"]["output"]>;
  /** Address line 2. */
  addressLine2?: Maybe<Scalars["String"]["output"]>;
  /** City. */
  city?: Maybe<Scalars["String"]["output"]>;
  /** Country. */
  country?: Maybe<Scalars["CCA3"]["output"]>;
  /** Postal code. */
  postalCode?: Maybe<Scalars["String"]["output"]>;
  /** State. */
  state?: Maybe<Scalars["String"]["output"]>;
};

/** Address */
export type AddressInformation = {
  __typename: "AddressInformation";
  /** Address */
  addressLine1: Scalars["String"]["output"];
  /** Address */
  addressLine2?: Maybe<Scalars["String"]["output"]>;
  /** City */
  city: Scalars["String"]["output"];
  /** Country */
  country: Scalars["CCA3"]["output"];
  /** Postal code */
  postalCode: Scalars["String"]["output"];
  /** State */
  state?: Maybe<Scalars["String"]["output"]>;
};

/** Address */
export type AddressInformationInput = {
  /** Address */
  addressLine1?: InputMaybe<Scalars["String"]["input"]>;
  /** Address */
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  /** City */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** Country */
  country: Scalars["CCA3"]["input"];
  /** Postal code */
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** State */
  state?: InputMaybe<Scalars["String"]["input"]>;
};

/** Address Information */
export type AddressInput = {
  /** address line 1 (max 100 characters) */
  addressLine1?: InputMaybe<Scalars["String"]["input"]>;
  /** address line 2 (max 100 characters) */
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  /** city (max 100 characters) */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** country code */
  country: Scalars["CCA3"]["input"];
  /** postal code (max 10 characters) */
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** state (max 100 characters) */
  state?: InputMaybe<Scalars["String"]["input"]>;
};

export type AllowedValue = {
  __typename: "AllowedValue";
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type AmlRiskLevel = "High" | "Low" | "Medium" | "TooHigh";

/** Amount with its currency */
export type Amount = {
  __typename: "Amount";
  /** currency */
  currency: Scalars["Currency"]["output"];
  /** value of the amount */
  value: Scalars["AmountValue"]["output"];
};

/** Amount with its currency */
export type AmountInput = {
  /** currency */
  currency: Scalars["Currency"]["input"];
  /** value of the amount */
  value: Scalars["AmountValue"]["input"];
};

export type AmountWithCurrency = {
  __typename: "AmountWithCurrency";
  currency: Scalars["Currency"]["output"];
  value: Scalars["AmountValue"]["output"];
};

/** Approved Funding Limit */
export type ApprovedFundingLimit = {
  __typename: "ApprovedFundingLimit";
  /** Requested amount settings for the funding limit */
  fundingLimit: FundingLimitAmount;
  /** Requested amount settings for the instant funding limit */
  instantFundingLimit: FundingLimitAmount;
};

/** A method used to authenticate a user */
export type Authenticator = {
  __typename: "Authenticator";
  /** Accept-Language header used during registration */
  acceptLanguage?: Maybe<Scalars["String"]["output"]>;
  /** Device Brand parsed from the user agent (eg: Acer, Alcatel, Amazon, Apple, ...) */
  brand?: Maybe<Scalars["String"]["output"]>;
  /** Device Model parsed from the user agent */
  model?: Maybe<Scalars["String"]["output"]>;
  /** Operating System parsed from the user agent (eg AIX, Amiga OS, Android, Arch, Bada, BeOS, BlackBerry, ...) */
  os?: Maybe<Scalars["String"]["output"]>;
  /**
   * The phone number used for the creation of the authenticator
   * @deprecated Field no longer supported
   */
  otpPhoneNumber?: Maybe<Scalars["String"]["output"]>;
  status: AuthenticatorStatus;
  /** Type of authenticator */
  type: AuthenticatorType;
  /** Raw user agent */
  userAgent?: Maybe<Scalars["String"]["output"]>;
};

export type AuthenticatorStatus =
  /**
   * The authenticator was canceled because the user disconnected
   * or they created a new authenticator - this status is final
   */
  | "Canceled"
  /** The authenticator can be used eg. to sign requests or call our apis */
  | "Enabled"
  /** The authenticator was suspended - this status is final */
  | "Suspended"
  /** This authenticator is not verified and the user hasn't validated any authentication factor. */
  | "WaitingForAuthentication"
  /**
   * The user must go through customer support for verification (reinit)
   * Once verified, the status will switch to Enabled
   */
  | "WaitingForCustomerSupportVerification"
  /**
   * The user must send their basic personal info (firstname, name, birthdate)
   * before the status can switch to Enabled
   */
  | "WaitingForUserInfo"
  /**
   * The user must go through the verification (reinit) process
   * Once verified, the status will switch to Enabled
   */
  | "WaitingForVerification";

export type AuthenticatorType =
  /** Deprecated: swan authenticator */
  | "Swan"
  /** A Swan web authenticator */
  | "SwanWeb";

/** Rejection returned if the status account is not valid */
export type BadAccountStatusRejection = Rejection & {
  __typename: "BadAccountStatusRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection when an inputs contains an error */
export type BadRequestRejection = Rejection & {
  __typename: "BadRequestRejection";
  message: Scalars["String"]["output"];
};

/** Basic Physical Card Info */
export type BasicPhysicalCardInfo = {
  __typename: "BasicPhysicalCardInfo";
  /** Masked Card Number */
  cardMaskedNumber: Scalars["String"]["output"];
  /** Custom Options */
  customOptions: PhysicalCardCustomOptions;
  /** Physical Card expiration date  with MM/YY string format */
  expiryDate?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier present on physical card */
  identifier?: Maybe<Scalars["String"]["output"]>;
  /** `true` if physical card is expired */
  isExpired: Scalars["Boolean"]["output"];
  /** Offline Spending limit defined by Swan */
  offlineSpendingLimit: Amount;
};

export type Branding = {
  __typename: "Branding";
  accentColor?: Maybe<Scalars["String"]["output"]>;
  customConsentSubdomain?: Maybe<Scalars["String"]["output"]>;
  logoUri?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  projectId?: Maybe<Scalars["String"]["output"]>;
};

export type BrowserConsent = DetailedConsent & {
  __typename: "BrowserConsent";
  acceptedAt?: Maybe<Scalars["DateTime"]["output"]>;
  accountId?: Maybe<Scalars["String"]["output"]>;
  allowsServerConsent: Scalars["Boolean"]["output"];
  branding: Branding;
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  challenge?: Maybe<Scalars["String"]["output"]>;
  channelName?: Maybe<Scalars["String"]["output"]>;
  consentOperations: Array<ConsentOperation>;
  consentResponses: Array<ConsentResponse>;
  consentUrl: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  env: EnvType;
  expiredAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  identityId: Scalars["String"]["output"];
  operationsSHA256HexDigest?: Maybe<Scalars["String"]["output"]>;
  projectId?: Maybe<Scalars["String"]["output"]>;
  purpose: DetailedConsentPurpose;
  redirectUrl: Scalars["String"]["output"];
  refusedAt?: Maybe<Scalars["DateTime"]["output"]>;
  requireSCA: Scalars["Boolean"]["output"];
  serviceToHook: Scalars["String"]["output"];
  startedAt?: Maybe<Scalars["DateTime"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  status: ConsentStatus;
  updatedAt: Scalars["DateTime"]["output"];
  userId?: Maybe<Scalars["String"]["output"]>;
};

export type BrowserMultiConsent = DetailedConsent & {
  __typename: "BrowserMultiConsent";
  acceptedAt?: Maybe<Scalars["DateTime"]["output"]>;
  accountId?: Maybe<Scalars["String"]["output"]>;
  aggregatedPurposesWithOperations: Array<PurposeWithOperations>;
  allowsServerConsent: Scalars["Boolean"]["output"];
  branding: Branding;
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  challenge?: Maybe<Scalars["String"]["output"]>;
  channelName?: Maybe<Scalars["String"]["output"]>;
  consentOperations: Array<ConsentOperation>;
  consentResponses: Array<ConsentResponse>;
  consentUrl: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  env: EnvType;
  expiredAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  identityId: Scalars["String"]["output"];
  operationsSHA256HexDigest?: Maybe<Scalars["String"]["output"]>;
  projectId?: Maybe<Scalars["String"]["output"]>;
  purpose: DetailedConsentPurpose;
  redirectUrl: Scalars["String"]["output"];
  refusedAt?: Maybe<Scalars["DateTime"]["output"]>;
  requireSCA: Scalars["Boolean"]["output"];
  startedAt?: Maybe<Scalars["DateTime"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  status: ConsentStatus;
  updatedAt: Scalars["DateTime"]["output"];
  userId?: Maybe<Scalars["String"]["output"]>;
};

/** Business activity. */
export type BusinessActivity =
  | "AdministrativeServices"
  | "Agriculture"
  | "Arts"
  | "BusinessAndRetail"
  | "Construction"
  | "Education"
  | "ElectricalDistributionAndWaterSupply"
  | "FinancialAndInsuranceOperations"
  | "Health"
  | "Housekeeping"
  | "InformationAndCommunication"
  | "LodgingAndFoodServices"
  | "ManufacturingAndMining"
  | "Other"
  | "PublicAdministration"
  | "RealEstate"
  | "ScientificActivities"
  | "Transportation";

/** Describes an identification level for the process associated to this identification that has been cancelled by the end-user */
export type CanceledIdentificationLevelStatusInfo = {
  __typename: "CanceledIdentificationLevelStatusInfo";
  /** Always set to `Cancelled` */
  status: SwanIdentificationStatus;
};

/** Capital deposit case for a company. */
export type CapitalDepositCase = {
  __typename: "CapitalDepositCase";
  /** Unique identifier of the company account. */
  companyAccountId?: Maybe<Scalars["String"]["output"]>;
  /** Name of the company. */
  companyName: Scalars["String"]["output"];
  /** Onboarding information of the company. */
  companyOnboarding?: Maybe<Onboarding>;
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Documents to provide to fulfill the capital deposit case. */
  documents: Array<CapitalDepositDocument>;
  /** Unique identifier of a capital deposit case. */
  id: Scalars["String"]["output"];
  /** List of the company’s shareholders. */
  shareholders: Array<Shareholder>;
  /**
   * Status of the capital deposit case.
   * @deprecated(reason: "use `statusInfo` instead")
   * @deprecated use `statusInfo` instead
   */
  status: CapitalDepositCaseStatus;
  /** Capital deposit case status information. */
  statusInfo: CapitalDepositCaseStatusInfo;
  /** Amount of the capital deposit. */
  totalCapitalDepositAmount: Amount;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Rejection returned if the capital deposit case cannot be canceled in its current state */
export type CapitalDepositCaseCanNotBeCanceledRejection = Rejection & {
  __typename: "CapitalDepositCaseCanNotBeCanceledRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection returned if the capital deposit case cannot be found */
export type CapitalDepositCaseCanNotBeFoundRejection = Rejection & {
  __typename: "CapitalDepositCaseCanNotBeFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type CapitalDepositCaseCanceledStatusInfo = CapitalDepositCaseStatusInfo & {
  __typename: "CapitalDepositCaseCanceledStatusInfo";
  /** Canceled */
  status: CapitalDepositStatus;
};

/** Rejection returned if the capital deposit case's company cannot be updated */
export type CapitalDepositCaseCompanyCannotBeUpdatedRejection = Rejection & {
  __typename: "CapitalDepositCaseCompanyCannotBeUpdatedRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type CapitalDepositCaseCompletedStatusInfo = CapitalDepositCaseStatusInfo & {
  __typename: "CapitalDepositCaseCompletedStatusInfo";
  /** Completed */
  status: CapitalDepositStatus;
};

/** Implements the Relay Connection interface, used to paginate list of elements ([Learn More](https://docs.swan.io/api/pagination)) */
export type CapitalDepositCaseConnection = Connection & {
  __typename: "CapitalDepositCaseConnection";
  /** CapitalDepositCaseEdge list */
  edges: Array<CapitalDepositCaseEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of elements in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type CapitalDepositCaseEdge = Edge & {
  __typename: "CapitalDepositCaseEdge";
  /** Opaque identifier pointing to this capital deposit case node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The CapitalDepositCase */
  node: CapitalDepositCase;
};

/** Filters that can be applied when listing capital deposit cases */
export type CapitalDepositCaseFiltersInput = {
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   *  - Company shareholder's name
   *  - Individual shareholder's first name
   *  - Individual shareholder's last name
   *  - Company name
   *  - ID
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by statuses */
  statuses?: InputMaybe<Array<CapitalDepositStatus>>;
};

/** Field we can use when ordering that can be applied when listing capital deposit cases */
export type CapitalDepositCaseOrderByFieldInput = "createdAt" | "id" | "updatedAt";

/** Order that can be applied when listing capital deposit cases */
export type CapitalDepositCaseOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<CapitalDepositCaseOrderByFieldInput>;
};

export type CapitalDepositCasePendingInternalReviewStatusInfo = CapitalDepositCaseStatusInfo & {
  __typename: "CapitalDepositCasePendingInternalReviewStatusInfo";
  /** PendingInternalReview */
  status: CapitalDepositStatus;
};

/**
 * Status of a capital deposit case.
 * @deprecated look for enum `CapitalDepositStatus` instead.
 */
export type CapitalDepositCaseStatus =
  /** The capital deposit case is canceled. */
  | "Canceled"
  /** The capital deposit case is completed. */
  | "Completed"
  /** Technical state when the mutation to create a new capital deposit case is called. */
  | "Initiated"
  /** Swan is waiting for the notary to wire the share capital on the account of the company being registered. */
  | "WaitingForNotaryTransfer"
  /** Swan is waiting for you to provide the Register Extract. */
  | "WaitingForRegisterExtract"
  /** A new capital deposit case is created and Swan is waiting for the required information to be provided and each shareholder to wire their share of share capital. */
  | "WaitingForRequirements"
  /** Swan is waiting for the notary to provide the Share Deposit Certificate. */
  | "WaitingForShareDepositCertificate";

export type CapitalDepositCaseStatusInfo = {
  /** Status of the capital deposit case. */
  status: CapitalDepositStatus;
};

export type CapitalDepositCaseWaitingForAdditionalInformationStatusInfo =
  CapitalDepositCaseStatusInfo & {
    __typename: "CapitalDepositCaseWaitingForAdditionalInformationStatusInfo";
    /** WaitingForAdditionalInformation */
    status: CapitalDepositStatus;
  };

export type CapitalDepositCaseWaitingForInitialRequirementsStatusInfo =
  CapitalDepositCaseStatusInfo & {
    __typename: "CapitalDepositCaseWaitingForInitialRequirementsStatusInfo";
    /** WaitingForInitialRequirements */
    status: CapitalDepositStatus;
  };

export type CapitalDepositCaseWaitingForNotaryShareDepositCertificateStatusInfo =
  CapitalDepositCaseStatusInfo & {
    __typename: "CapitalDepositCaseWaitingForNotaryShareDepositCertificateStatusInfo";
    /** WaitingForNotaryShareDepositCertificate */
    status: CapitalDepositStatus;
  };

export type CapitalDepositCaseWaitingForNotaryTransferStatusInfo = CapitalDepositCaseStatusInfo & {
  __typename: "CapitalDepositCaseWaitingForNotaryTransferStatusInfo";
  /** WaitingForNotaryTransfer */
  status: CapitalDepositStatus;
};

export type CapitalDepositCaseWaitingForRegisterExtractStatusInfo = CapitalDepositCaseStatusInfo & {
  __typename: "CapitalDepositCaseWaitingForRegisterExtractStatusInfo";
  /** WaitingForRegisterExtract */
  status: CapitalDepositStatus;
};

/** Document provided for a capital deposit case. */
export type CapitalDepositDocument = {
  __typename: "CapitalDepositDocument";
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Url to download the document, null if it has not already been uploaded. */
  downloadUrl?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier of a document. */
  id: Scalars["String"]["output"];
  /** Information about capital deposit case. */
  relatedCapitalDepositCase?: Maybe<CapitalDepositCase>;
  /** Information about shareholder. */
  relatedShareholder?: Maybe<Shareholder>;
  /**
   * Status of the document.
   * @deprecated use statusInfo.status
   */
  status: CapitalDepositDocumentStatus;
  /** Status info of the document. */
  statusInfo: CapitalDepositDocumentStatusInfo;
  /** Type of the document. */
  type: CapitalDepositDocumentType;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** Date when the last version of the document has been uploaded. */
  uploadedAt?: Maybe<Scalars["Date"]["output"]>;
};

/**
 * Rejection returned if the document from a capital deposit case cannot be uploaded in its context
 * @deprecated(reason: "use `CapitalDepositDocumentCanNotBeUploadedRejection` instead")
 */
export type CapitalDepositDocumentCanNotBeUploaded = Rejection & {
  __typename: "CapitalDepositDocumentCanNotBeUploaded";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection returned if the document from a capital deposit case cannot be uploaded in its context */
export type CapitalDepositDocumentCanNotBeUploadedRejection = Rejection & {
  __typename: "CapitalDepositDocumentCanNotBeUploadedRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Capital Deposit Document with Pending status */
export type CapitalDepositDocumentPendingStatusInfo = CapitalDepositDocumentStatusInfo & {
  __typename: "CapitalDepositDocumentPendingStatusInfo";
  /** Pending */
  status: CapitalDepositDocumentStatus;
};

/** Capital Deposit Document with Refused status */
export type CapitalDepositDocumentRefusedStatusInfo = CapitalDepositDocumentStatusInfo & {
  __typename: "CapitalDepositDocumentRefusedStatusInfo";
  /** Reason for the rejection. */
  reasonCode: DocumentReasonCode;
  /** Refused */
  status: CapitalDepositDocumentStatus;
};

/** Status of the Capital Deposit Case */
export type CapitalDepositDocumentStatus =
  /** Document is not uploaded yet. */
  | "Pending"
  /** Document has been refused by Swan, it must be uploaded again. */
  | "Refused"
  /** Document has been uploaded but not verified by Swan yet. */
  | "Uploaded"
  /** Document has been uploaded and verified by Swan. */
  | "Validated";

/** Status info of the document. */
export type CapitalDepositDocumentStatusInfo = {
  /** Status of the document. */
  status: CapitalDepositDocumentStatus;
};

/** Type of the document. */
export type CapitalDepositDocumentType =
  /** Legal document required for company’s formation. */
  | "ArticlesOfIncorporation"
  /** Created by the Notary, it certifies the capital of the company to have been deposited with the appropriate share for each shareholder. */
  | "CapitalShareDepositCertificate"
  /** Lease agreement in the name of the business or Proof of Individual Address if the company is hosted by one of the legal representative. */
  | "CompanyLeaseAgreement"
  /** Document submitted to your tax bureau at the end of the last business period. */
  | "CorporateIncomeTaxReturn"
  /** Signed power of attorney document to give the power to act on behalf. */
  | "PowerOfAttorney"
  /** Can be either passport, national id card or resident permit. */
  | "ProofOfIdentity"
  /** Can be a utility bill (water, electricity or gas), a telephone bill or a rental receipt. The document must have been issued within the last 3 months. */
  | "ProofOfIndividualAddress"
  /** Commercial registry extract issued within the last 3 months. */
  | "RegisterExtract";

/** Capital Deposit Document with Uploaded status */
export type CapitalDepositDocumentUploadedStatusInfo = CapitalDepositDocumentStatusInfo & {
  __typename: "CapitalDepositDocumentUploadedStatusInfo";
  /** Uploaded */
  status: CapitalDepositDocumentStatus;
};

/** Capital Deposit Document with Validated status */
export type CapitalDepositDocumentValidatedStatusInfo = CapitalDepositDocumentStatusInfo & {
  __typename: "CapitalDepositDocumentValidatedStatusInfo";
  /** Validated */
  status: CapitalDepositDocumentStatus;
};

/** Status of a capital deposit case. */
export type CapitalDepositStatus =
  /** The case has been canceled upon request. A capital deposit can be canceled at any time before completion by contacting Swan Support. When canceled, the associated shareholder is also canceled. */
  | "Canceled"
  /** The notary has approved all documents and transferred the funds to the newly created company. The capital deposit process is complete. */
  | "Completed"
  /** Swan is reviewing the information and documents provided. */
  | "PendingInternalReview"
  /** After review, Swan has requested additional details or corrections from the customer and is awaiting their response. */
  | "WaitingForAdditionalInformation"
  /** The case has been initiated and is waiting for shareholder verification, fund transfers, document uploads, and completion of company onboarding. */
  | "WaitingForInitialRequirements"
  /** The notary is reviewing the deposited funds and documents, then preparing and uploading the share deposit certificate to Swan. */
  | "WaitingForNotaryShareDepositCertificate"
  /** The notary is reviewing the register extract. If the document is rejected by either Swan or the notary, the case will return to WaitingForRegisterExtract. */
  | "WaitingForNotaryTransfer"
  /** The company must upload its register extract for review by the notary. */
  | "WaitingForRegisterExtract";

/** Card authorization operation type */
export type CardAuthorizationOperationType =
  | "AtmWithdrawal"
  | "CashBackPayment"
  | "Credit"
  | "InStoreWithdrawal"
  | "Payment"
  | "QuasiCash"
  | "TokenizationRequest";

export type CardAuthorizationOutcome =
  | "Accepted"
  | "AccountClosed"
  | "AccountSuspended"
  | "AmountInvalid"
  | "AtmWithdrawalAmountLimitExceeded"
  | "AtmWithdrawalNumberLimitExceeded"
  | "CanceledByCardHolder"
  | "CardExpired"
  | "CardHolderVerificationMethodMissing"
  | "CardNotActivated"
  | "CardNumberInvalid"
  | "CardOutOfOrder"
  | "CardPermanentlyBlocked"
  | "CardSuspended"
  | "CardUnknown"
  | "ChipCryptogramControlRefusal"
  | "ContactlessAmountLimitExceeded"
  | "ContactlessCumulativeAmountLimitExceeded"
  | "DigitalCardDeactivated"
  | "DigitalCardEnrollmentInvalid"
  | "DigitalCardRefusal"
  | "DigitalCardSuspended"
  | "DigitalCardTokenInvalid"
  | "DoNotHonor"
  | "DomesticTransactionNotAllowed"
  | "FraudRossAndersonRefusal"
  | "InPersonTransactionsNotAuthorized"
  | "InconsistentEmvAmount"
  | "InvalidAuthorizationResponse"
  | "InvalidExpirationDate"
  | "InvalidPinAttemptsExceeded"
  | "InvalidSecurityNumber"
  | "MagstripeNotSupported"
  | "MerchantNotFound"
  | "MerchantShouldResubmitAuthorization"
  | "MiscellaneousReason"
  | "MissingExpirationDate"
  | "PartialApproval"
  | "PartialCancelation"
  | "PinInvalid"
  | "PinRequired"
  | "SchemeAccountConversionError"
  | "SchemeStandInRefusal"
  | "SchemeTransactionBlockingRefusal"
  | "SecurityViolation"
  | "SoftDecline"
  | "SwanTechnicalErrorOccurred"
  | "SwanTimeout"
  | "TerminalVerificationResultsInvalid"
  | "ThreeDsError"
  | "TransactionAmountLimitExceeded"
  | "TransactionCurrencyIncorrect"
  | "TransactionDuplicated"
  | "TransactionInvalid"
  | "TransactionNotAllowed"
  | "TransactionNotAuthorizedForCardHolder"
  | "UnableToDetectTransactionEnvironment";

export type CardAuthorizationReleaseReason =
  /** Authorization expired */
  | "Expired"
  /** Authorization manually released by Swan */
  | "ManuallyReleased"
  /** Authorization released by the merchant */
  | "MerchantReleased";

export type CardAuthorizationType = "Classic" | "DataRequest" | "PreAuthorization";

export type CardMerchantPayment = MerchantPayment & {
  __typename: "CardMerchantPayment";
  /** amount */
  amount: Amount;
  /**
   * Authorized date
   * @deprecated use authorizedAt in statusInfo instead
   */
  authorizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  balance: MerchantBalance;
  /** The billing address associated to the payment */
  billingAddress?: Maybe<Address>;
  /**
   * Canceled date
   * @deprecated use canceledAt in statusInfo instead
   */
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Captured date
   * @deprecated use capturedAt in statusInfo instead
   */
  capturedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Created date
   * @deprecated use createdAt in statusInfo instead
   */
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Disputed date
   * @deprecated use disputedAt in statusInfo instead
   */
  disputedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** an arbitrary identifier that was defined by you when you created this payment */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of a merchant payment */
  id: Scalars["ID"]["output"];
  /** Label */
  label?: Maybe<Scalars["String"]["output"]>;
  /** merchant profile associated to the merchant payment */
  merchantProfile: MerchantProfile;
  /** payment link associated to the merchant payment */
  paymentLink?: Maybe<MerchantPaymentLink>;
  /** payment link associated to the merchant payment */
  paymentMandate: PaymentMandate;
  /** payment method associated to the merchant payment */
  paymentMethod: MerchantPaymentMethod;
  reference?: Maybe<Scalars["String"]["output"]>;
  /**
   * Refunded date
   * @deprecated use refundedAt in statusInfo instead
   */
  refundedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Rejected date
   * @deprecated use rejectedAt in statusInfo instead
   */
  rejectedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** status information */
  statusInfo: MerchantPaymentStatusInfo;
  threeDs?: Maybe<ThreeDs>;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** COMING SOON */
export type CardMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "CardMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** The Merchant Payment Method payment amount limit */
  paymentAmountLimit?: Maybe<Amount>;
  /**
   * Reason of rejection when the status is Rejected
   * @deprecated Use statusInfo.rejectionReason instead
   */
  rejectReason?: Maybe<MerchantPaymentMethodCardRejectReason>;
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

/** Rejection returned if the card was not found or if the user does not have the rights to know that the account exists */
export type CardNotFoundRejection = Rejection & {
  __typename: "CardNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type CardPaymentMandate = PaymentMandate & {
  __typename: "CardPaymentMandate";
  /** Account Holder information */
  accountHolder: AccountHolder;
  /** The card associated to this mandate */
  card: ExternalCard;
  /** Creation date of the Payment Mandate */
  createdAt: Scalars["DateTime"]["output"];
  /** Date of the the last transaction executed for the concerned Payment Mandate */
  executedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Expiry date of the Payment Mandate */
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  /** Unique identifier of the Payment Mandate */
  id: Scalars["ID"]["output"];
  /** Custom name of the mandate */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Payment Mandate status information */
  statusInfo: PaymentMandateStatusInfo;
  /** Last Update date of the Payment Mandate */
  updatedAt: Scalars["DateTime"]["output"];
};

export type CardPaymentMandateCategory = "Commercial" | "Consumer";

export type CardPaymentMandateScheme =
  | "AmericanExpress"
  | "CartesBancaires"
  | "Mastercard"
  | "Other"
  | "Visa";

export type CardPaymentMandateType = "Charge" | "Credit" | "Debit" | "Deferred" | "Prepaid";

export type CardTransactionCategory =
  | "InStore"
  | "Other"
  | "Withdrawal"
  | "eCommerce"
  | "eCommerceWith3DS";

/** Type of card */
export type CardType = "Physical" | "Virtual";

/** Cash account type (Always Current) */
export type CashAccountType =
  | "CashIncome"
  | "CashPayment"
  | "CashTrading"
  | "Charges"
  | "ClearingParticipantSettlementAccount"
  | "Commission"
  /** When the account is a current account. */
  | "Current"
  | "LimitedLiquiditySavingsAccount"
  | "Loan"
  | "MarginalLending"
  | "MoneyMarket"
  | "NonResidentExternal"
  | "OtherAccount"
  | "OverNightDeposit"
  | "Overdraft"
  | "Salary"
  | "Savings"
  | "Settlement"
  | "Tax"
  | "TransactingAccount";

/** Enum CategoryPurpose - Purpose of the payment transaction */
export type CategoryPurpose =
  /** Account Sweep */
  | "AccountSweep"
  /** Account Top-Up */
  | "AccountTopUp"
  /** Bonus Payment */
  | "BonusPayment"
  /** Card Bulk Settlement */
  | "CardBulkSettlement"
  /** Card Fee Collection */
  | "CardFeeCollection"
  /** Cash in Transit Payment */
  | "CashInTransitPayment"
  /** Cash Management */
  | "CashManagement"
  /** Cash Order Direct Debit */
  | "CashOrderDirectDebit"
  /** Commercial Reimbursement */
  | "CommercialReimbursement"
  /** Credit Card Payment */
  | "CreditCardPayment"
  /** Credit Card Reimbursement */
  | "CreditCardReimbursement"
  /** Debit Card Payment */
  | "DebitCardPayment"
  /** Debit Card Reimbursement */
  | "DebitCardReimbursement"
  /** Deliver Against Payment */
  | "DeliverAgainstPayment"
  /** Direct Debit Representment */
  | "DirectDebitRepresentment"
  /** Dividend Payment */
  | "DividendPayment"
  /** Dodd Frank Cross Border */
  | "DoddFrankCrossBorder"
  /** E-Payment */
  | "EPayment"
  /** Fee Interest Payment */
  | "FeeInterestPayment"
  /** Foreign Currency Domestic */
  | "ForeignCurrencyDomestic"
  /** General P2P Payment */
  | "GeneralP2PPayment"
  /** Government Payment */
  | "GovernmentPayment"
  /** Hedging Payment */
  | "HedgingPayment"
  /** Interest Payment */
  | "InterestPayment"
  /** Intra-Company Payment */
  | "IntraCompanyPayment"
  /** Loan Transfer */
  | "LoanTransfer"
  /** Lockbox Cash Handling */
  | "LockboxCashHandling"
  /** Mobile P2B Payment */
  | "MobileP2BPayment"
  /** Mobile P2P Payment */
  | "MobileP2PPayment"
  /** Other */
  | "Other"
  /** Pension Payment */
  | "PensionPayment"
  /** Receive Against Payment */
  | "ReceiveAgainstPayment"
  /** Salary Payment */
  | "SalaryPayment"
  /** Savings Transfer */
  | "SavingsTransfer"
  /** Securities Payment */
  | "SecuritiesPayment"
  /** Social Security Benefit */
  | "SocialSecurityBenefit"
  /** Supplier Payment */
  | "SupplierPayment"
  /** Tax Payment */
  | "TaxPayment"
  /** Trade Finance Payment */
  | "TradeFinancePayment"
  /** Trade Settlement */
  | "TradeSettlement"
  /** Treasury Payment */
  | "TreasuryPayment"
  /** VAT Payment */
  | "VATPayment"
  /** Vostro Payment */
  | "VostroPayment"
  /** Withholding Tax Payment */
  | "WithholdingTaxPayment"
  /** Zero Balance Account */
  | "ZeroBalanceAccount";

export type CheckMerchantPayment = MerchantPayment & {
  __typename: "CheckMerchantPayment";
  /** amount */
  amount: Amount;
  /**
   * Authorized date
   * @deprecated use authorizedAt in statusInfo instead
   */
  authorizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  balance: MerchantBalance;
  /** The billing address associated to the payment */
  billingAddress?: Maybe<Address>;
  /**
   * Canceled date
   * @deprecated use canceledAt in statusInfo instead
   */
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Captured date
   * @deprecated use capturedAt in statusInfo instead
   */
  capturedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Created date
   * @deprecated use createdAt in statusInfo instead
   */
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Disputed date
   * @deprecated use disputedAt in statusInfo instead
   */
  disputedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** an arbitrary identifier that was defined by you when you created this payment */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of a merchant payment */
  id: Scalars["ID"]["output"];
  /** Label */
  label?: Maybe<Scalars["String"]["output"]>;
  /** merchant profile associated to the merchant payment */
  merchantProfile: MerchantProfile;
  /**
   * Not applicable to checks, TO BE REMOVED
   * @deprecated Not applicable to checks
   */
  paymentLink?: Maybe<MerchantPaymentLink>;
  /**
   * Not applicable to checks, TO BE REMOVED
   * @deprecated Not applicable to checks
   */
  paymentMandate: PaymentMandate;
  /** payment method associated to the merchant payment */
  paymentMethod: MerchantPaymentMethod;
  reference?: Maybe<Scalars["String"]["output"]>;
  /**
   * Refunded date
   * @deprecated use refundedAt in statusInfo instead
   */
  refundedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Rejected date
   * @deprecated use rejectedAt in statusInfo instead
   */
  rejectedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** status information */
  statusInfo: MerchantPaymentStatusInfo;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** CheckMerchantPaymentMethod */
export type CheckMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "CheckMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** The Merchant Payment Method payment amount limit */
  paymentAmountLimit?: Maybe<Amount>;
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

/** List of Check return reasons */
export type CheckReturnReasonCodeEnum =
  | "AccountClosed"
  | "CheckBlocked"
  | "CheckOutdated"
  | "DebtorDeceased"
  | "EndorsementMissingOrInvalid"
  | "Fraudulent"
  | "InsufficientFunds"
  | "LegalOrBankDecision"
  | "MandatoryReferenceMissingOnCheck"
  | "SignatureInvalid"
  | "SwanTechnicalErrorOccurred"
  | "TransactionDuplicated";

/** Define a reason with a message and a specific type for closing account action */
export type CloseAccountReason = Reason & {
  __typename: "CloseAccountReason";
  message?: Maybe<Scalars["String"]["output"]>;
  type: CloseAccountReasonType;
};

/** Specific type for closing account action */
export type CloseAccountReasonType =
  /** Capital Deposit Reason */
  | "CapitalDepositReason"
  /** Compliance Reason */
  | "ComplianceReason"
  /** Inactivity */
  | "Inactivity"
  /** Partner Reason */
  | "PartnerReason";

/** Union between PartnerCloseAccountReasonType and InternalCloseAccountReason */
export type CloseAccountStatusReason = CloseAccountReason;

export type CompanyRepresentative = {
  __typename: "CompanyRepresentative";
  /** Legal entity name of the representative (for Company type). */
  entityName?: Maybe<Scalars["String"]["output"]>;
  /** Legal form of the representative's legal entity. */
  legalForm?: Maybe<Scalars["String"]["output"]>;
  /** Registration number of the representative’s legal entity. */
  registrationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Residency address of the representative. */
  residencyAddress?: Maybe<AddressInformation>;
  /** List of representative roles. */
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** Company shareholder info. */
export type CompanyShareholder = {
  __typename: "CompanyShareholder";
  /** Company name. */
  name: Scalars["String"]["output"];
  /** Whether the shareholder is an individual or a company. */
  type: ShareholderType;
};

/** Type of company. */
export type CompanyType =
  | "Association"
  | "Company"
  | "HomeOwnerAssociation"
  | "Other"
  | "SelfEmployed";

/** Complete Address Information */
export type CompleteAddressInput = {
  /** address line 1 (max 38 characters) */
  addressLine1: Scalars["String"]["input"];
  /** address line 2 (max 38 characters) */
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  /** city (max 30 characters) `^\p{L}+(\p{L}|[0-9]|-|'|\s)*(\p{L}|[0-9])+$` */
  city: Scalars["String"]["input"];
  /** country code */
  country: Scalars["CCA3"]["input"];
  /** postal code (max 10 characters) `^[0-9A-Z- ]{1,10}$` */
  postalCode: Scalars["String"]["input"];
  /** state (max 30 characters) `^\p{L}+(\p{L}|-|'|\s)*\p{L}+` */
  state?: InputMaybe<Scalars["String"]["input"]>;
};

/** Complete Address Information with a contact */
export type CompleteAddressWithContactInput = {
  /** address line 1 (max 38 characters) */
  addressLine1: Scalars["String"]["input"];
  /** address line 2 (max 38 characters) */
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  /** city (max 30 characters) `^\p{L}+(\p{L}|[0-9]|-|'|\s)*(\p{L}|[0-9])+$` */
  city: Scalars["String"]["input"];
  /** contact company name (max 38 characters) */
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  /** country code */
  country: Scalars["CCA3"]["input"];
  /** contact first name */
  firstName: Scalars["String"]["input"];
  /** contact last name */
  lastName: Scalars["String"]["input"];
  /** contact phone number */
  phoneNumber: Scalars["PhoneNumber"]["input"];
  /** postal code (max 10 characters) `^[0-9A-Z- ]{1,10}$` */
  postalCode: Scalars["String"]["input"];
  /** state (max 30 characters) `^\p{L}+(\p{L}|-|'|\s)*\p{L}+` */
  state?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompletedMerchantPaymentLinkStatusInfo = MerchantPaymentLinkStatusInfo & {
  __typename: "CompletedMerchantPaymentLinkStatusInfo";
  /** The time when the customer completed the payment. */
  completedAt: Scalars["DateTime"]["output"];
  status: MerchantPaymentLinkStatus;
};

/** Relay Connection type, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type Connection = {
  /** Edge list */
  edges: Array<Edge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Some sensitive operation at Swan, such as initiating a payment, require consent */
export type Consent = {
  __typename: "Consent";
  /** date when the consent is accepted */
  acceptedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** date when the consent is canceled */
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** unique hash of the consent */
  challenge?: Maybe<Scalars["String"]["output"]>;
  /** Redirect the user to this URL to start the consent flow */
  consentUrl: Scalars["String"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** date when the consent expire */
  expiredAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** unique identifier of the consent */
  id: Scalars["ID"]["output"];
  /** purpose of the consent */
  purpose: ConsentPurpose;
  /** When the consent flow is finished the user is redirected to this URL */
  redirectUrl: Scalars["String"]["output"];
  /** date when the consent is refused */
  refusedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** `true` if the consent requires a Strong Customer Authentication */
  requireSCA: Scalars["Boolean"]["output"];
  /** date when the `consentUrl` was request the first time */
  startedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** status of the consent */
  status: ConsentStatus;
  /** updated date */
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** user who initiated the consent */
  user?: Maybe<User>;
  /** userId who initiated the consent */
  userId: Scalars["String"]["output"];
};

/** Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type ConsentConnection = Connection & {
  __typename: "ConsentConnection";
  /** ConsentEdge list */
  edges: Array<ConsentEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type ConsentEdge = Edge & {
  __typename: "ConsentEdge";
  /** Opaque identifier pointing to this consent node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The consent */
  node: Consent;
};

export type ConsentOperation = {
  __typename: "ConsentOperation";
  props?: Maybe<Array<ConsentOperationProperty>>;
};

export type ConsentOperationProperty = {
  __typename: "ConsentOperationProperty";
  name: ConsentOperationPropertyName;
  value: Scalars["String"]["output"];
};

export type ConsentOperationPropertyName =
  | "Account"
  | "AccountFrom"
  | "AccountHolderName"
  | "AccountTo"
  | "AllowedIpAddresses"
  | "Amount"
  | "BeneficiaryName"
  | "BeneficiaryNameSuggestion"
  | "BeneficiaryVerification"
  | "BirthDate"
  | "BookedDate"
  | "CardDesignURL"
  | "CardHolderName"
  | "CardInsuranceSubscriptionNoticeUrl"
  | "CardNumber"
  | "CardOption"
  | "CreditLimitAmount"
  | "CreditorAddress"
  | "CreditorIdentifier"
  | "CreditorName"
  | "CurrencyExchangeQuoteDurationInBusinessHours"
  | "CurrencyExchangeTargetAmount"
  | "CurrencyExchangeTotalAmount"
  | "DebtorBankName"
  | "DebtorIban"
  | "DebtorName"
  | "DeliveryAddress"
  | "DeviceName"
  | "DeviceOs"
  | "Email"
  | "ExchangeRate"
  | "FirstName"
  | "From"
  | "Iban"
  | "Label"
  | "LastName"
  | "LatePenalty"
  | "MandateLegalNotice"
  | "MandateReference"
  | "MandateScheme"
  | "MandateSequenceType"
  | "Merchant"
  | "MerchantIdentifier"
  | "Option"
  | "Permissions"
  | "PhoneNumber"
  | "PublicKey"
  | "RepaymentFrequency"
  | "RepaymentMethod"
  | "Settings"
  | "SignatureDate"
  | "SpendingLimit"
  | "To"
  | "YourAccountNumber";

/** Purpose of a consent */
export type ConsentPurpose =
  /** when accepting the partnership conditions */
  | "AcceptPartnershipConditions"
  /** when activating a digital card */
  | "ActivateDigitalCard"
  /** when activating a physical card */
  | "ActivatePhysicalCard"
  /** when inviting a new account membership */
  | "AddAccountMembership"
  /** when adding several account memberships */
  | "AddAccountMemberships"
  /** when adding a beneficiary */
  | "AddBeneficiary"
  /** when adding a virtual card */
  | "AddCard"
  /** when adding multiple cards */
  | "AddCards"
  /** when adding a digital card */
  | "AddDigitalCard"
  /** when adding a payment direct debit mandate */
  | "AddDirectDebitPaymentMandate"
  /** when closing an account */
  | "CloseAccount"
  /** when the consent is a multiple consent */
  | "ConsentToMultipleConsents"
  /** when enabling a mandate */
  | "EnableMandate"
  /** when initiating a credit transfer */
  | "InitPayment"
  /** when initiating a funding request */
  | "InitiateFundingRequest"
  /** when initiating an instant funding request */
  | "InitiateInstantFundingRequest"
  /** when initiating an international credit transfer */
  | "InitiateInternationalCreditTransfer"
  /** when opting-out from Verification of Payee for Bulk Payments */
  | "OptOutBulkVerificationOfPayee"
  /** when requesting to print physical card */
  | "PrintPhysicalCard"
  /** when Requesting a credit limit */
  | "RequestCreditLimit"
  /** when resuming an account membership */
  | "ResumeAccountMembership"
  /** when resuming a physical card */
  | "ResumePhysicalCard"
  /** when returning a transaction for direct debit */
  | "ReturnTransactionForDirectDebit"
  /** when returning a transaction for international credit transfer */
  | "ReturnTransactionForInternationalCreditTransfer"
  /** when scheduling a standing order */
  | "ScheduleStandingOrder"
  /** if the consent originates from a 3DS flow */
  | "ThreeDsPayment"
  /** when updating an account membership */
  | "UpdateAccountMembership"
  /** when updating an account settings */
  | "UpdateAccountSettings"
  /** when updating a card */
  | "UpdateCard"
  /** when updating a server consent project settings */
  | "UpdateServerConsentProjectSettings"
  /** when viewing card confidential of a virtual card */
  | "ViewCardNumbers"
  /** when requesting to view physical card PIN */
  | "ViewPhysicalCardPin";

export type ConsentResponse = {
  __typename: "ConsentResponse";
  authenticatorId: Scalars["ID"]["output"];
  credentialTypeUsed: CredentialType;
  idVerified: Scalars["Boolean"]["output"];
  identityId: Scalars["ID"]["output"];
  ipAddress: Scalars["String"]["output"];
  macAddress: Scalars["String"]["output"];
  originIdentityId: Scalars["ID"]["output"];
  provider: AuthenticatorType;
  respondedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Status of a consent */
export type ConsentStatus =
  /** when the user accepted */
  | "Accepted"
  /** when the user or the project decided to cancel the consent */
  | "Canceled"
  /** when the consent is created */
  | "Created"
  /** when the user credentials were refused */
  | "CredentialRefused"
  /** when the user refused */
  | "CustomerRefused"
  /** when the consent is expired */
  | "Expired"
  /** when something went wrong */
  | "Failed"
  /** when the operation is committing */
  | "OperationCommitting"
  /** when the consentUrl has been requested */
  | "Started";

export type CouldNotFindCapitalDepositCaseRejection = Rejection & {
  __typename: "CouldNotFindCapitalDepositCaseRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type CouldNotFindCapitalDepositDocumentRejection = Rejection & {
  __typename: "CouldNotFindCapitalDepositDocumentRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type CouldNotRejectCapitalDepositDocumentRejection = Rejection & {
  __typename: "CouldNotRejectCapitalDepositDocumentRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type CouldNotUpdateCapitalDepositDocumentStatusRejection = Rejection & {
  __typename: "CouldNotUpdateCapitalDepositDocumentStatusRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type CouldNotUploadCapitalDepositDocumentRejection = Rejection & {
  __typename: "CouldNotUploadCapitalDepositDocumentRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Create sandbox identification input payload. */
export type CreateSandboxIdentificationInput = {
  errorReasons?: InputMaybe<Array<IdentificationInvalidReason>>;
  levels: IdentificationLevelStatusesInput;
  process: IdentificationProcess;
  userId: Scalars["String"]["input"];
};

/** Union of success payload and possible rejections */
export type CreateSandboxIdentificationPayload =
  | CreateSandboxIdentificationSuccessPayload
  | ForbiddenRejection
  | InvalidIdentificationErrorReasonsRejection
  | InvalidIdentificationLevelsRejection
  | UserNotFoundRejection;

/** Success payload type */
export type CreateSandboxIdentificationSuccessPayload = {
  __typename: "CreateSandboxIdentificationSuccessPayload";
  /** Created sandbox identification */
  sandboxIdentification: SandboxIdentification;
};

/** Sandbox user input payload. */
export type CreateSandboxUserInput = {
  /** List of first names */
  allFirstNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * Saves you considerable time during the development phase,
   * by automatically allowing consent,
   * removing the need to repeatedly get consent.
   */
  autoConsent: Scalars["Boolean"]["input"];
  /** [Alpha-3 birth country representation](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3) */
  birthCountryCCA3?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Birth date */
  birthDate: Scalars["Date"]["input"];
  /** First name */
  firstName: Scalars["String"]["input"];
  /** Last name */
  lastName: Scalars["String"]["input"];
  /**
   * [Alpha-3 nationality representation](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3)
   * Ex: FRA for french nationality
   */
  nationalityCCA3: Scalars["CCA3"]["input"];
};

/** Union of success payload and possible rejections */
export type CreateSandboxUserPayload =
  | CreateSandboxUserSuccessPayload
  | ForbiddenRejection
  | NationalityNotFoundRejection;

/** Success payload type */
export type CreateSandboxUserSuccessPayload = {
  __typename: "CreateSandboxUserSuccessPayload";
  /** Creates a sandbox user */
  sandboxUser: SandboxUser;
};

export type CredentialType = "FaceId" | "Pin" | "TouchId";

export type CreditLimitSettings = {
  __typename: "CreditLimitSettings";
  /** The amount currently available for borrowing */
  createdAt: Scalars["DateTime"]["output"];
  /** The different requests made for a credit limit. */
  creditLimitSettingsRequests: CreditLimitSettingsRequestConnection;
  currentCycle?: Maybe<RepaymentCycle>;
  cycles?: Maybe<RepaymentCycleConnection>;
  id: Scalars["ID"]["output"];
  repaymentSettings: RepaymentSettings;
  statusInfo: CreditLimitSettingsStatusInfo;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Rejection when an inputs contains an error */
export type CreditLimitSettingsNotFoundRejection = Rejection & {
  __typename: "CreditLimitSettingsNotFoundRejection";
  message: Scalars["String"]["output"];
};

/** Credit limit requested by the account’s legal representative. */
export type CreditLimitSettingsRequest = {
  __typename: "CreditLimitSettingsRequest";
  /** The amount claimed for the credit limits. */
  amount: Amount;
  /** The consent of the credit settings request. */
  consent: Consent;
  createdAt: Scalars["DateTime"]["output"];
  /** The ID of the credit settings request */
  id: Scalars["ID"]["output"];
  /** The amount claimed for the credit limits. */
  message?: Maybe<Scalars["String"]["output"]>;
  /** The repayment settings used for the reimbursements. */
  repaymentSettings: RepaymentSettings;
  /** The status of the credit settings request. */
  statusInfo: CreditLimitSettingsRequestStatusInfo;
  updatedAt: Scalars["DateTime"]["output"];
};

export type CreditLimitSettingsRequestApprovedStatusInfo = CreditLimitSettingsRequestStatusInfo & {
  __typename: "CreditLimitSettingsRequestApprovedStatusInfo";
  approvedAt: Scalars["DateTime"]["output"];
  status: CreditLimitSettingsRequestStatus;
};

export type CreditLimitSettingsRequestCanceledStatusInfo = CreditLimitSettingsRequestStatusInfo & {
  __typename: "CreditLimitSettingsRequestCanceledStatusInfo";
  canceledAt: Scalars["DateTime"]["output"];
  status: CreditLimitSettingsRequestStatus;
};

export type CreditLimitSettingsRequestConnection = Connection & {
  __typename: "CreditLimitSettingsRequestConnection";
  /** CardSettingsRequestEdge list */
  edges: Array<CreditLimitSettingsRequestEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

export type CreditLimitSettingsRequestConsentPendingStatusInfo =
  CreditLimitSettingsRequestStatusInfo & {
    __typename: "CreditLimitSettingsRequestConsentPendingStatusInfo";
    status: CreditLimitSettingsRequestStatus;
  };

/** Implements the Relay Edge interface */
export type CreditLimitSettingsRequestEdge = Edge & {
  __typename: "CreditLimitSettingsRequestEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The Repayment Cycle entry */
  node: CreditLimitSettingsRequest;
};

export type CreditLimitSettingsRequestPendingReviewStatusInfo =
  CreditLimitSettingsRequestStatusInfo & {
    __typename: "CreditLimitSettingsRequestPendingReviewStatusInfo";
    status: CreditLimitSettingsRequestStatus;
  };

export type CreditLimitSettingsRequestRefusedStatusInfo = CreditLimitSettingsRequestStatusInfo & {
  __typename: "CreditLimitSettingsRequestRefusedStatusInfo";
  reasons: Array<Maybe<Scalars["String"]["output"]>>;
  refusedAt: Scalars["DateTime"]["output"];
  status: CreditLimitSettingsRequestStatus;
};

export type CreditLimitSettingsRequestStatus =
  | "Approved"
  | "Canceled"
  | "ConsentPending"
  | "Frozen"
  | "PendingReview"
  | "Refused";

export type CreditLimitSettingsRequestStatusInfo = {
  /** The status of the credit settings request. */
  status: CreditLimitSettingsRequestStatus;
};

export type CreditLimitSettingsStatusInfo = {
  /** The status of the credit limit. */
  status?: Maybe<CreditLimitStatus>;
};

export type CreditLimitStatus = "Activated" | "Deactivated" | "Pending" | "Suspended";

export type CreditLimitStatusActivatedInfo = CreditLimitSettingsStatusInfo & {
  __typename: "CreditLimitStatusActivatedInfo";
  status: CreditLimitStatus;
};

export type CreditLimitStatusDeactivatedInfo = CreditLimitSettingsStatusInfo & {
  __typename: "CreditLimitStatusDeactivatedInfo";
  /** The date when the credit limit got deactivated. */
  deactivatedAt: Scalars["DateTime"]["output"];
  status: CreditLimitStatus;
};

export type CreditLimitStatusPendingInfo = CreditLimitSettingsStatusInfo & {
  __typename: "CreditLimitStatusPendingInfo";
  status: CreditLimitStatus;
};

export type CreditLimitStatusSuspendedInfo = CreditLimitSettingsStatusInfo & {
  __typename: "CreditLimitStatusSuspendedInfo";
  status: CreditLimitStatus;
  /** The date when the credit limit got suspended. */
  suspendedAt: Scalars["DateTime"]["output"];
};

/** A statement represent metadata around a banking document that list all of the BOOKED banking transactions that have happened between startDate and endDate */
export type CreditStatement = {
  __typename: "CreditStatement";
  /** booked balance at the end of the window */
  closingBalance: Amount;
  /** ending date of the date window */
  closingDate: Scalars["DateTime"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** unique identifier of the statement */
  id: Scalars["ID"]["output"];
  /** booked balance at the start of the window */
  openingBalance: Amount;
  /** starting date of the date window */
  openingDate: Scalars["DateTime"]["output"];
  /** repayment cycle related to the statement */
  repaymentCycle?: Maybe<RepaymentCycle>;
  /** status of the statement */
  status: StatementStatus;
  /** the sum of credit transactions during the window */
  totalCredits: Amount;
  /** the sum of debit transactions during the window */
  totalDebits: Amount;
  /** type of statement (ex: PDF) */
  type: StatementInfo;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

export type CreditTransferMode = "InstantWithFallback" | "InstantWithoutFallback" | "Regular";

/** Custom information for a CSV statement */
export type CsvStatement = StatementInfo & {
  __typename: "CsvStatement";
  /** date at which the link will not be useable anymore */
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** statement type */
  type?: Maybe<StatementType>;
  /** temporary public url on which the file can be accessed */
  url?: Maybe<Scalars["String"]["output"]>;
};

export type Customer = {
  __typename: "Customer";
  /**
   * A customer id present in a third-party system.
   * Alows to link a customer to a payment link and by extension, to a Merchant Payment.
   */
  externalCustomerId?: Maybe<Scalars["String"]["output"]>;
  iban?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type DateField = Field & {
  __typename: "DateField";
  example?: Maybe<Scalars["String"]["output"]>;
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  required: Scalars["Boolean"]["output"];
  validationRegex?: Maybe<Scalars["String"]["output"]>;
};

export type DayEnum =
  | "Friday"
  | "Monday"
  | "Saturday"
  | "Sunday"
  | "Thursday"
  | "Tuesday"
  | "Wednesday";

/** Rejection returned when the Debtor is closed */
export type DebtorAccountClosedRejection = Rejection & {
  __typename: "DebtorAccountClosedRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the Debtor does not belong to the same project as the creditor */
export type DebtorAccountNotAllowedRejection = Rejection & {
  __typename: "DebtorAccountNotAllowedRejection";
  message: Scalars["String"]["output"];
};

export type DefaultAdditionalInformation = {
  __typename: "DefaultAdditionalInformation";
  type: AdditionalInformationType;
  value: Scalars["String"]["output"];
};

export type DefaultAdditionalInformationInput = {
  type: AdditionalInformationType;
  value: Scalars["String"]["input"];
};

/** Input of to delete a sandbox user */
export type DeleteSandboxUserInput = {
  /** Id of the sandbox user to delete */
  id: Scalars["String"]["input"];
};

/** Union of the success payload and possible rejections */
export type DeleteSandboxUserPayload =
  | DeleteSandboxUserSuccessPayload
  | ForbiddenRejection
  | LastSandboxUserCannotBeDeletedRejection
  | SandboxUserNotFoundRejection;

export type DeleteSandboxUserSuccessPayload = {
  __typename: "DeleteSandboxUserSuccessPayload";
  /** Success flag */
  success: Scalars["Boolean"]["output"];
};

export type DetailedConsent = {
  acceptedAt?: Maybe<Scalars["DateTime"]["output"]>;
  branding: Branding;
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  challenge?: Maybe<Scalars["String"]["output"]>;
  consentOperations: Array<ConsentOperation>;
  consentResponses: Array<ConsentResponse>;
  createdAt: Scalars["DateTime"]["output"];
  env: EnvType;
  expiredAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** @deprecated use userId, which can be null in the oAuth2 consent case */
  identityId: Scalars["String"]["output"];
  operationsSHA256HexDigest?: Maybe<Scalars["String"]["output"]>;
  projectId?: Maybe<Scalars["String"]["output"]>;
  purpose: DetailedConsentPurpose;
  refusedAt?: Maybe<Scalars["DateTime"]["output"]>;
  requireSCA: Scalars["Boolean"]["output"];
  startedAt?: Maybe<Scalars["DateTime"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  status: ConsentStatus;
  updatedAt: Scalars["DateTime"]["output"];
  userId?: Maybe<Scalars["String"]["output"]>;
};

/** Purpose of a consent */
export type DetailedConsentPurpose =
  /** when accepting the partnership conditions */
  | "AcceptPartnershipConditions"
  /** when activating a digital card */
  | "ActivateDigitalCard"
  /** when activating a physical card */
  | "ActivatePhysicalCard"
  /** when inviting a new account membership */
  | "AddAccountMembership"
  /** when adding several account memberships */
  | "AddAccountMemberships"
  /** when adding a beneficiary */
  | "AddBeneficiary"
  /** when adding a virtual card */
  | "AddCard"
  /** when adding multiple cards */
  | "AddCards"
  /** when adding a digital card */
  | "AddDigitalCard"
  /** when adding a payment direct debit mandate */
  | "AddDirectDebitPaymentMandate"
  /** when closing an account */
  | "CloseAccount"
  /** if the consent is a multiple consent */
  | "ConsentToMultipleConsents"
  /** when enabling a mandate */
  | "EnableMandate"
  /** when initiating a credit transfer */
  | "InitPayment"
  /** when initiating a funding request */
  | "InitiateFundingRequest"
  /** when initiating an instant funding request */
  | "InitiateInstantFundingRequest"
  /** when initiating an international credit transfer */
  | "InitiateInternationalCreditTransfer"
  /** if the consent originates from a oauth2 flow, the purpose should be determined from its scopes */
  | "OAuth2"
  /** when opting out a bulk verification of payee for an account settings */
  | "OptOutBulkVerificationOfPayee"
  /** when requesting to print physical card */
  | "PrintPhysicalCard"
  /** When requesting for a credit limit */
  | "RequestCreditLimit"
  /** when resuming an account membership */
  | "ResumeAccountMembership"
  /** when resuming a physical card */
  | "ResumePhysicalCard"
  /** when returning a transaction for direct debit */
  | "ReturnTransactionForDirectDebit"
  /** when returning a transaction for international credit transfer */
  | "ReturnTransactionForInternationalCreditTransfer"
  /** when scheduling a standing order */
  | "ScheduleStandingOrder"
  /** if the consent originates from a 3DS flow */
  | "ThreeDsPayment"
  /** when updating an account membership */
  | "UpdateAccountMembership"
  /** when updating an account settings */
  | "UpdateAccountSettings"
  /** when updating a card */
  | "UpdateCard"
  /** to update server consent settings on project */
  | "UpdateServerConsentProjectSettings"
  /** when viewing card confidential of a virtual card */
  | "ViewCardNumbers"
  /** when requesting to view physical card PIN */
  | "ViewPhysicalCardPin";

/** Input to decide on digitalization */
export type DigitalizationInput = {
  /** The card id to provision */
  cardId: Scalars["String"]["input"];
  /** Type of card */
  cardType: CardType;
  /** Response from swan to the provisioning request */
  provisioningResponse: ProvisioningResponse;
  /** Type of card */
  responseChannel: ResponseChannel;
  /** Wallet Provider (ApplePay, GooglePay ...) */
  walletProvider?: InputMaybe<WalletProviderType>;
};

/** Direct Debit Account Verification */
export type DirectDebitAccountVerification = AccountVerification & {
  __typename: "DirectDebitAccountVerification";
  /** Creation date of the account verification */
  createdAt: Scalars["DateTime"]["output"];
  /** IBAN of the account to cross check with account holder information */
  iban: Scalars["IBAN"]["output"];
  /** Unique identifier of the Account Verification */
  id: Scalars["ID"]["output"];
  /** Account Verification Status Information */
  statusInfo: AccountVerificationStatusInfo;
  /** Last update date of the account verification */
  updatedAt: Scalars["DateTime"]["output"];
};

/** StatusInfo when funding limit settings has been disabled */
export type DisabledFundingLimitSettingsStatusInfo = FundingLimitSettingsStatusInfo & {
  __typename: "DisabledFundingLimitSettingsStatusInfo";
  reason: Scalars["String"]["output"];
  status: FundingLimitSettingsStatus;
};

/** EnabledMerchantPaymentMethodStatusInfo */
export type DisabledMerchantPaymentMethodStatusInfo = MerchantPaymentMethodStatusInfo & {
  __typename: "DisabledMerchantPaymentMethodStatusInfo";
  /** Merchant Payment Method disabled date */
  disabledAt: Scalars["Date"]["output"];
  status: MerchantPaymentMethodStatus;
};

/** DisabledMerchantProfileStatusInfo */
export type DisabledMerchantProfileStatusInfo = MerchantProfileStatusInfo & {
  __typename: "DisabledMerchantProfileStatusInfo";
  disabledAt: Scalars["Date"]["output"];
  status: MerchantProfileStatus;
};

/** Rejection returned if the document cannot be found */
export type DocumentCanNotBeFoundRejection = Rejection & {
  __typename: "DocumentCanNotBeFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection returned if the document cannot be rejected */
export type DocumentCanNotBeRejectedRejection = Rejection & {
  __typename: "DocumentCanNotBeRejectedRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Retrieved document extracted from the identity verification */
export type DocumentFile = {
  downloadUrl: Scalars["String"]["output"];
};

/** From which side the document picture was taken */
export type DocumentFileSide = "BothSides" | "SideA" | "SideB" | "Unknown";

/** Rejection returned if the document-parent link is missing */
export type DocumentParentLinkMissingRejection = Rejection & {
  __typename: "DocumentParentLinkMissingRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Reason code of the document. */
export type DocumentReasonCode =
  /** Document is damaged, in poor condition, or has not been uploaded in the correct file type. */
  | "BadDocumentQuality"
  /** Company name in document doesn't match our records. */
  | "CompanyNameMismatch"
  /** Document refused for compliance reasons. */
  | "ComplianceReason"
  /** Declared amount in document doesn't match the expected amount. */
  | "DeclaredAmountMismatch"
  /** One of the provided documents is too old. */
  | "ExpiredDocument"
  /** Only part of the document was provided. */
  | "FullDocumentRequired"
  /** The signature is not handwritten or electronically certified. */
  | "HandwrittenOrCertifiedElectronicSignatureRequired"
  /** Address in document doesn't match our records. */
  | "InvalidAddress"
  /** Bank name in articles of association document is invalid. */
  | "InvalidDepositBankName"
  /** Default value when none of the other values is appropriate. */
  | "InvalidDocument"
  /** Some information is missing. */
  | "InvalidOrMissingData"
  /** Missing identity document of accommodation provider. */
  | "MissingAccommodationProviderId"
  /** Missing identity document and proof of accommodation from accommodation provider. */
  | "MissingAccommodationProviderIdLetter"
  /** Missing proof of accommodation from accommodation provider. */
  | "MissingAccommodationProviderLetter"
  /** Missing company domiciliation statement. */
  | "MissingCompanyDomiciliationStatement"
  /** Missing the register extract of the company providing accommodation and ID document of the legal representative. */
  | "MissingCompanyProviderRegisterExtract"
  /** Missing accommodation provider's proof of address. */
  | "MissingProviderProofOfAddress"
  /** Missing accommodation provider's proof of address and ID document. */
  | "MissingProviderProofOfAddressAndIdDocument"
  /** Document must be signed, either by hand or electronically with certification. */
  | "MissingSignature"
  /** Power of attorney must be provided to Swan. */
  | "PowerOfAttorneyToSwanRequired"
  /** Accommodation provider's identity document must be in full color. */
  | "ProviderColorIdDocumentRequired"
  /** Document cannot be accepted for the requested document type. Refer to the [list of accepted documents](https://docs.swan.io/partnership/document-center/proof-address/). */
  | "UnacceptableDocument";

/** The type of the document */
export type DocumentType =
  | "DriversLicense"
  | "Face"
  | "IdCard"
  | "Passport"
  | "Report"
  | "ResidencePermit";

/** The document corresponding to a driver's license */
export type DriversLicenseDocument = {
  __typename: "DriversLicenseDocument";
  /** List of the associated files */
  files: Array<DriversLicenseDocumentFile>;
  /** Unique identifier of the driver's license document */
  id: Scalars["String"]["output"];
  /** The type of the document */
  type: DocumentType;
};

/** The file associated to the driver's license document */
export type DriversLicenseDocumentFile = DocumentFile & {
  __typename: "DriversLicenseDocumentFile";
  /** The file's temporary download url */
  downloadUrl: Scalars["String"]["output"];
  /** From which side the deiver's license's picture was taken */
  side: DocumentFileSide;
};

/**
 * Edge type containing the node and cursor. The node is not defined in the interface because generic is not supported by GraphQL
 * but all implementation contains its own node property according to the paginated type.
 */
export type Edge = {
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
};

/** Employment status. */
export type EmploymentStatus =
  | "Craftsman"
  | "Employee"
  | "Entrepreneur"
  | "Farmer"
  | "Manager"
  | "Practitioner"
  | "Retiree"
  | "ShopOwner"
  | "Student"
  | "Unemployed";

/** StatusInfo when the funding limit settings is enabled */
export type EnabledFundingLimitSettingsStatusInfo = FundingLimitSettingsStatusInfo & {
  __typename: "EnabledFundingLimitSettingsStatusInfo";
  status: FundingLimitSettingsStatus;
};

/** EnabledMerchantPaymentMethodStatusInfo */
export type EnabledMerchantPaymentMethodStatusInfo = MerchantPaymentMethodStatusInfo & {
  __typename: "EnabledMerchantPaymentMethodStatusInfo";
  /** Merchant Payment Method enabled date */
  enabledAt: Scalars["Date"]["output"];
  status: MerchantPaymentMethodStatus;
};

/** EnabledMerchantProfileStatusInfo */
export type EnabledMerchantProfileStatusInfo = MerchantProfileStatusInfo & {
  __typename: "EnabledMerchantProfileStatusInfo";
  enabledAt: Scalars["Date"]["output"];
  status: MerchantProfileStatus;
};

export type EndorseSandboxUserDummyRejection = Rejection & {
  __typename: "EndorseSandboxUserDummyRejection";
  message: Scalars["String"]["output"];
};

/** Input of the sandbox user you want to be logged as */
export type EndorseSandboxUserInput = {
  /** Sandbox user ID */
  id: Scalars["String"]["input"];
};

/** Union of the success payload and possible rejections */
export type EndorseSandboxUserPayload =
  | EndorseSandboxUserSuccessPayload
  | ForbiddenRejection
  | SandboxUserNotFoundRejection;

/** Success payload type */
export type EndorseSandboxUserSuccessPayload = {
  __typename: "EndorseSandboxUserSuccessPayload";
  sandboxUser: SandboxUser;
};

export type EnrichedTransactionInfo = {
  __typename: "EnrichedTransactionInfo";
  /** Merchant address */
  address?: Maybe<Scalars["String"]["output"]>;
  /** Transaction carbon footprint in micrograms of CO2 emitted */
  carbonFootprint?: Maybe<Scalars["String"]["output"]>;
  /** Merchant category */
  category?: Maybe<MerchantCategory>;
  /** Merchant city */
  city?: Maybe<Scalars["String"]["output"]>;
  /** Merchant email */
  contactEmail?: Maybe<Scalars["String"]["output"]>;
  /** Merchant phone */
  contactPhone?: Maybe<Scalars["String"]["output"]>;
  /** Merchant website */
  contactWebsite?: Maybe<Scalars["String"]["output"]>;
  /** Merchant country */
  country?: Maybe<Scalars["CCA3"]["output"]>;
  /** Well formatted merchant name */
  enrichedMerchantName?: Maybe<Scalars["String"]["output"]>;
  /** Is merchant a subcription */
  isSubscription?: Maybe<Scalars["Boolean"]["output"]>;
  /** Merchant location latitude */
  latitude?: Maybe<Scalars["String"]["output"]>;
  /** URL of the merchant logo */
  logoUrl?: Maybe<Scalars["String"]["output"]>;
  /** Merchant location longitude */
  longitude?: Maybe<Scalars["String"]["output"]>;
  /** Merchant postal code */
  postalCode?: Maybe<Scalars["String"]["output"]>;
  /** Merchant subcategory */
  subcategory?: Maybe<MerchantSubCategory>;
};

export type EnvType = "Live" | "Sandbox";

export type ExemptThreeDsStatusInfo = ThreeDsStatusInfo & {
  __typename: "ExemptThreeDsStatusInfo";
  status: IncomingThreeDsStatus;
};

export type ExpectedMonthlyMerchantProcessingVolume =
  | "Between5000And10000"
  | "Between10000And100000"
  | "LessThan5000"
  | "MoreThan100000";

/** Describes an identification level for the process associated to this identification that has expired and is no longer considered valid */
export type ExpiredIdentificationLevelStatusInfo = {
  __typename: "ExpiredIdentificationLevelStatusInfo";
  /** When this identification level expired */
  expiredAt: Scalars["Date"]["output"];
  /** Always set to `Expired` */
  status: SwanIdentificationStatus;
};

export type ExpiredMerchantPaymentLinkStatusInfo = MerchantPaymentLinkStatusInfo & {
  __typename: "ExpiredMerchantPaymentLinkStatusInfo";
  /**
   * The date when the payment link expired.
   * By default the payment link expires 120 days after it was created.
   */
  expiredAt: Scalars["DateTime"]["output"];
  status: MerchantPaymentLinkStatus;
};

export type ExternalCard = {
  __typename: "ExternalCard";
  /** The card's first 6 digits - Bank Identification Number */
  bin: Scalars["String"]["output"];
  /**
   * deprecated: The card type
   * @deprecated The cardType field is deprecated, use the type field instead
   */
  cardType?: Maybe<CardPaymentMandateType>;
  /** The card category */
  category?: Maybe<CardPaymentMandateCategory>;
  /** The card's bank country */
  country?: Maybe<Scalars["CCA2"]["output"]>;
  /** The card's expiry date */
  expiryDate?: Maybe<Scalars["String"]["output"]>;
  /** The card's last digits */
  lastDigits: Scalars["String"]["output"];
  /** The local card scheme */
  localScheme?: Maybe<CardPaymentMandateScheme>;
  /** The card scheme */
  scheme: CardPaymentMandateScheme;
  /** The card type */
  type?: Maybe<CardPaymentMandateType>;
};

export type FnciResult = "IrregularOrange" | "IrregularRed" | "IrregularWhite" | "PositiveGreen";

/** The document corresponding to a face photo */
export type FacePhotoDocument = {
  __typename: "FacePhotoDocument";
  /** Unique identifier of the face photo document. For privacy reasons, no temporary download url is exposed for this document */
  id: Scalars["String"]["output"];
  /** The type of the document */
  type: DocumentType;
};

export type FailedThreeDsReason = "AuthenticationExpired" | "AuthenticationFailed" | "Other";

export type FailedThreeDsStatusInfo = ThreeDsStatusInfo & {
  __typename: "FailedThreeDsStatusInfo";
  reasonCode: FailedThreeDsReason;
  status: IncomingThreeDsStatus;
};

export type Field = {
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  required: Scalars["Boolean"]["output"];
};

export type FieldValidationError =
  /** When the associated field's value is invalid */
  | "Invalid"
  /** When the associated field's value is missing */
  | "Missing";

export type ForbiddenRejection = Rejection & {
  __typename: "ForbiddenRejection";
  message: Scalars["String"]["output"];
};

export type FundingLimit = {
  __typename: "FundingLimit";
  /** Maximum Funding Amount authorized */
  amount: Amount;
  /** Funding Amount that has already been used during the interval */
  funding?: Maybe<Amount>;
  /** Interval in number of calendar days where the limit is applied */
  rollingDays: Scalars["Int"]["output"];
};

/** Funding Limit Amount */
export type FundingLimitAmount = {
  __typename: "FundingLimitAmount";
  /** The amount settings */
  amount: Amount;
};

/** Funding Limit Amount Input */
export type FundingLimitAmountInput = {
  /** The amount settings */
  amount: AmountInput;
};

/** Rejection returned when the Account Holder Funding has been exceeded */
export type FundingLimitExceededRejection = Rejection & {
  __typename: "FundingLimitExceededRejection";
  message: Scalars["String"]["output"];
};

export type FundingLimitSettings = {
  __typename: "FundingLimitSettings";
  /** Periodic funding limit */
  fundingLimit?: Maybe<FundingLimit>;
  /** Related change request */
  fundingLimitSettingsChangeRequest?: Maybe<FundingLimitSettingsChangeRequest>;
  /** Instant funding limit */
  instantFundingLimit?: Maybe<InstantFundingLimit>;
  /** Status of the resource */
  statusInfo: FundingLimitSettingsStatusInfo;
};

/** Funding Limit Settings Change Request */
export type FundingLimitSettingsChangeRequest = {
  __typename: "FundingLimitSettingsChangeRequest";
  /** Approved amount settings for the the instant funding limit and the funding limit */
  approved?: Maybe<ApprovedFundingLimit>;
  /** Date of creation */
  createdAt?: Maybe<Scalars["Date"]["output"]>;
  /** Requested amount settings for the funding limit */
  fundingLimit: FundingLimitAmount;
  /** Unique identifier of a funding limit settings change request */
  id: Scalars["ID"]["output"];
  /** Requested amount settings for the instant funding limit */
  instantFundingLimit: FundingLimitAmount;
  /** Status of the request */
  statusInfo: FundingLimitSettingsChangeRequestStatusInfo;
  /** Date of last update */
  updatedAt?: Maybe<Scalars["Date"]["output"]>;
};

/** StatusInfo when funding limit settings change request has been approved */
export type FundingLimitSettingsChangeRequestApprovedStatusInfo =
  FundingLimitSettingsChangeRequestStatusInfo & {
    __typename: "FundingLimitSettingsChangeRequestApprovedStatusInfo";
    reason: Scalars["String"]["output"];
    status: FundingLimitSettingsChangeRequestStatus;
  };

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type FundingLimitSettingsChangeRequestConnection = Connection & {
  __typename: "FundingLimitSettingsChangeRequestConnection";
  /** FundingLimitSettingsChangeRequestEdge list */
  edges: Array<FundingLimitSettingsChangeRequestEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type FundingLimitSettingsChangeRequestEdge = Edge & {
  __typename: "FundingLimitSettingsChangeRequestEdge";
  /** Opaque identifier pointing to this onboarding node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The FundingLimitSettingsChangeRequest */
  node: FundingLimitSettingsChangeRequest;
};

/** Filters that can be applied when listing funding limit settings change requests */
export type FundingLimitSettingsChangeRequestFiltersInput = {
  /** Filter by IDs */
  id?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filter by status */
  status?: InputMaybe<Array<FundingLimitSettingsChangeRequestStatus>>;
};

export type FundingLimitSettingsChangeRequestNotFoundRejection = Rejection & {
  __typename: "FundingLimitSettingsChangeRequestNotFoundRejection";
  message: Scalars["String"]["output"];
};

/** Field we can use when ordering that can be applied when listing funding limit settings change requests */
export type FundingLimitSettingsChangeRequestOrderByFieldInput = "createdAt" | "id" | "updatedAt";

/** Order that can be applied when listing funding limit settings change requests */
export type FundingLimitSettingsChangeRequestOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<FundingLimitSettingsChangeRequestOrderByFieldInput>;
};

/** StatusInfo when funding limit settings change request is pending */
export type FundingLimitSettingsChangeRequestPendingStatusInfo =
  FundingLimitSettingsChangeRequestStatusInfo & {
    __typename: "FundingLimitSettingsChangeRequestPendingStatusInfo";
    status: FundingLimitSettingsChangeRequestStatus;
  };

/** StatusInfo when funding limit settings change request has been rejected */
export type FundingLimitSettingsChangeRequestRefusedStatusInfo =
  FundingLimitSettingsChangeRequestStatusInfo & {
    __typename: "FundingLimitSettingsChangeRequestRefusedStatusInfo";
    reason: Scalars["String"]["output"];
    status: FundingLimitSettingsChangeRequestStatus;
  };

/** Funding Limit Settings Change Request Status */
export type FundingLimitSettingsChangeRequestStatus =
  /** When the request is approved */
  | "Approved"
  /** When the request is in pending */
  | "Pending"
  /** When the request is refused */
  | "Refused"
  /** When the request is in waiting for information */
  | "WaitingForInformation";

/** Object containing details about funding limit settings change request status */
export type FundingLimitSettingsChangeRequestStatusInfo = {
  /** Current limit settings change request status. */
  status: FundingLimitSettingsChangeRequestStatus;
};

export type FundingLimitSettingsChangeRequestStatusNotAllowedRejection = Rejection & {
  __typename: "FundingLimitSettingsChangeRequestStatusNotAllowedRejection";
  message: Scalars["String"]["output"];
};

/** StatusInfo when funding limit settings change request is waiting for more information */
export type FundingLimitSettingsChangeRequestWaitingForInformationStatusInfo =
  FundingLimitSettingsChangeRequestStatusInfo & {
    __typename: "FundingLimitSettingsChangeRequestWaitingForInformationStatusInfo";
    status: FundingLimitSettingsChangeRequestStatus;
  };

/** Possible values for funding limit settings status */
export type FundingLimitSettingsStatus =
  /** When the funding limit settings is disabled */
  | "Disabled"
  /** When the funding limit settings is enabled */
  | "Enabled"
  /** When the funding limit settings is suspended */
  | "Suspended";

/** Object containing details about funding limit settings status */
export type FundingLimitSettingsStatusInfo = {
  /** Current funding limit settings. */
  status: FundingLimitSettingsStatus;
};

/** Funding Source */
export type FundingSource = {
  __typename: "FundingSource";
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** ID of the Funding Source */
  id: Scalars["ID"]["output"];
  /** Name of the Funding Source */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Funding Source status information */
  statusInfo: FundingSourceStatusInfo;
  /** Last updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

export type FundingSourceNotFoundRejection = Rejection & {
  __typename: "FundingSourceNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Funding Source Statuses */
export type FundingSourceStatus = "Canceled" | "Enabled" | "Pending" | "Rejected" | "Suspended";

/** Funding Source status information */
export type FundingSourceStatusInfo = {
  __typename: "FundingSourceStatusInfo";
  /** Funding Source Pending status */
  status: FundingSourceStatus;
};

/** Rejection returned when the Funding Source is not in the expected status */
export type FundingSourceWrongStatusRejection = Rejection & {
  __typename: "FundingSourceWrongStatusRejection";
  currentStatus: FundingSourceStatus;
  expectedStatus: FundingSourceStatus;
  message: Scalars["String"]["output"];
};

export type Gender = "Female" | "Male" | "Unknown";

/** GenerateCheckInput */
export type GenerateCheckInput = {
  fnciResult?: InputMaybe<FnciResult>;
};

export type GenerateCheckPayload = GenerateCheckSuccessPayload | InternalErrorRejection;

/** GenerateCheckSuccessPayload */
export type GenerateCheckSuccessPayload = {
  __typename: "GenerateCheckSuccessPayload";
  /**
   * 31-character unique identifier.
   * CMC7 is composed of 3 sections (check number (7 char.), check issuing bank code (12 char.), check holder account number (12 char.)).
   * Combined with RLMC key, it  allows the check traceability.
   */
  cmc7: Scalars["String"]["output"];
  /**
   * 2-digit key used to check the integrity of the CMC7 line.
   * Combined with CMC7 line, it allows the check traceability.
   */
  rlmcKey: Scalars["String"]["output"];
};

/** Rejection returned when the Global Funding has been exceeded */
export type GlobalFundingLimitExceededRejection = Rejection & {
  __typename: "GlobalFundingLimitExceededRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the Global Instant Funding limit has been exceeded */
export type GlobalInstantFundingLimitExceededRejection = Rejection & {
  __typename: "GlobalInstantFundingLimitExceededRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the IBAN is not reachable */
export type IbanNotReachableRejection = Rejection & {
  __typename: "IBANNotReachableRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the IBAN is not valid */
export type IbanNotValidRejection = Rejection & {
  __typename: "IBANNotValidRejection";
  message: Scalars["String"]["output"];
};

/** Virtual IBAN Status */
export type IbanStatus =
  /** When the virtual IBAN refuse definitely to receive Sepa payments */
  | "Canceled"
  /** When the virtual IBAN accept to receive Sepa payments */
  | "Enabled"
  /** When the virtual IBAN refuse temporarily to receive Sepa payments */
  | "Suspended";

/** The document corresponding to an ID card */
export type IdCardDocument = {
  __typename: "IdCardDocument";
  /** The date at which the ID card expires */
  expiryDate?: Maybe<Scalars["Date"]["output"]>;
  /** List of the associated files */
  files: Array<IdCardDocumentFile>;
  /** Unique identifier of the ID card document */
  id: Scalars["String"]["output"];
  /** The date at which the ID card was issued */
  issueDate?: Maybe<Scalars["Date"]["output"]>;
  /** Machine-readable zone code of the ID card */
  mrz?: Maybe<Scalars["String"]["output"]>;
  /** Number of the ID card */
  number?: Maybe<Scalars["String"]["output"]>;
  /** The type of the document */
  type: DocumentType;
};

/** The file associated to the ID card document */
export type IdCardDocumentFile = DocumentFile & {
  __typename: "IdCardDocumentFile";
  /** The file's temporary download url */
  downloadUrl: Scalars["String"]["output"];
  /** From which side the ID card's picture was taken */
  side: DocumentFileSide;
};

/** The identification represents an ongoing identification process or its result */
export type Identification = {
  __typename: "Identification";
  /** Creation date of the identification */
  createdAt: Scalars["DateTime"]["output"];
  /** The available documents related to the identification (id doc, selfie, report...) */
  documents?: Maybe<Array<IdentificationDocument>>;
  /** Unique identifier of the identification */
  id: Scalars["String"]["output"];
  /** The identity document type used for the current identification (passport, id card ...) */
  identityDocumentType?: Maybe<IdentityDocumentType>;
  /** The status and results associated to the available identification processes */
  levels: IdentificationLevelStatusesInfo;
  /** The process that was used for this identification */
  process: IdentificationProcess;
  /** The global status of the identification */
  status: SwanIdentificationStatus;
  /** Last update date of the identification */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Fields we can use when ordering that can be applied when listing identifications */
export type IdentificationConnection = {
  __typename: "IdentificationConnection";
  /** IdentificationEdge list */
  edges: Array<IdentificationEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Union representing all the possible identification document types */
export type IdentificationDocument =
  | DriversLicenseDocument
  | FacePhotoDocument
  | IdCardDocument
  | PassportDocument
  | ReportDocument
  | ResidencePermitDocument;

/** Implements the Relay Edge interface */
export type IdentificationEdge = Edge & {
  __typename: "IdentificationEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The identification entry */
  node: Identification;
};

/**
 * If requested by sending the right parameters to the initial oauth2 url,
 * it contains the identification level that is requested to be fulfilled
 * after the oauth2 consent by starting the right identification.
 *
 * QES => use the `startFourthlineQesIdentification` mutation
 *
 * Expert => use the `startUbbleExpertIdVerificationIdentification` mutation
 *
 * PVID => use the `startUbblePvidIdVerificationIdentification` mutation
 *
 * Auto => use query `recommendedIdentificationFlow` to let Swan recommend the best flow and level for a user
 */
export type IdentificationFlowLevel = "Auto" | "Expert" | "PVID" | "QES";

/** The various reasons that can lead to an invalid identification level */
export type IdentificationInvalidReason =
  /** Face must be fully present in the photo */
  | "AbsentOrIncompleteFace"
  /** Applicant used a device that has been technically altered / modified */
  | "AlteredDevice"
  /** Light on actual document is insufficient */
  | "BadDocumentLighting"
  /** Something about the document is damaged (could be as tiny as a bent corner) */
  | "DamagedDocument"
  /** Expiry date of document has passed */
  | "ExpiredDocument"
  /** Attempt to commit fraud detected */
  | "FraudDetected"
  /** Video quality isn’t sufficient or video is missing required information */
  | "InadequateVideo"
  /** Lighting on applicant’s face is insufficient */
  | "InsufficientApplicantLighting"
  /** Applicant isn’t meeting movement requirements */
  | "InsufficientApplicantLiveness"
  /** Internet connection quality is insufficient */
  | "InsufficientConnectionQuality"
  /** Video of document doesn’t meet movement requirements */
  | "InsufficientDocumentLiveness"
  /** Document is blurry or otherwise distorted */
  | "InsufficientDocumentReadability"
  /** Face is blurry or otherwise distorted */
  | "InsufficientFaceReadability"
  /** Video is blurry or otherwise distorted */
  | "InsufficientVideoReadability"
  /** There was a technical error */
  | "InternalError"
  /** Address is not valid or accepted */
  | "InvalidAddress"
  /** Identification data is invalid or missing */
  | "InvalidOrMissingData"
  /** Applicant seems to be doing verification against their will */
  | "InvoluntaryIdentification"
  /** Geolocation data is required but not available */
  | "MissingGeolocationData"
  /** Applicant appears on unacceptable news list */
  | "NegativeNewsHit"
  /** Applicant’s identity does not match the expected ID info */
  | "NonMatchingIdentity"
  /** Applicant presented a duplicate of the document (digital or paper) */
  | "NonOriginalDocument"
  /** Applicant appears on a sanctions list */
  | "SanctionListHit"
  /** Applicant required to provide a second document */
  | "SecondDocumentRequired"
  /** There was a technical error with the electronic signature process */
  | "TechnicalSignatureError"
  /** The time to complete the signature timed out */
  | "TimeoutSignatureFlow"
  /** Document not on list of acceptable document types */
  | "UnacceptableDocument"
  /** Applicant is under the minimum required age */
  | "UnderageApplicant";

/** Possible value for the field IdentificationLevel */
export type IdentificationLevel =
  /** Human identity verification */
  | "Expert"
  /** Identity verification with PVID */
  | "PVID"
  /** Identity verification with Qualified Electronic Signature */
  | "QES";

/**
 * Union representing all the possible statuses: not supported, not started, pending, valid, invalid, cancelled, expired
 * Each variant contains its relevant data, for example invalid contains a `reason` field, expired contains an `expiredAt` field, valid contains a `documents` field
 */
export type IdentificationLevelStatusInfo =
  | CanceledIdentificationLevelStatusInfo
  | ExpiredIdentificationLevelStatusInfo
  | InvalidIdentificationLevelStatusInfo
  | NotStartedIdentificationLevelStatusInfo
  | NotSupportedIdentificationLevelStatusInfo
  | PendingIdentificationLevelStatusInfo
  | StartedIdentificationLevelStatusInfo
  | ValidIdentificationLevelStatusInfo;

/** The status and results associated to the available identification processes */
export type IdentificationLevelStatusesInfo = {
  __typename: "IdentificationLevelStatusesInfo";
  /** The status and results associated to the expert level */
  expert: IdentificationLevelStatusInfo;
  /** The status and results associated to the Remote Identity Verification Service level */
  pvid: IdentificationLevelStatusInfo;
  /** The status and results associated to the Qualified Electronic Signature level */
  qes: IdentificationLevelStatusInfo;
};

export type IdentificationLevelStatusesInput = {
  expert?: InputMaybe<SwanIdentificationStatus>;
  pvid?: InputMaybe<SwanIdentificationStatus>;
  qes?: InputMaybe<SwanIdentificationStatus>;
};

/** Identification levels */
export type IdentificationLevels = {
  __typename: "IdentificationLevels";
  PVID: Scalars["Boolean"]["output"];
  QES: Scalars["Boolean"]["output"];
  expert: Scalars["Boolean"]["output"];
};

/** Process of the identification */
export type IdentificationProcess =
  /** Identity verified by an expert */
  | "Expert"
  /** Identity verified by an expert with a Remote Identity Verification Service */
  | "PVID"
  /** Identity verified by an expert and a Qualified Electronic Signature has been done */
  | "QES";

/** The type of the identity document */
export type IdentityDocumentType = "DriversLicense" | "IdCard" | "Passport" | "ResidencePermit";

/** Input to decide on digitalization */
export type InAPpDigitalizationInput = {
  /** The ID of a InApp Pending DigitalCard */
  digitalCardId: Scalars["String"]["input"];
  /** Response from swan to the provisioning request */
  provisioningResponse: ProvisioningResponse;
  /** Type of card */
  responseChannel: ResponseChannel;
};

export type InPersonCardMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "InPersonCardMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** The Merchant Payment Method payment amount limit */
  paymentAmountLimit?: Maybe<Amount>;
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

export type IncomingCheckRejectionReasonCodeEnum =
  | "AmountMismatch"
  | "BeneficiaryMissingOrIncorrect"
  | "CheckNotReceived"
  | "CheckReceivedLate"
  | "DateInvalid"
  | "DateMissing"
  | "DebtorNameMissing"
  | "EndorsementMissing"
  | "InvalidOrMissingAmount"
  | "SignatureMissing";

export type IncomingInternalDirectDebitRejectionReasonCodeEnum =
  | "AccountClosed"
  | "InsufficientFunds"
  | "ReasonNotSpecifiedByDebtor";

export type IncomingInternalDirectDebitReturnReasonCodeEnum =
  | "ReasonNotSpecifiedByBank"
  | "ReasonNotSpecifiedByDebtor"
  | "RefundRequestedByDebtor"
  | "RegulatoryReason";

/** Reason codes for returning an incoming international transfer */
export type IncomingInternationalCreditTransferReturnReasonCode =
  | "BeneficiaryAccountBlocked"
  | "BeneficiaryAccountClosed"
  | "BeneficiaryAccountUnknown"
  | "BeneficiaryDeceased"
  | "ReasonNotSpecifiedByBank"
  | "ReasonNotSpecifiedByBeneficiary"
  | "RegulatoryReason"
  | "TransactionDuplicated"
  | "TransactionOnAccountTypeNotAllowed";

/** Inputs for SEPA credit transfer */
export type IncomingSepaCreditTransferInput = {
  /** Credit transfer amount input */
  amount: AmountInput;
  /** Creditor address input */
  creditorAddress?: InputMaybe<AddressInput>;
  /** Creditor IBAN. Your Swan IBAN if you want to receive a credit transfer in your Swan account */
  creditorIban: Scalars["IBAN"]["input"];
  /** Creditor name */
  creditorName: Scalars["String"]["input"];
  /** Debtor address input */
  debtorAddress?: InputMaybe<AddressInput>;
  /** Debtor IBAN. It should be a valid IBAN */
  debtorIban: Scalars["IBAN"]["input"];
  /** Debtor name */
  debtorName: Scalars["String"]["input"];
  /** SEPA end to end reference. This information can't be updated once it's persisted. */
  endToEndId?: InputMaybe<Scalars["SepaReference"]["input"]>;
  /** Indicates that the transfer is received as an instant SEPA Credit transfer */
  isInstant?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Displayed label in Swan account */
  label?: InputMaybe<Scalars["String"]["input"]>;
};

export type IncomingSepaDirectDebitRejectionReasonCodeEnum =
  | "AccountClosed"
  | "InsufficientFunds"
  | "ReasonNotSpecifiedByDebtor";

export type IncomingSepaDirectDebitReturnReasonCodeEnum =
  | "AccountClosed"
  | "InsufficientFunds"
  | "ReasonNotSpecifiedByDebtor";

export type IncomingThreeDsStatus =
  | "Exempt"
  | "Failed"
  | "NotRequested"
  | "Requested"
  | "Succeeded";

/** Rejection returned if the transaction was of incorrect type */
export type IncorrectTransactionTypeRejection = Rejection & {
  __typename: "IncorrectTransactionTypeRejection";
  message: Scalars["String"]["output"];
};

export type IndividualRepresentative = {
  __typename: "IndividualRepresentative";
  /** Birth city of the representative. */
  birthCity?: Maybe<Scalars["String"]["output"]>;
  /** Postal code of the birth city. */
  birthCityPostalCode?: Maybe<Scalars["String"]["output"]>;
  /** Birth country code of the representative. */
  birthCountryCode?: Maybe<Scalars["CCA3"]["output"]>;
  /** Birth date of the representative. */
  birthDate?: Maybe<Scalars["String"]["output"]>;
  /** First name of the representative. */
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** Gender of the representative (Male, Female, or Unknown). */
  gender?: Maybe<Gender>;
  /** Last name of the representative. */
  lastName?: Maybe<Scalars["String"]["output"]>;
  /** Nationality of the representative. */
  nationality?: Maybe<Scalars["CCA3"]["output"]>;
  /** Preferred first name of the representative. */
  preferredFirstName?: Maybe<Scalars["String"]["output"]>;
  /** Residency address of the representative. */
  residencyAddress?: Maybe<AddressInformation>;
  /** List of representative roles. */
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** Individual shareholder info. */
export type IndividualShareholder = {
  __typename: "IndividualShareholder";
  /** Birth date of the shareholder. */
  birthDate: Scalars["String"]["output"];
  /** First name of the shareholder. */
  firstName: Scalars["String"]["output"];
  /** Last name of the shareholder. */
  lastName: Scalars["String"]["output"];
  /** CCA3 code for the country of nationality of the shareholder. */
  nationality: Scalars["CCA3"]["output"];
  /** Whether the shareholder is an individual or a company. */
  type: ShareholderType;
};

/**
 * Individual Ultimate Beneficial Owner
 * You need to describe the natural person (s) who hold, directly or indirectly, more than 25% of the capital or the rights of vote of the reporting company.
 * Please describe the company (s) that owns the company that wishes to open an account, when an individual holds in fine more than 25%
 */
export type IndividualUltimateBeneficialOwner = {
  __typename: "IndividualUltimateBeneficialOwner";
  /** individual birth city */
  birthCity?: Maybe<Scalars["String"]["output"]>;
  /** individual birth city postal code */
  birthCityPostalCode?: Maybe<Scalars["String"]["output"]>;
  /** individual birth country code */
  birthCountryCode?: Maybe<Scalars["CCA3"]["output"]>;
  /** individual birth date */
  birthDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** individual first name */
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** gender */
  gender?: Maybe<Gender>;
  /** Ultimate beneficial owner's identity document details */
  identityDocumentDetails?: Maybe<UboIdentityDocumentDetails>;
  /** Information relating to the type of the UBO */
  info: IndividualUltimateBeneficialOwnerInfo;
  /** individual last name */
  lastName?: Maybe<Scalars["String"]["output"]>;
  /** Individual beneficial owner residency Address */
  residencyAddress?: Maybe<AddressInformation>;
  /** Individual beneficial owner Tax or Identification Number */
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
};

/** Define the type of the UBO */
export type IndividualUltimateBeneficialOwnerInfo = {
  /** Individual type */
  type: IndividualUltimateBeneficialOwnerTypeEnum;
};

export type IndividualUltimateBeneficialOwnerInput = {
  /** Individual birth city. Length must be from 0 to 100 characters */
  birthCity?: InputMaybe<Scalars["String"]["input"]>;
  /** Individual birth city postal code. Length must be from 0 to 50 characters */
  birthCityPostalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Individual birth country code */
  birthCountryCode?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Individual birth date. Must be a valid date in the YYYY/MM/DD format */
  birthDate?: InputMaybe<Scalars["String"]["input"]>;
  /** Define UBO is a Direct Owner */
  direct?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Individual beneficial owner first name. Length must be from 0 to 100 characters */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /** Gender */
  gender?: InputMaybe<Gender>;
  /** Ultimate beneficial owner's identity document details */
  identityDocumentDetails?: InputMaybe<UboIdentityDocumentDetailsInput>;
  /** Define UBO is an Indirect Owner */
  indirect?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Individual beneficial owner last name. Length must be from 0 to 100 characters */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /** Individual beneficial owner residency address */
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
  /** Individual beneficial owner Tax or Identification Number */
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Total of capital (in percentage, ex: 50 = 50%). Must be between 1 and 100. */
  totalCapitalPercentage?: InputMaybe<Scalars["Float"]["input"]>;
  /** Define UBO is a Legal Representative */
  type?: InputMaybe<IndividualUltimateBeneficialOwnerTypeEnum>;
};

/** Individual Ultimate beneficial owner nature */
export type IndividualUltimateBeneficialOwnerTypeEnum =
  /** The Beneficial Owner have shares */
  | "HasCapital"
  /** The Beneficial Owner is the representant legal */
  | "LegalRepresentative"
  /** Other */
  | "Other";

/** Individual Ultimate Beneficial Owner Type Has Capital */
export type IndividualUltimateBeneficialOwnerTypeHasCapital =
  IndividualUltimateBeneficialOwnerInfo & {
    __typename: "IndividualUltimateBeneficialOwnerTypeHasCapital";
    /** Define UBO is an Direct Owner */
    direct?: Maybe<Scalars["Boolean"]["output"]>;
    /** Define UBO is an Indirect Owner */
    indirect?: Maybe<Scalars["Boolean"]["output"]>;
    /** Total of capital (in percentage, ex: 50 = 50%) */
    totalCapitalPercentage?: Maybe<Scalars["Float"]["output"]>;
    /** Individual type */
    type: IndividualUltimateBeneficialOwnerTypeEnum;
  };

/** Individual Ultimate Beneficial Owner Type Legal Representative */
export type IndividualUltimateBeneficialOwnerTypeLegalRepresentative =
  IndividualUltimateBeneficialOwnerInfo & {
    __typename: "IndividualUltimateBeneficialOwnerTypeLegalRepresentative";
    /** Individual type */
    type: IndividualUltimateBeneficialOwnerTypeEnum;
  };

/** Individual Ultimate Beneficial Owner Type Other */
export type IndividualUltimateBeneficialOwnerTypeOther = IndividualUltimateBeneficialOwnerInfo & {
  __typename: "IndividualUltimateBeneficialOwnerTypeOther";
  /** Individual type */
  type: IndividualUltimateBeneficialOwnerTypeEnum;
};

export type InstantFundingLimit = {
  __typename: "InstantFundingLimit";
  /** Maximum Instant Funding Amount authorized */
  amount: Amount;
  /** Instant Funding Amount that has already been used */
  funding?: Maybe<Amount>;
};

/** Rejection returned when the Account Holder Instant Funding limit has been exceeded */
export type InstantFundingLimitExceededRejection = Rejection & {
  __typename: "InstantFundingLimitExceededRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the Available balance is insufficient */
export type InsufficientFundsRejection = Rejection & {
  __typename: "InsufficientFundsRejection";
  message: Scalars["String"]["output"];
};

/** InternalDirectDebitB2BMerchantPaymentMethod */
export type InternalDirectDebitB2BMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

export type InternalDirectDebitMandate = {
  /** Unique identifier of the internal received direct debit mandate, generated by Swan */
  id: Scalars["ID"]["output"];
};

/** InternalDirectDebitStandardMerchantPaymentMethod */
export type InternalDirectDebitStandardMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

/** Rejection returned on unexpected server error */
export type InternalErrorRejection = Rejection & {
  __typename: "InternalErrorRejection";
  message: Scalars["String"]["output"];
};

/** Payment direct debit mandate for Internal */
export type InternalPaymentDirectDebitMandate = InternalDirectDebitMandate &
  PaymentDirectDebitMandate &
  PaymentMandate & {
    __typename: "InternalPaymentDirectDebitMandate";
    /** Account Holder information */
    accountHolder: AccountHolder;
    /** Creation date of the Internal Direct Debit Payment Mandate */
    createdAt: Scalars["DateTime"]["output"];
    /** Internal Direct Debit Payment Mandate creditor information */
    creditor: InternalPaymentMandateCreditor;
    /** Internal Direct Debit Payment Mandate debtor information */
    debtor: InternalPaymentMandateDebtor;
    /** Date of the the last transaction executed for the concerned Internal Direct Debit Payment Mandate */
    executedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Expiry date of the Internal Direct Debit Payment Mandate */
    expiredAt?: Maybe<Scalars["Date"]["output"]>;
    /** Unique identifier of the Internal Direct Debit Payment Mandate */
    id: Scalars["ID"]["output"];
    /** Language that will be used to produce the mandate PDF document */
    language: Scalars["String"]["output"];
    /** Internal Direct Debit Payment Mandate PDF document URL */
    mandateDocumentUrl: Scalars["String"]["output"];
    /** Custom name of the mandate */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Unique reference of the Internal Direct Debit Payment Mandate */
    reference: Scalars["String"]["output"];
    /** Internal Direct Debit Payment Mandate scheme */
    scheme: InternalPaymentMandateScheme;
    /** Internal Direct Debit Payment Mandate sequence */
    sequence: PaymentMandateSequence;
    /** Signature date of the Internal Direct Debit Payment Mandate */
    signatureDate?: Maybe<Scalars["Date"]["output"]>;
    /** Internal Direct Debit Payment Mandate status information */
    statusInfo: PaymentMandateStatusInfo;
    /** Internal direct debit ultimate creditor name */
    ultimateCreditorName?: Maybe<Scalars["String"]["output"]>;
    /** Last Update date of the Internal Direct Debit Payment Mandate */
    updatedAt: Scalars["DateTime"]["output"];
  };

export type InternalPaymentMandateCreditor = PaymentMandateCreditor & {
  __typename: "InternalPaymentMandateCreditor";
  /** Internal Direct Debit Payment Mandate creditor address */
  address: Address;
  /** Internal Direct Debit Payment Mandate creditor UUID */
  id: Scalars["ID"]["output"];
  /** Internal Direct Debit Payment Mandate Creditor Idenfier */
  identifier: Scalars["ID"]["output"];
  /** Internal Direct Debit Payment Mandate creditor name */
  name: Scalars["String"]["output"];
};

export type InternalPaymentMandateDebtor = PaymentMandateDebtor & {
  __typename: "InternalPaymentMandateDebtor";
  /** Internal Direct Debit Payment Mandate debtor address. Mandatory for non EEA Countries */
  accountId?: Maybe<Scalars["ID"]["output"]>;
  /** Internal Direct Debit Payment Mandate debtor address. Mandatory for non EEA Countries */
  address?: Maybe<Address>;
  /** Internal Direct Debit Payment Mandate debtor country */
  country: Scalars["CCA3"]["output"];
  /** Internal Direct Debit Payment Mandate debtor e-mail */
  email: Scalars["String"]["output"];
  /** Internal Direct Debit Payment Mandate debtor name */
  name: Scalars["String"]["output"];
};

export type InternalPaymentMandateScheme =
  /** Internal Direct Debit B2B */
  | "InternalDirectDebitB2b"
  /** Internal Direct Debit Standard */
  | "InternalDirectDebitStandard";

/** Received direct debit mandate for SEPA */
export type InternalReceivedDirectDebitMandate = InternalDirectDebitMandate &
  ReceivedDirectDebitMandate & {
    __typename: "InternalReceivedDirectDebitMandate";
    /** Account of the received internal direct debit mandate debtor */
    account?: Maybe<Account>;
    /** Creation date of the received internal direct debit mandate */
    createdAt: Scalars["DateTime"]["output"];
    /** Received internal direct debit creditor */
    creditor: InternalReceivedDirectDebitMandateCreditor;
    /** Date of the last internal direct debit transaction executed for the concerned received internal direct debit mandate */
    executedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Expiry date of the received internal direct debit mandate, computed automatically (36 months from the executedAt date) */
    expiredAt?: Maybe<Scalars["Date"]["output"]>;
    /** Iban of the received internal direct debit mandate debtor */
    iban: Scalars["IBAN"]["output"];
    /** Unique identifier of the received internal direct debit mandate, generated by Swan */
    id: Scalars["ID"]["output"];
    /** Mandate name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Received internal direct debit Unique Mandate Reference (UMR) */
    reference: Scalars["String"]["output"];
    /** Received internal direct debit mandate scheme */
    scheme: InternalReceivedDirectDebitMandateScheme;
    /** Received internal direct debit mandate sequence */
    sequence: InternalReceivedDirectDebitMandateSequence;
    /** Date of signature of the received internal direct debit mandate */
    signatureDate?: Maybe<Scalars["Date"]["output"]>;
    /** Mandate status information of the received internal direct debit mandate */
    statusInfo: ReceivedDirectDebitMandateStatusInfo;
    /** Received internal direct debit ultimate creditor name */
    ultimateCreditorName?: Maybe<Scalars["String"]["output"]>;
    /** Last Update date of the received internal direct debit mandate */
    updatedAt: Scalars["DateTime"]["output"];
    /** Version of the received internal direct debit mandate */
    version: Scalars["String"]["output"];
  };

/** Internal received direct debit mandate creditor */
export type InternalReceivedDirectDebitMandateCreditor = {
  __typename: "InternalReceivedDirectDebitMandateCreditor";
  /** Address of the creditor */
  address: Address;
  /** Creditor identifier */
  identifier: Scalars["String"]["output"];
  /** Name of the creditor */
  name: Scalars["String"]["output"];
};

/** Received internal direct debit mandate scheme */
export type InternalReceivedDirectDebitMandateScheme =
  /** When the received internal direct debit mandate can only be used for internal B2B direct debit transactions */
  | "InternalDirectDebitB2b"
  /** When the received internal direct debit mandate can only be used for internal Standard direct debit transactions */
  | "InternalDirectDebitStandard";

/** Internal received direct debit mandate sequence */
export type InternalReceivedDirectDebitMandateSequence =
  /** When the authorisation is given once by the Debtor to collect only one single internal direct debit */
  | "OneOff"
  /** When the authorisation by the Debtor can be used for regular internal direct debits initiated by the Creditor */
  | "Recurrent";

/** Rejection returned on invalid argument error */
export type InvalidArgumentRejection = Rejection & {
  __typename: "InvalidArgumentRejection";
  code: InvalidArgumentRejectionCode;
  fields: Array<InvalidArgumentRejectionField>;
  message: Scalars["String"]["output"];
};

export type InvalidArgumentRejectionCode = "INVALID_INPUT";

export type InvalidArgumentRejectionField = {
  __typename: "InvalidArgumentRejectionField";
  errors: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
};

export type InvalidIdentificationErrorReasonsRejection = Rejection & {
  __typename: "InvalidIdentificationErrorReasonsRejection";
  message: Scalars["String"]["output"];
};

/** Describes an invalid identification level for the process associated to this identification, and the invalid reason can be accessed */
export type InvalidIdentificationLevelStatusInfo = {
  __typename: "InvalidIdentificationLevelStatusInfo";
  /** The reasons why this identification level is invalid */
  reasons?: Maybe<Array<IdentificationInvalidReason>>;
  /** Always set to `Invalid` */
  status: SwanIdentificationStatus;
};

export type InvalidIdentificationLevelsRejection = Rejection & {
  __typename: "InvalidIdentificationLevelsRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned if phone number is not well formatted */
export type InvalidPhoneNumberRejection = Rejection & {
  __typename: "InvalidPhoneNumberRejection";
  message: Scalars["String"]["output"];
};

/** Invoice */
export type Invoice = {
  __typename: "Invoice";
  /** account id */
  accountId: Scalars["ID"]["output"];
  /** due amount */
  amount: Amount;
  /** ending date of the billing window */
  closingDate: Scalars["DateTime"]["output"];
  /** creation date */
  createdAt: Scalars["DateTime"]["output"];
  /** date at which the link will not be useable anymore */
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** unique id */
  id: Scalars["ID"]["output"];
  /** name of the invoice */
  name: Scalars["String"]["output"];
  /** starting date of the billing window */
  openingDate: Scalars["DateTime"]["output"];
  /** status of the invoice */
  status: InvoiceStatus;
  /** type of the invoice */
  type: InvoiceType;
  /** last update date */
  updatedAt: Scalars["DateTime"]["output"];
  /** temporary public url on which the file can be accessible */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Please see the Connection interface */
export type InvoiceConnection = Connection & {
  __typename: "InvoiceConnection";
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** Please see the Edge interface */
export type InvoiceEdge = Edge & {
  __typename: "InvoiceEdge";
  cursor: Scalars["String"]["output"];
  node: Invoice;
};

/** The different statuses of invoice */
export type InvoiceStatus = "Failed" | "NotPaid" | "Paid" | "PaymentDue" | "Pending" | "Voided";

export type InvoiceType = "Invoice" | "RefundNote";

export type LabelType = "Iso" | "OgmVcs" | "Structured" | "Unstructured";

/**
 * Rejection returned when you try to delete the last sandbox user.
 * At least one sandbox user should be present
 */
export type LastSandboxUserCannotBeDeletedRejection = Rejection & {
  __typename: "LastSandboxUserCannotBeDeletedRejection";
  /** Rejection message */
  message: Scalars["String"]["output"];
  /** Sandbox user ID */
  userId: Scalars["String"]["output"];
};

/** Mandate amendment input */
export type MandateAmendment = {
  /** Previous SEPA creditor identifier */
  previousCreditorIdentifier?: InputMaybe<Scalars["SepaCreditorIdentifier"]["input"]>;
  /** Previous SEPA debtor identifier */
  previousDebtorIban?: InputMaybe<Scalars["IBAN"]["input"]>;
  /** Previous mandate reference */
  previousMandateReference?: InputMaybe<Scalars["SepaReference"]["input"]>;
};

/** Banking fee which could add manually */
export type ManualBankingFee =
  /** Drafting a circularization letter for a legal entity holder */
  | "CirculationLetterDraftingFee"
  /** Drafting a confirmation letter for a legal entity holder */
  | "ConfirmationLetterDraftingFee"
  /** Issuance of a document */
  | "DocumentIssuance"
  /** Improper use of the account */
  | "ImproperUseOfAccount"
  /** Account inactive within the past 12 months */
  | "InactiveAccount"
  /** Processing of judicial or administrative seizures, notice to third party holders */
  | "ProcessingJudicialOrAdministrativeSeizure"
  /** SEPA creditor identifier request */
  | "SepaCreditorIdentifierRequest"
  /** Intervention fee for managing unauthorized overdrafts */
  | "UnauthorizedOverdraft";

/** Filters that can be applied when listing account memberships */
export type MembershipsFilterInput = {
  /** Can the user initiate payments on this account */
  canInitiatePayments?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Can the user manage account membership */
  canManageAccountMembership?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Can the user manage beneficiaries */
  canManageBeneficiaries?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** `true` if this account membership can manage cards for himself or to the memberships he manages */
  canManageCards?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Can the user view account */
  canViewAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Search by email
   *
   * @deprecated(reason: "use `search` instead")
   */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search by first name
   *
   * @deprecated(reason: "use `search` instead")
   */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search by last name
   *
   * @deprecated(reason: "use `search` instead")
   */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   * - First name
   * - Last name
   * - Email
   * - ID
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Account memberships status/statuses we're looking for */
  status?: InputMaybe<Array<AccountMembershipStatus>>;
};

export type Merchant = {
  /** Acquirer ID */
  acquirerId?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant city */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant code */
  code?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant country */
  country?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Merchant ID */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant postal Code */
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Sub merchant ID */
  subMerchantId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The different balances of the payment. Use this to understand in details what actions have been taken on the payment and what actions can be taken moving forward. */
export type MerchantBalance = {
  __typename: "MerchantBalance";
  /** The amount that can be canceled on this payment */
  availableToCancel: Amount;
  /** The amount that can be captured on this payment */
  availableToCapture: Amount;
  /** The amount that can be refunded on this payment */
  availableToRefund: Amount;
  /** The amount authorised */
  totalAuthorized: Amount;
  /** The amount canceled */
  totalCanceled: Amount;
  /** The amount captured */
  totalCaptured: Amount;
  /** The amount disputed */
  totalDisputed: Amount;
  /** The amount refunded */
  totalRefunded: Amount;
};

/** Rejection returned when the Merchant Card Payment is declined */
export type MerchantCardPaymentDeclinedRejection = Rejection & {
  __typename: "MerchantCardPaymentDeclinedRejection";
  message: Scalars["String"]["output"];
};

export type MerchantCategory =
  | "Culture"
  | "Entertainment"
  | "Finance"
  | "Groceries"
  | "HealthAndBeauty"
  | "HomeAndUtilities"
  | "Other"
  | "ProfessionalServices"
  | "PublicAdministrations"
  | "Restaurants"
  | "Shopping"
  | "Software"
  | "Transport"
  | "Travel";

export type MerchantPayment = {
  /** amount */
  amount: Amount;
  /**
   * Authorized date
   * @deprecated use authorizedAt in statusInfo instead
   */
  authorizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  balance: MerchantBalance;
  /** The billing address associated to the payment */
  billingAddress?: Maybe<Address>;
  /**
   * Canceled date
   * @deprecated use canceledAt in statusInfo instead
   */
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Captured date
   * @deprecated use capturedAt in statusInfo instead
   */
  capturedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Created date
   * @deprecated use createdAt in statusInfo instead
   */
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Disputed date
   * @deprecated use disputedAt in statusInfo instead
   */
  disputedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** an arbitrary identifier that was defined by you when you created this payment */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of a merchant payment */
  id: Scalars["ID"]["output"];
  /** Label */
  label?: Maybe<Scalars["String"]["output"]>;
  /** merchant profile associated to the merchant payment */
  merchantProfile: MerchantProfile;
  /**
   * payment link associated to the merchant payment
   * @deprecated The field is available on concrete types where relevant
   */
  paymentLink?: Maybe<MerchantPaymentLink>;
  /**
   * payment link associated to the merchant payment
   * @deprecated The field is available on concrete types where relevant
   */
  paymentMandate: PaymentMandate;
  /** payment method associated to the merchant payment */
  paymentMethod: MerchantPaymentMethod;
  reference?: Maybe<Scalars["String"]["output"]>;
  /**
   * Refunded date
   * @deprecated use refundedAt in statusInfo instead
   */
  refundedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Rejected date
   * @deprecated use rejectedAt in statusInfo instead
   */
  rejectedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** status information */
  statusInfo: MerchantPaymentStatusInfo;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Merchant Payment status authorized */
export type MerchantPaymentAuthorized = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentAuthorized";
  /** Authorized date */
  authorizedAt: Scalars["DateTime"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

/** Merchant Payment status canceled */
export type MerchantPaymentCanceled = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentCanceled";
  /** Canceled date */
  canceledAt: Scalars["DateTime"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

/** Merchant Payment status captured */
export type MerchantPaymentCaptured = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentCaptured";
  /** Authorized date */
  authorizedAt: Scalars["DateTime"]["output"];
  /** Captured date */
  capturedAt: Scalars["DateTime"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

/** Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type MerchantPaymentConnection = Connection & {
  __typename: "MerchantPaymentConnection";
  /** Edge list */
  edges: Array<MerchantPaymentEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Merchant Payment status disputed */
export type MerchantPaymentDisputed = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentDisputed";
  /** Authorized date */
  authorizedAt: Scalars["DateTime"]["output"];
  /** Captured date */
  capturedAt: Scalars["DateTime"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Disputed date */
  disputedAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

/** Implements the Relay Edge interface */
export type MerchantPaymentEdge = Edge & {
  __typename: "MerchantPaymentEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  node: MerchantPayment;
};

/** Filters that can be applied when listing merchant payments */
export type MerchantPaymentFiltersInput = {
  accountId?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by amount (amount is greater than a given amount) */
  amountGreaterThan?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** Filter by amount (amount is less than a given amount) */
  amountSmallerThan?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** Filter by createdAt (created after a given date) */
  isAfterCreatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by createdAt (created before a given date) */
  isBeforeCreatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by Method Type */
  paymentMethod?: InputMaybe<Array<MerchantPaymentMethodType>>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   *  - Label
   *  - Reference
   *  - External Reference
   *  - Amount
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by status */
  status?: InputMaybe<Array<MerchantPaymentStatus>>;
};

/** Merchant Payment status initiated */
export type MerchantPaymentInitiated = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentInitiated";
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

export type MerchantPaymentLink = {
  __typename: "MerchantPaymentLink";
  /** Amount to be paid to successfully complete the payment. */
  amount: Amount;
  /**
   * The customer billing Address
   * These fields should be completed also to pre-fill a SEPA direct debit mandate.
   *
   * We strongly advice to complete these fields if merchants want to get paid through card payment method, in order to minimize the risk of payment rejection by Visa / Mastercard schemes
   */
  billingAddress?: Maybe<Address>;
  /** URL to redirect the user to if they cancel their payment */
  cancelRedirectUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  /**
   *  We will use the information specified here to prefill the payment link fields
   * depending on the payment method the end user chooses.
   * Keep in mind that your end customer will be able to edit these fields.
   */
  customer?: Maybe<Customer>;
  /**
   * Any string that you want to be attached to this payment link.
   * Usually something to help you reference the link in an external system.
   */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** Merchant payment link's unique ID. */
  id: Scalars["String"]["output"];
  /** Label of the concerned payment collection, which will be displayed on Swan bank statement	and on the Swan merchant payment page. */
  label?: Maybe<Scalars["String"]["output"]>;
  /**
   * The language used for the payment page.
   * Default is the browser's language, or English if not available.
   */
  language?: Maybe<Scalars["String"]["output"]>;
  /** The Merchant Profile to link this Payment Link to */
  merchantProfile: MerchantProfile;
  /**
   * List of payment methods IDs enabled for this payment link.
   * If the array is empty Swan will allow all the payment methods that are enabled for the merchant profile (except for Check and Internal Direct Debit)
   */
  paymentMethods: Array<MerchantPaymentMethod>;
  /** ID of the related project */
  projectId: Scalars["ID"]["output"];
  /** Merchant Website URL to redirect the user to when the payment is completed. */
  redirectUrl?: Maybe<Scalars["String"]["output"]>;
  /**
   * Optional field intended to provide a way for you to include a reference number or code.
   * The customer will most likely see this value on their bank statement, though we can't know as every banking platform is different.
   */
  reference?: Maybe<Scalars["String"]["output"]>;
  /**
   *   A date that reflects the time at which the user asked the transaction to be executed.
   * For card transactions, request execution must occur within 7 days after authorization or the authorization may expire.
   * For SEPA Direct Debit transactions, request execution must occur up to 1 year in the future.
   *
   * Default value means that the execution will be as soon as possible
   */
  requestedExecutionAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Controls if the payment mandate created from this payment link is for one-time use or can be reused
   * This is applicable for card and SEPA Direct Debit payment methods only.
   */
  sequence: PaymentMandateSequence;
  /** The merchant payment link status. */
  statusInfo: MerchantPaymentLinkStatusInfo;
  /** The URL at which the customer can complete the payment. */
  url: Scalars["String"]["output"];
};

/** Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type MerchantPaymentLinkConnection = Connection & {
  __typename: "MerchantPaymentLinkConnection";
  /** Edge list */
  edges: Array<MerchantPaymentLinkEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type MerchantPaymentLinkEdge = Edge & {
  __typename: "MerchantPaymentLinkEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  node: MerchantPaymentLink;
};

/** Filters that can be applied when listing merchant payment links */
export type MerchantPaymentLinkFiltersInput = {
  /** Filter by amount (amount is greater than a given amount) */
  amountGreaterThan?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** Filter by amount (amount is less than a given amount) */
  amountSmallerThan?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** Filter by createdAt (created after a given date) */
  isAfterCreatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by createdAt (created before a given date) */
  isBeforeCreatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   *  - Label
   *  - Reference
   *  - Amount
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by status */
  status?: InputMaybe<Array<MerchantPaymentLinkStatus>>;
};

/** Field we can use when ordering that can be applied when listing merchant payment links */
export type MerchantPaymentLinkOrderByFieldInput = "createdAt" | "label" | "url";

/** Order that can be applied when listing merchant payment links */
export type MerchantPaymentLinkOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<MerchantPaymentLinkOrderByFieldInput>;
};

export type MerchantPaymentLinkStatus =
  /** Customers can still use the merchant payment link to pay. */
  | "Active"
  /** The customer completed the payment. */
  | "Completed"
  /** The merchant payment link is expired. */
  | "Expired";

export type MerchantPaymentLinkStatusInfo = {
  status: MerchantPaymentLinkStatus;
};

/** Base object for the different Payment Methods available */
export type MerchantPaymentMethod = {
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

/** The different rejection reasons for a CardMerchantPaymentMethod */
export type MerchantPaymentMethodCardRejectReason =
  | "SwanRefused"
  | "SwanTechnicalErrorOccurred"
  | "UnsupportedBusiness";

/** Rejection returned when the Merchant Payment Method is not active */
export type MerchantPaymentMethodNotActiveRejection = Rejection & {
  __typename: "MerchantPaymentMethodNotActiveRejection";
  message: Scalars["String"]["output"];
  paymentMethodIds?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type MerchantPaymentMethodRejectReason =
  | "SwanRefused"
  | "SwanTechnicalErrorOccurred"
  | "UnsupportedBusiness";

/** The different rejection reasons a MerchantPaymentMethod can have */
export type MerchantPaymentMethodRejectionReason =
  /** We gave a custom criteria to the partner and it’s in violation */
  | "ContractualCriteriaNotFulfilled"
  /** General rejection where we don't want to provide more info (eg, fraudster with sensitive info) */
  | "GenericRejection"
  /** Merchant denied or failed to provide a relevant requested information */
  | "InconsistentOrMissingInformation"
  /** Payment method requested makes no sense for the business model */
  | "InvalidUseCase"
  | "SuspiciousBehavior"
  /** General rejection where an error occurred on Swan's side. */
  | "SwanTechnicalErrorOccurred"
  | "UnsupportedActivity"
  /** Merchant profile is not supported */
  | "UnsupportedMerchantProfile"
  /** Partner isn’t allowed to request this payment method */
  | "UnsupportedPaymentMethod";

/** The different statuses a MerchantPaymentMethod can have */
export type MerchantPaymentMethodStatus =
  | "Disabled"
  | "Enabled"
  | "PendingReview"
  | "Rejected"
  | "Suspended"
  | "WaitingForInformation";

/** The payment method status information */
export type MerchantPaymentMethodStatusInfo = {
  /** Merchant Payment Method Status */
  status: MerchantPaymentMethodStatus;
};

/** The different statuses a MerchantPaymentMethod can have */
export type MerchantPaymentMethodType =
  | "Card"
  | "Check"
  | "InPersonCard"
  | "InternalDirectDebitB2b"
  | "InternalDirectDebitStandard"
  | "SepaDirectDebitB2b"
  | "SepaDirectDebitCore";

export type MerchantPaymentMethodUpdateRequest = {
  id: Scalars["ID"]["output"];
};

export type MerchantPaymentMethodWrongStatusRejection = Rejection & {
  __typename: "MerchantPaymentMethodWrongStatusRejection";
  message: Scalars["String"]["output"];
};

/** Field we can use when ordering that can be applied when listing merchant payments */
export type MerchantPaymentOrderByFieldInput =
  | "amount"
  | "createdAt"
  | "externalReference"
  | "label"
  | "status";

/** Order that can be applied when listing merchant payments */
export type MerchantPaymentOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<MerchantPaymentOrderByFieldInput>;
};

/** Merchant Payment status partially disputed */
export type MerchantPaymentPartiallyDisputed = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentPartiallyDisputed";
  /** Authorized date */
  authorizedAt: Scalars["DateTime"]["output"];
  /** Captured date */
  capturedAt: Scalars["DateTime"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Disputed date */
  disputedAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

/** Merchant Payment status rejected */
export type MerchantPaymentRejected = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentRejected";
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Rejected date */
  rejectedAt: Scalars["DateTime"]["output"];
  /** rejected reason */
  rejectedReasonCode: MerchantPaymentRejectedReason;
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

export type MerchantPaymentRejectedReason =
  | "AmountInvalid"
  | "BankRefused"
  | "CardDetailsInvalid"
  | "CardExpired"
  | "CardNotSupported"
  | "CheckNotReceived"
  | "CheckReceivedLate"
  | "DebtorAccountClosed"
  | "DebtorAccountConsumer"
  | "DebtorAccountUnknown"
  | "DebtorDeceased"
  | "InsufficientFunds"
  | "InvalidPinAttemptsExceeded"
  | "MandateInvalid"
  | "ReasonNotSpecifiedByBank"
  | "ReasonNotSpecifiedByDebtor"
  | "RegulatoryReason"
  | "RejectedByCardAcquirer"
  | "RejectedByCardIssuer"
  | "SoftDecline3dsExpiration"
  | "SoftDecline3dsFailure"
  | "SoftDecline3dsNotSupported"
  | "SoftDecline3dsRequired"
  | "SoftDeclineCardAmountLimitsExceeded"
  | "SoftDeclineCardDetailsInvalid"
  | "SoftDeclineCardExpired"
  | "SoftDeclineCardNotActivated"
  | "SoftDeclineCardNotSupported"
  | "SoftDeclineCvcCheckFailed"
  | "SoftDeclineCvcInvalid"
  | "SoftDeclineInsufficientFunds"
  | "SoftDeclineInvalidPinAttemptsExceeded"
  | "SoftDeclinePinInvalid"
  | "SoftDeclinePinRequired"
  | "SoftDeclineRefundTimeLimitExceeded"
  | "SoftDeclineRejectedByCardIssuer"
  | "SoftDeclineSwanTechnicalErrorOccurred"
  | "SoftDeclineTransactionAmountIncorrect"
  | "SuspiciousCheck"
  | "SwanRefused"
  | "SwanTechnicalErrorOccurred"
  | "TransactionDuplicated"
  | "TransactionOnAccountTypeNotAllowed"
  | "TransactionTypeNotAllowed";

/** Merchant Payment status */
export type MerchantPaymentStatus =
  | "Authorized"
  | "Canceled"
  | "Captured"
  | "Disputed"
  | "Initiated"
  | "PartiallyDisputed"
  | "Rejected";

/** Merchant Payment Status Information */
export type MerchantPaymentStatusInfo = {
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

/** Merchant Profile */
export type MerchantProfile = {
  __typename: "MerchantProfile";
  /**
   * Your accent color, used in white label interfaces.
   * This color would also be inherited in the Swan Merchant Payment page.
   */
  accentColor?: Maybe<Scalars["String"]["output"]>;
  /** The Account ID this Merchant Profile is linked to */
  accountId: Scalars["ID"]["output"];
  /** Additional information about the merchant profile */
  additionalInformation: Array<AdditionalInformation>;
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Where the payer are generally based. */
  customerRegion?: Maybe<MerchantProfileCustomerRegion>;
  /** expected average basket value. */
  expectedAverageBasket: Amount;
  /** Expected annual activity volumes for all payment method */
  expectedMonthlyMerchantProcessingVolume: ExpectedMonthlyMerchantProcessingVolume;
  /**
   * Expected annual activity volumes for all payment method
   * @deprecated use expectedMonthlyMerchantProcessingVolume instead
   */
  expectedMonthlyPaymentVolume: Amount;
  /** The Merchant Profile ID */
  id: Scalars["ID"]["output"];
  /**
   * Url of an example typical invoice issued by the merchant.
   * @deprecated Unused, will be removed in future versions
   */
  invoiceExampleUrl?: Maybe<Scalars["String"]["output"]>;
  /** Url of the merchant's logo */
  merchantLogoUrl?: Maybe<Scalars["String"]["output"]>;
  /** Business name of the merchant, i.e. name that will be displayed on debtors' bank statements */
  merchantName: Scalars["String"]["output"];
  /**
   * Returns a list of merchant payment links
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  merchantPaymentLinks?: Maybe<MerchantPaymentLinkConnection>;
  /** Payment Methods associated */
  merchantPaymentMethods?: Maybe<Array<MerchantPaymentMethod>>;
  /**
   * Returns a list of merchant payments
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  merchantPayments?: Maybe<MerchantPaymentConnection>;
  /**
   * Url of the merchant's website
   * @deprecated Use merchantWebsiteUrl instead
   */
  merchantWebsite?: Maybe<Scalars["String"]["output"]>;
  /** Url of the merchant's website */
  merchantWebsiteUrl?: Maybe<Scalars["String"]["output"]>;
  /** The type of payments accepted by the merchant. Can be OneOff (no returning payers in general), Recurrent (returning payers), or a mix of both OneOffAndRecurrent. */
  paymentFrequency?: Maybe<MerchantProfilePaymentFrequency>;
  /** Type of product sold. List of value: Goods, Services, VirtualGoods, GiftsAndDonations. Gifts and donations can be club subscription or collection of donations (for associations), tips collection, contributions for local authorities */
  productType: ProductType;
  /** Update Requested associated */
  requestMerchantProfileUpdate?: Maybe<RequestMerchantProfileUpdate>;
  /**
   * Updates Requested associated
   * @deprecated Field no longer supported
   */
  requestedMerchantProfileUpdates?: Maybe<Array<RequestMerchantProfileUpdate>>;
  /**
   * The URL of the main social network of the merchant.
   * @deprecated use socialNetworkUrl instead
   */
  socialNetwork?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the main social network of the merchant. */
  socialNetworkUrl?: Maybe<Scalars["String"]["output"]>;
  /** The status of the merchant profile */
  statusInfo: MerchantProfileStatusInfo;
  /**
   * The URL of the support website or help center of the merchant.
   * @deprecated use supportWebsiteUrl instead
   */
  supportWebsite?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the support website or help center of the merchant. */
  supportWebsiteUrl?: Maybe<Scalars["String"]["output"]>;
  /**
   * The URL of the terms and conditions of the merchant.
   * @deprecated use termsAndConditionsUrl instead
   */
  termsAndConditions?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the terms and conditions of the merchant. */
  termsAndConditionsUrl?: Maybe<Scalars["String"]["output"]>;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Merchant Profile */
export type MerchantProfileMerchantPaymentLinksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<MerchantPaymentLinkFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<MerchantPaymentLinkOrderByInput>;
};

/** Merchant Profile */
export type MerchantProfileMerchantPaymentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<MerchantPaymentFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<MerchantPaymentOrderByInput>;
};

export type MerchantProfileCustomerRegion = "Domestic" | "European" | "International";

export type MerchantProfileNotValidRejection = Rejection & {
  __typename: "MerchantProfileNotValidRejection";
  message: Scalars["String"]["output"];
};

export type MerchantProfilePaymentFrequency = "OneOff" | "OneOffAndRecurrent" | "Recurrent";

/** RejectedMerchantProfileRejectionReasonEnum */
export type MerchantProfileRejectionReason =
  /** Doesn’t respect a custom criteria discussed with partners */
  | "ContractualCriteriaNotFulfilled"
  /** Duplicate profile found by the risk team (or in the future programmatically) */
  | "DuplicateProfile"
  /** General rejection where we don't want to provide more info (eg, fraudster with sensitive info) */
  | "GenericRejection"
  /** Something is highly inconsistent, for example a completely different unrelated website */
  | "InconsistentOrMissingInformation"
  /** Risk alerting popped up for a weird processing pattern */
  | "SuspiciousBehavior"
  /** Prohibited activity/NACE code, automatically applied if there's a hit/match */
  | "UnsupportedActivity";

/** Merchant Profile Statuses */
export type MerchantProfileStatus =
  /** Disabled */
  | "Disabled"
  /** Enabled */
  | "Enabled"
  /** A Merchant Profile is created in the PendingReview status */
  | "PendingReview"
  /** Rejected */
  | "Rejected"
  /** Suspended */
  | "Suspended";

/** Merchant Profile Status Information */
export type MerchantProfileStatusInfo = {
  status: MerchantProfileStatus;
};

export type MerchantProfileUpdateRequestPendingRejection = Rejection & {
  __typename: "MerchantProfileUpdateRequestPendingRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the Merchant Profile is not in the expected status */
export type MerchantProfileWrongStatusRejection = Rejection & {
  __typename: "MerchantProfileWrongStatusRejection";
  currentStatus: MerchantProfileStatus;
  expectedStatus: MerchantProfileStatus;
  message: Scalars["String"]["output"];
};

export type MerchantRequirementType =
  | "CustomerRegion"
  | "ExpectedAverageBasket"
  | "ExpectedMonthlyMerchantProcessingVolume"
  | "MerchantWebsite"
  | "PaymentFrequency"
  | "ProductType"
  | "SocialNetwork"
  | "SupportWebsite"
  | "TermsAndConditions";

export type MerchantRequirements = {
  __typename: "MerchantRequirements";
  fields: Array<MerchantRequirementType>;
};

export type MerchantSubCategory =
  | "AdvertisingAndMarketing"
  | "Airlines"
  | "AtmWithdrawal"
  | "BarsAndRestaurants"
  | "BookkeepingAndConsultancy"
  | "BooksAndNewspapers"
  | "CarRental"
  | "CharityAndNonProfitOrganizations"
  | "CigarShops"
  | "CinemasAndShows"
  | "ClothingShoesAndAccessories"
  | "CoffeeAndBakeries"
  | "ComputersAndElectronicDevices"
  | "ConstructionAndOddJobs"
  | "CourierAndLogistics"
  | "DepartmentStores"
  | "Education"
  | "EnergyProviders"
  | "FerriesAndBoats"
  | "FinancialServices"
  | "FitnessAndSports"
  | "Flowers"
  | "FoodDelivery"
  | "Furniture"
  | "GamblingAndBettingActivities"
  | "GamesAndToys"
  | "Gardening"
  | "GovernmentAndCityCouncils"
  | "Hairdressing"
  | "HardwareStores"
  | "Healthcare"
  | "HotelsAndAccommodation"
  | "HouseholdItems"
  | "HrAndRecruiting"
  | "IndustrialCleaning"
  | "Insurance"
  | "Laundries"
  | "LegalActivities"
  | "LiquorStore"
  | "MetroBusAndTrains"
  | "MotorVehiclesRepairsAndAccessories"
  | "Museums"
  | "OfficeRental"
  | "Other"
  | "OtherLeisureActivities"
  | "OtherProfessionalServices"
  | "OtherStores"
  | "OtherTransportProviders"
  | "PerfumesAndCosmetics"
  | "Pets"
  | "Pharmacies"
  | "PhoneAndInternetServicesProviders"
  | "PrivateMobilityServices"
  | "PubsAndNightclubs"
  | "RealEstate"
  | "ReligiousOrganizations"
  | "ServiceStations"
  | "SoftwareServices"
  | "SpaAndBeautyTreatments"
  | "StationaryServices"
  | "StreamingPlatforms"
  | "SupermarketsAndOtherGroceryStores"
  | "ThemeParks"
  | "TicketsAndEvents"
  | "TollsAndParkings"
  | "TravelAgents"
  | "VideoGames";

export type MerchantVerificationRequirementInput = {
  additionalInformation?: InputMaybe<Array<AdditionalInformationType>>;
  fields?: InputMaybe<Array<MerchantRequirementType>>;
  otherAdditionalInformation?: InputMaybe<Array<Scalars["String"]["input"]>>;
  supportingDocumentPurposes?: InputMaybe<Array<SupportingDocumentPurposeEnum>>;
};

export type MerchantVerificationRequirements =
  | AdditionalInformationRequirements
  | MerchantRequirements
  | OtherAdditionalInformationRequirements
  | SupportingDocumentRequirements;

export type MissingAddressItemRejection = Rejection & {
  __typename: "MissingAddressItemRejection";
  addressLine1?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
};

/** Monthly income. */
export type MonthlyIncome =
  /** between 500 and 1500 */
  | "Between500And1500"
  /** between 1500 and 3000 */
  | "Between1500And3000"
  /** between 3000 and 4500 */
  | "Between3000And4500"
  /** less than 500 */
  | "LessThan500"
  /** more than 4500 */
  | "MoreThan4500";

/** Monthly payment volume. */
export type MonthlyPaymentVolume =
  | "Between10000And50000"
  | "Between50000And100000"
  | "LessThan10000"
  | "MoreThan100000";

export type MonthlyPeriod = {
  __typename: "MonthlyPeriod";
  dayOfMonth: Scalars["Int"]["output"];
};

export type Mutation = {
  __typename: "Mutation";
  /** Create a sandbox identification */
  createSandboxIdentification: CreateSandboxIdentificationPayload;
  /**
   * Create a sandbox user
   * This mutation is restricted to a User access token
   */
  createSandboxUser: CreateSandboxUserPayload;
  /**
   * Delete a sandbox user
   * This mutation is restricted to a User access token
   */
  deleteSandboxUser: DeleteSandboxUserPayload;
  /**
   * Log sandbox user
   * This mutation is restricted to a User access token
   */
  endorseSandboxUser: EndorseSandboxUserPayload;
  /** Generate a CMC7 with its RLMC key usable for test purpose */
  generateTestCheck: GenerateCheckPayload;
  /**
   * Mutation to simulate the reception of a physical card.
   * Requires a physical card in a valid state for reception.
   */
  physicalCardReception: PhysicalCardReceptionPayload;
  /**
   * Mutation to promote an account holder to the role of project owner.
   * Requires the account holder identifier to be promoted to Project Owner.
   * Beware, if another account holder had this role, they will lose it.
   */
  promoteAccountHolderToProjectOwner: PromoteAccountHolderToProjectOwnerPayload;
  requestSupportingDocuments: RequestSupportingDocumentsPayload;
  /** Mutation to simulate a capital deposit case approval. */
  simulateApproveCapitalDepositCase: SimulateApproveCapitalDepositCasePayload;
  /** Mutation to simulate an update of capital deposit document status. */
  simulateCapitalDepositDocumentStatus: SimulateCapitalDepositDocumentStatusPayload;
  /** Simulation to insert card transaction enrichment infos manualy */
  simulateCardTransactionEnrichment: SimulateCardTransactionEnrichmentPayload;
  /** Request a credit limit with given settings */
  simulateCreditLimitUpdated?: Maybe<SimulateCreditLimitUpdatedResponse>;
  /**
   * Mutation to give decision on digitalization.
   * If more than one InApp digitalization process are ongoing, only the latest one will be acted upon
   */
  simulateInAppProvisioningCompletion: SimulationResponse;
  /** Simulate the authorization of a card merchant payment */
  simulateIncomingCardAuthorization: SimulateIncomingCardAuthorizationPayload;
  /** After an incoming Card transaction has been scheduled, simulate the corresponding transaction being booked on the Swan creditor account. */
  simulateIncomingCardBooking: SimulateIncomingCardBookingPayload;
  /** After an incoming Check has been scheduled, simulate the corresponding transaction being booked on the Swan creditor account. */
  simulateIncomingCheckBooking: SimulateIncomingCheckBookingPayload;
  /** After an incoming Check has been sent, simulate the corresponding transaction being rejected on the Swan creditor account. */
  simulateIncomingCheckRejection: SimulateIncomingCheckRejectionPayload;
  /** After an incoming Check has been booked, simulate the corresponding transaction being returned from the Swan creditor account. */
  simulateIncomingCheckReturn: SimulateIncomingCheckReturnPayload;
  /** After an incoming Internal Direct Debit has been scheduled, simulate the corresponding transaction being booked on the Swan creditor account. */
  simulateIncomingInternalDirectDebitBooking: SimulateIncomingInternalDirectDebitBookingPayload;
  /** After an incoming Internal Direct Debit has been sent, simulate the corresponding transaction being rejected on the Swan creditor account. */
  simulateIncomingInternalDirectDebitRejection: SimulateIncomingInternalDirectDebitRejectionPayload;
  /** After an incoming Internal Direct Debit has been sent, simulate the corresponding transaction being returned. */
  simulateIncomingInternalDirectDebitReturn: SimulateIncomingInternalDirectDebitReturnPayload;
  /** Simulate an incoming international credit transfer */
  simulateIncomingInternationalCreditTransferReception: SimulateIncomingInternationalCreditTransferPayload;
  /** Simulate Swan returning an Incoming International Credit Transfer Return request. */
  simulateIncomingInternationalCreditTransferReturn: SimulateIncomingInternationalCreditTransferReturnPayload;
  /** After a SEPA Credit Transfer has credited a Swan account, simulate an authorized account member accepting a recall request, and the subsequent return of funds to the issuer. */
  simulateIncomingSepaCreditTransferAcceptedRecall: SimulateIncomingSepaCreditTransferAcceptedRecallPayload;
  /** Simulate when a SEPA Credit Transfer credits the account */
  simulateIncomingSepaCreditTransferReception: SimulateIncomingSepaCreditTransferReceptionPayload;
  /** After a SEPA Credit Transfer has credited a Swan account, simulate an authorized account member returning funds to the issuer. */
  simulateIncomingSepaCreditTransferReturn: SimulateIncomingSepaCreditTransferReturnPayload;
  /** After an incoming SEPA Direct Debit has been sent for execution to Sepa, simulate the corresponding transaction being booked on the Swan creditor account. */
  simulateIncomingSepaDirectDebitBooking: SimulateIncomingSepaDirectDebitBookingPayload;
  /** After an incoming SEPA Direct Debit has been sent for execution to Sepa, simulate the corresponding transaction being rejected on the Swan creditor account. */
  simulateIncomingSepaDirectDebitRejection: SimulateIncomingSepaDirectDebitRejectionPayload;
  /** After an incoming SEPA Direct Debit has been booked, simulate the corresponding transaction being returned from the Swan creditor account. */
  simulateIncomingSepaDirectDebitReturn: SimulateIncomingSepaDirectDebitReturnPayload;
  /** Simulation to enable an insurance subscription */
  simulateInsuranceSubscriptionEnablement: SimulateInsuranceSubscriptionEnablementPayload;
  /**
   * Mutation to simulate the generation of an account invoice
   * This invoice will contain all banking fees related to the account
   */
  simulateInvoiceGeneration?: Maybe<SimulateInvoiceGenerationPayload>;
  /** Mutation to simulate a banking fee manually added by the Swan Team */
  simulateManualBankingFee?: Maybe<SimulateManualBankingFeePayload>;
  /** Mutation to simulate a manual provisioning */
  simulateManualProvisioning: SimulationResponse;
  /** Simulate the update of a Merchant Payment Method */
  simulateMerchantPaymentMethodRequestOutcome: SimulateMerchantPaymentMethodRequestOutcomePayload;
  /** Simulate the approval or rejection of a merchant payment method update request */
  simulateMerchantPaymentMethodUpdateRequestOutcome: SimulateMerchantPaymentMethodUpdateRequestOutcomePayload;
  /** Simulate the update of a Merchant Profile */
  simulateMerchantProfileRequestOutcome: SimulateMerchantProfileRequestOutcomePayload;
  /** Simulate the approval or rejection of a merchant profile update request */
  simulateMerchantProfileUpdateRequestOutcome: SimulateMerchantProfileUpdateRequestOutcomePayload;
  /** Simulate a card advice (amendment) received for a previous authorization for a card issued on a Swan account. */
  simulateOutgoingCardAdvice: SimulateOutgoingCardAuthorizationPayload;
  /** Simulate a card authorization request being received for a card issued on a Swan account. */
  simulateOutgoingCardAuthorization: SimulateOutgoingCardAuthorizationPayload;
  /** Simulate a card authorization release being received for a card authorization. */
  simulateOutgoingCardAuthorizationRelease: SimulateOutgoingCardAuthorizationReleasePayload;
  /** Simulate the reception of a card credit on a Swan account. */
  simulateOutgoingCardCredit: SimulateOutgoingCardCreditPayload;
  /** After a Card Credit has been booked on a Swan account, simulate the merchant reversing the transaction and the subsequent debit of funds from the Swan account. */
  simulateOutgoingCardCreditReverse: SimulateOutgoingCardCreditReversePayload;
  /** Simulate a card debit being received on a previously authorized card transaction. */
  simulateOutgoingCardDebit: SimulateOutgoingCardDebitPayload;
  /** After a Card Debit has been booked on a Swan account, simulate the merchant reversing the transaction and the subsequent return of funds to the Swan account. */
  simulateOutgoingCardDebitReverse: SimulateOutgoingCardDebitReversePayload;
  /** After an outgoing International Credit Transfer has been sent for execution to Swan, simulate the corresponding transaction being booked on the Swan debtor account. */
  simulateOutgoingInternationalCreditTransferBooking: SimulateOutgoingInternationalCreditTransferBookingPayload;
  /** Simulate Swan rejecting an outgoing International Credit Transfer request, for compliance reasons. */
  simulateOutgoingInternationalCreditTransferRejection: SimulateOutgoingInternationalCreditTransferRejectionPayload;
  /** Simulate Swan returning an outgoing International Credit Transfer request. */
  simulateOutgoingInternationalCreditTransferReturn: SimulateOutgoingInternationalCreditTransferReturnPayload;
  /** Simulate the return of funds to a Swan account, following a recall request by an authorized account member of that account and the acceptance by the beneficiary. */
  simulateOutgoingSepaCreditTransferAcceptedRecall: SimulateOutgoingSepaCreditTransferAcceptedRecallPayload;
  /** After an outgoing SEPA Credit Transfer has been sent for execution to Swan, simulate the corresponding transaction being booked on the Swan debtor account. */
  simulateOutgoingSepaCreditTransferBooking: SimulateOutgoingSepaCreditTransferBookingPayload;
  /** Simulate Swan rejecting an outgoing SEPA Credit Transfer request, for compliance reasons. */
  simulateOutgoingSepaCreditTransferRejection: SimulateOutgoingSepaCreditTransferRejectionPayload;
  /** Simulate a beneficiary bank returning funds to a Swan account after a SEPA Credit Transfer debited the account. */
  simulateOutgoingSepaCreditTransferReturn: SimulateOutgoingSepaCreditTransferReturnPayload;
  /** Simulate a creditor cancelling an incoming SEPA Direct Debit instruction sent to debit a Swan account, before the execution/debit date. */
  simulateOutgoingSepaDirectDebitCancel: SimulateOutgoingSepaDirectDebitCancelPayload;
  /** Simulate a Swan account receiving a SEPA Direct Debit instruction and being debited. */
  simulateOutgoingSepaDirectDebitReception: SimulateOutgoingSepaDirectDebitReceptionPayload;
  /** Simulate a Swan debtor rejecting a SEPA Direct Debit instruction they’ve already received, before the execution/debit date */
  simulateOutgoingSepaDirectDebitReject: SimulateOutgoingSepaDirectDebitRejectPayload;
  /** After a SEPA Direct Debit instruction has been received and the transaction was booked on a Swan debtor account, simulate a refund request by an authorized account member and the subsequent return of funds to their account. */
  simulateOutgoingSepaDirectDebitReturn: SimulateOutgoingSepaDirectDebitReturnPayload;
  /** After a SEPA Direct Debit instruction has been received and the transaction was booked on a Swan debtor account, simulate the creditor reversing the transaction and the subsequent return of funds to the Swan account */
  simulateOutgoingSepaDirectDebitReverse: SimulateOutgoingSepaDirectDebitReversePayload;
  /**
   * Mutation to simulate delivery of a physical card.
   * Requires a physical card in a valid state for delivery.
   */
  simulatePhysicalCardDelivery: SimulationResponse;
  /** Simulate physical card renewal process. */
  simulatePhysicalCardRenewalProcess: SimulatePhysicalCardRenewalProcessPayload;
  /** Release reserved balance associate to a transaction id. */
  simulateReleaseReservedBalance: SimulateReleaseReservedBalancePayload;
  /** Perform a repayment */
  simulateRepayment?: Maybe<SimulateRepaymentResponse>;
  /** Simulate a repayment status modification from the credit provider */
  simulateRepaymentUpdated?: Maybe<SimulateRepaymentUpdatedResponse>;
  /**
   * Mutation to simulate the start of the billing for a given project, which occurs generally when the project go Live (Partner billing)
   *
   * This mutation is restricted to a Project access token ([Learn More](https://docs.swan.io/api/authentication)).
   */
  simulateStartProjectBilling?: Maybe<SimulateStartProjectBillingPayload>;
  /** Change the loan status to TO_REPAY */
  simulateToRepayLoan?: Maybe<SimulateToRepayLoanResponse>;
  updateAccountHolder: UpdateAccountHolderPayload;
  /**
   * Update the account holder funding limit
   * @deprecated Use mutation updateFundingLimitSettingsChangeRequest in sandbox-partner-admin instead.
   */
  updateAccountHolderFundingLimits?: Maybe<UpdateAccountHolderFundingLimitsPayload>;
  /** Simulate Swan processing on Account Verification */
  updateAccountVerificationStatus: UpdateAccountVerificationStatusPayload;
  updateFundingLimitSettingsChangeRequest: UpdateFundingLimitSettingsChangeRequestPayload;
  /** Update a sandbox identification */
  updateSandboxIdentification: UpdateSandboxIdentificationPayload;
  /**
   * Updates a sandbox user
   * This mutation is restricted to a User access token
   */
  updateSandboxUser: UpdateSandboxUserPayload;
  updateSupportingDocumentCollectionStatus: UpdateSupportingDocumentCollectionStatusPayload;
  updateSupportingDocumentStatus: UpdateSupportingDocumentStatusPayload;
};

export type MutationCreateSandboxIdentificationArgs = {
  input: CreateSandboxIdentificationInput;
};

export type MutationCreateSandboxUserArgs = {
  input: CreateSandboxUserInput;
};

export type MutationDeleteSandboxUserArgs = {
  input: DeleteSandboxUserInput;
};

export type MutationEndorseSandboxUserArgs = {
  input: EndorseSandboxUserInput;
};

export type MutationGenerateTestCheckArgs = {
  input: GenerateCheckInput;
};

export type MutationPhysicalCardReceptionArgs = {
  input: PhysicalCardReceptionInput;
};

export type MutationPromoteAccountHolderToProjectOwnerArgs = {
  input: PromoteAccountHolderToProjectOwnerInput;
};

export type MutationRequestSupportingDocumentsArgs = {
  input: RequestSupportingDocumentsInput;
};

export type MutationSimulateApproveCapitalDepositCaseArgs = {
  input: SimulateApproveCapitalDepositCaseInput;
};

export type MutationSimulateCapitalDepositDocumentStatusArgs = {
  input: SimulateCapitalDepositDocumentStatusInput;
};

export type MutationSimulateCardTransactionEnrichmentArgs = {
  input: SimulateCardTransactionEnrichmentInput;
};

export type MutationSimulateCreditLimitUpdatedArgs = {
  input: SimulateCreditLimitUpdatedWebhookInput;
};

export type MutationSimulateInAppProvisioningCompletionArgs = {
  input: InAPpDigitalizationInput;
};

export type MutationSimulateIncomingCardAuthorizationArgs = {
  input: SimulateIncomingCardAuthorizationInput;
};

export type MutationSimulateIncomingCardBookingArgs = {
  input: SimulateIncomingCardBookingInput;
};

export type MutationSimulateIncomingCheckBookingArgs = {
  input: SimulateIncomingCheckBookingInput;
};

export type MutationSimulateIncomingCheckRejectionArgs = {
  input: SimulateIncomingCheckRejectionInput;
};

export type MutationSimulateIncomingCheckReturnArgs = {
  input: SimulateIncomingCheckReturnInput;
};

export type MutationSimulateIncomingInternalDirectDebitBookingArgs = {
  input: SimulateIncomingInternalDirectDebitBookingInput;
};

export type MutationSimulateIncomingInternalDirectDebitRejectionArgs = {
  input: SimulateIncomingInternalDirectDebitRejectionInput;
};

export type MutationSimulateIncomingInternalDirectDebitReturnArgs = {
  input: SimulateIncomingInternalDirectDebitReturnInput;
};

export type MutationSimulateIncomingInternationalCreditTransferReceptionArgs = {
  input: SimulateIncomingInternationalCreditTransferInput;
};

export type MutationSimulateIncomingInternationalCreditTransferReturnArgs = {
  input: SimulateIncomingInternationalCreditTransferReturnInput;
};

export type MutationSimulateIncomingSepaCreditTransferAcceptedRecallArgs = {
  input: SimulateIncomingSepaCreditTransferAcceptedRecallInput;
};

export type MutationSimulateIncomingSepaCreditTransferReceptionArgs = {
  input: IncomingSepaCreditTransferInput;
};

export type MutationSimulateIncomingSepaCreditTransferReturnArgs = {
  input: SimulateIncomingSepaCreditTransferReturnInput;
};

export type MutationSimulateIncomingSepaDirectDebitBookingArgs = {
  input: SimulateIncomingSepaDirectDebitBookingInput;
};

export type MutationSimulateIncomingSepaDirectDebitRejectionArgs = {
  input: SimulateIncomingSepaDirectDebitRejectionInput;
};

export type MutationSimulateIncomingSepaDirectDebitReturnArgs = {
  input: SimulateIncomingSepaDirectDebitReturnInput;
};

export type MutationSimulateInsuranceSubscriptionEnablementArgs = {
  input: SimulateInsuranceSubscriptionEnablementInput;
};

export type MutationSimulateInvoiceGenerationArgs = {
  input: SimulateInvoiceGenerationInput;
};

export type MutationSimulateManualBankingFeeArgs = {
  input: SimulateManualBankingFeeInput;
};

export type MutationSimulateManualProvisioningArgs = {
  input: DigitalizationInput;
};

export type MutationSimulateMerchantPaymentMethodRequestOutcomeArgs = {
  input: SimulateMerchantPaymentMethodRequestOutcomeInput;
};

export type MutationSimulateMerchantPaymentMethodUpdateRequestOutcomeArgs = {
  input: SimulateMerchantPaymentMethodUpdateRequestOutcomeInput;
};

export type MutationSimulateMerchantProfileRequestOutcomeArgs = {
  input: SimulateMerchantProfileRequestOutcomeInput;
};

export type MutationSimulateMerchantProfileUpdateRequestOutcomeArgs = {
  input: SimulateMerchantProfileUpdateRequestOutcomeInput;
};

export type MutationSimulateOutgoingCardAdviceArgs = {
  input: SimulateOutgoingCardAdviceInput;
};

export type MutationSimulateOutgoingCardAuthorizationArgs = {
  input: SimulateOutgoingCardAuthorizationInput;
};

export type MutationSimulateOutgoingCardAuthorizationReleaseArgs = {
  input: SimulateOutgoingCardAuthorizationReleaseInput;
};

export type MutationSimulateOutgoingCardCreditArgs = {
  input: SimulateOutgoingCardCreditInput;
};

export type MutationSimulateOutgoingCardCreditReverseArgs = {
  input: SimulateOutgoingCardCreditReverseInput;
};

export type MutationSimulateOutgoingCardDebitArgs = {
  input: SimulateOutgoingCardDebitInput;
};

export type MutationSimulateOutgoingCardDebitReverseArgs = {
  input: SimulateOutgoingCardDebitReverseInput;
};

export type MutationSimulateOutgoingInternationalCreditTransferBookingArgs = {
  input: SimulateOutgoingInternationalCreditTransferBookingInput;
};

export type MutationSimulateOutgoingInternationalCreditTransferRejectionArgs = {
  input: SimulateOutgoingInternationalCreditTransferRejectionInput;
};

export type MutationSimulateOutgoingInternationalCreditTransferReturnArgs = {
  input: SimulateOutgoingInternationalCreditTransferReturnInput;
};

export type MutationSimulateOutgoingSepaCreditTransferAcceptedRecallArgs = {
  input: SimulateOutgoingSepaCreditTransferAcceptedRecallInput;
};

export type MutationSimulateOutgoingSepaCreditTransferBookingArgs = {
  input: SimulateOutgoingSepaCreditTransferBookingInput;
};

export type MutationSimulateOutgoingSepaCreditTransferRejectionArgs = {
  input: SimulateOutgoingSepaCreditTransferRejectionInput;
};

export type MutationSimulateOutgoingSepaCreditTransferReturnArgs = {
  input: SimulateOutgoingSepaCreditTransferReturnInput;
};

export type MutationSimulateOutgoingSepaDirectDebitCancelArgs = {
  input: SimulateOutgoingSepaDirectDebitCancelInput;
};

export type MutationSimulateOutgoingSepaDirectDebitReceptionArgs = {
  input: SimulateOutgoingSepaDirectDebitReceptionInput;
};

export type MutationSimulateOutgoingSepaDirectDebitRejectArgs = {
  input: SimulateOutgoingSepaDirectDebitRejectInput;
};

export type MutationSimulateOutgoingSepaDirectDebitReturnArgs = {
  input: SimulateOutgoingSepaDirectDebitReturnInput;
};

export type MutationSimulateOutgoingSepaDirectDebitReverseArgs = {
  input: SimulateOutgoingSepaDirectDebitReverseInput;
};

export type MutationSimulatePhysicalCardDeliveryArgs = {
  input: SimulatePhysicalCardDeliveryInput;
};

export type MutationSimulatePhysicalCardRenewalProcessArgs = {
  input: SimulatePhysicalCardRenewalProcessInput;
};

export type MutationSimulateReleaseReservedBalanceArgs = {
  input: SimulateReleaseReservedBalanceInput;
};

export type MutationSimulateRepaymentArgs = {
  input: SimulateRepaymentInput;
};

export type MutationSimulateRepaymentUpdatedArgs = {
  input: SimulateRepaymentUpdatedInput;
};

export type MutationSimulateStartProjectBillingArgs = {
  input: SimulateStartProjectBillingInput;
};

export type MutationSimulateToRepayLoanArgs = {
  input: SimulateToRepayLoanInput;
};

export type MutationUpdateAccountHolderArgs = {
  input: UpdateAccountHolderInput;
};

export type MutationUpdateAccountHolderFundingLimitsArgs = {
  input: UpdateAccountHolderFundingLimitsInput;
};

export type MutationUpdateAccountVerificationStatusArgs = {
  input: UpdateAccountVerificationStatusInput;
};

export type MutationUpdateFundingLimitSettingsChangeRequestArgs = {
  input: UpdateFundingLimitSettingsChangeRequestInput;
};

export type MutationUpdateSandboxIdentificationArgs = {
  input: UpdateSandboxIdentificationInput;
};

export type MutationUpdateSandboxUserArgs = {
  input: UpdateSandboxUserInput;
};

export type MutationUpdateSupportingDocumentCollectionStatusArgs = {
  input: UpdateSupportingDocumentCollectionStatusInput;
};

export type MutationUpdateSupportingDocumentStatusArgs = {
  input: UpdateSupportingDocumentStatusInput;
};

/** Rejection returned on unknown nationality */
export type NationalityNotFoundRejection = Rejection & {
  __typename: "NationalityNotFoundRejection";
  identifier: Scalars["CCA3"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection returned if the entity was not found or if the user does not have the rights to know that the account exists */
export type NotFoundRejection = Rejection & {
  __typename: "NotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type NotLegalRepresentativeRejection = Rejection & {
  __typename: "NotLegalRepresentativeRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when consent status couldn't change */
export type NotReachableConsentStatusRejection = Rejection & {
  __typename: "NotReachableConsentStatusRejection";
  currentStatus?: Maybe<ConsentStatus>;
  message: Scalars["String"]["output"];
  unreachableStatus?: Maybe<ConsentStatus>;
};

export type NotRequestedThreeDsStatusInfo = ThreeDsStatusInfo & {
  __typename: "NotRequestedThreeDsStatusInfo";
  status: IncomingThreeDsStatus;
};

/**
 * @deprecated Use 'StartedIdentificationLevelStatusInfo' instead. Deprecated to ensure consistency and clear identification status behavior
 * Describes an identification level that hasn't started for the process of the current identification
 */
export type NotStartedIdentificationLevelStatusInfo = {
  __typename: "NotStartedIdentificationLevelStatusInfo";
  /**
   * Always set to `NotStarted`
   * @deprecated Use 'Started' instead. Deprecated to ensure consistency and clear identification status behavior.
   */
  status: SwanIdentificationStatus;
};

/** Describes an identification level that's not supported for the process of the current identification */
export type NotSupportedIdentificationLevelStatusInfo = {
  __typename: "NotSupportedIdentificationLevelStatusInfo";
  /** Always set to `NotSupported` */
  status: SwanIdentificationStatus;
};

export type OAuth2Consent = DetailedConsent & {
  __typename: "OAuth2Consent";
  acceptedAt?: Maybe<Scalars["DateTime"]["output"]>;
  branding: Branding;
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  challenge?: Maybe<Scalars["String"]["output"]>;
  consentChallenge?: Maybe<Scalars["String"]["output"]>;
  consentOperations: Array<ConsentOperation>;
  consentResponses: Array<ConsentResponse>;
  createdAt: Scalars["DateTime"]["output"];
  env: EnvType;
  expiredAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  identityId: Scalars["String"]["output"];
  loginChallenge?: Maybe<Scalars["String"]["output"]>;
  operationsSHA256HexDigest?: Maybe<Scalars["String"]["output"]>;
  projectId?: Maybe<Scalars["String"]["output"]>;
  purpose: DetailedConsentPurpose;
  refusedAt?: Maybe<Scalars["DateTime"]["output"]>;
  requireSCA: Scalars["Boolean"]["output"];
  scopes?: Maybe<Scalars["String"]["output"]>;
  startedAt?: Maybe<Scalars["DateTime"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  status: ConsentStatus;
  updatedAt: Scalars["DateTime"]["output"];
  userId?: Maybe<Scalars["String"]["output"]>;
};

/** Extra parameters provided by partner */
export type OAuthRedirectParameters = {
  __typename: "OAuthRedirectParameters";
  /** URL used to redirect the user at the end of the onboarding process. If `null` the user is redirected to the white label web banking. */
  redirectUrl?: Maybe<Scalars["String"]["output"]>;
  /** Custom state provided by partner to prevent XSRF attack, will be filled by onBoardingId in case of nullity. */
  state?: Maybe<Scalars["String"]["output"]>;
};

/** Information provided during the onboarding process of an individual or a company */
export type Onboarding = {
  __typename: "Onboarding";
  /** Account opened after the onboarding finalization */
  account?: Maybe<Account>;
  /** Account Country */
  accountCountry: AccountCountry;
  /** Account holder created at the end of the onboarding process */
  accountHolder?: Maybe<AccountHolder>;
  /** Account name */
  accountName?: Maybe<Scalars["String"]["output"]>;
  /** Acquisition Channel to specify how the user joined, such as "InboundOrganic", "OutboundSales", etc. */
  acquisitionChannel?: Maybe<AcquisitionChannel>;
  /** Creation date */
  createdAt: Scalars["DateTime"]["output"];
  /** Email */
  email?: Maybe<Scalars["String"]["output"]>;
  /** Finalization date */
  finalizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Unique identifier of an onboarding */
  id: Scalars["String"]["output"];
  /** Information regarding the Individual or the company to onboard */
  info: OnboardingAccountHolderInfo;
  /**
   * Language of the onboarding process.
   * - Accepted languages: `["en", "fr", "nl", "de", "it", "es", "pt", "fi"]`
   */
  language?: Maybe<AccountLanguage>;
  /** List of accepted identification level for the legal representative */
  legalRepresentativeAcceptedIdentificationLevels: Array<Maybe<IdentificationLevel>>;
  /** Extra parameters provided by partner */
  oAuthRedirectParameters?: Maybe<OAuthRedirectParameters>;
  /** Redirect the legal representative of a new account holder to this URL to start the onboarding process */
  onboardingUrl?: Maybe<Scalars["String"]["output"]>;
  /** Status (valid/invalid/finalized) and details of errors on fields */
  statusInfo: OnboardingStatusInfo;
  /** List of supporting document collection owned by the account holder. */
  supportingDocumentCollection: SupportingDocumentCollection;
  /** Swan TCU URL */
  tcuUrl: Scalars["String"]["output"];
  /** Creation date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** The onboarding could be for an Individual or a company */
export type OnboardingAccountHolderInfo = {
  /** Account holder type */
  type: AccountHolderType;
};

/** Company Account Holder Information */
export type OnboardingCompanyAccountHolderInfo = OnboardingAccountHolderInfo & {
  __typename: "OnboardingCompanyAccountHolderInfo";
  /** business activity */
  businessActivity?: Maybe<BusinessActivity>;
  /**
   * business activity description
   * This must be 1024 characters long maximum.
   */
  businessActivityDescription?: Maybe<Scalars["String"]["output"]>;
  /** legal form of the company (SAS, SCI, SASU, ...) */
  companyType?: Maybe<CompanyType>;
  /**
   * The ultimate beneficiary is defined as the natural person (s) who own or control, directly or indirectly, the reporting company.
   *
   * The ultimate beneficiary is :
   * - either the natural person (s) who hold, directly or indirectly, more than 25% of the capital or the rights of vote of the reporting company;
   * - either the natural person (s) who exercise, by other means, a power of control of the company;
   */
  individualUltimateBeneficialOwners?: Maybe<Array<IndividualUltimateBeneficialOwner>>;
  /** Is company registered at RCS in its country */
  isRegistered?: Maybe<Scalars["Boolean"]["output"]>;
  /** Legal representative personal address */
  legalRepresentativePersonalAddress?: Maybe<AddressInformation>;
  /** estimated monthly payment volume (euro) */
  monthlyPaymentVolume?: Maybe<MonthlyPaymentVolume>;
  /** Name of the company. */
  name?: Maybe<Scalars["String"]["output"]>;
  /**
   * Registration number of the company (for example, Système d'Identification du Répertoire des ENtreprises [SIREN] in France, ...).
   * - Length must be from 0 to 50 characters.
   */
  registrationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Returns the list of representatives of a company. */
  representatives?: Maybe<Array<Representative>>;
  /** residency address of the head office (Must be in a European country) */
  residencyAddress?: Maybe<AddressInfo>;
  /** Tax Identification Number */
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Trade name of the company */
  tradeName?: Maybe<Scalars["String"]["output"]>;
  /** Account holder type (always Company for type OnboardingCompanyAccountHolderInfo) */
  type: AccountHolderType;
  /** Type of representation (legal representative or power of attorney) */
  typeOfRepresentation?: Maybe<TypeOfRepresentation>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT */
  vatNumber?: Maybe<Scalars["String"]["output"]>;
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type OnboardingConnection = Connection & {
  __typename: "OnboardingConnection";
  /** OnboardingEdge list */
  edges: Array<OnboardingEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type OnboardingEdge = Edge & {
  __typename: "OnboardingEdge";
  /** Opaque identifier pointing to this onboarding node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The Onboarding */
  node: Onboarding;
};

/** Filters that can be applied when listing onboardings */
export type OnboardingFiltersInput = {
  /** Filter by email */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   *  - Account holder's first name
   *  - Account holder's last name
   *  - Account holder's company name
   *  - Account holder's ID
   *  - Email
   *  - ID
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by status */
  status?: InputMaybe<Array<OnboardingStatus>>;
  /** Filter by type */
  types?: InputMaybe<Array<AccountHolderType>>;
};

/** StatusInfo when onboarding has been finalized */
export type OnboardingFinalizedStatusInfo = OnboardingStatusInfo & {
  __typename: "OnboardingFinalizedStatusInfo";
  status: OnboardingStatus;
};

/** Individual Account Holder Information */
export type OnboardingIndividualAccountHolderInfo = OnboardingAccountHolderInfo & {
  __typename: "OnboardingIndividualAccountHolderInfo";
  /** employment status of the individual account holder */
  employmentStatus?: Maybe<EmploymentStatus>;
  /** monthly income of the individual account holder */
  monthlyIncome?: Maybe<MonthlyIncome>;
  /** residency address of the individual account holder (must be in a European country) */
  residencyAddress?: Maybe<AddressInfo>;
  /** Tax Identification Number */
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Account holder type (always Individual for type OnboardingIndividualAccountHolderInfo) */
  type: AccountHolderType;
};

export type OnboardingInfo = {
  __typename: "OnboardingInfo";
  /** Country of the account that will be created at the end of the onboarding process */
  accountCountry?: Maybe<AccountCountry>;
  /** Account name */
  accountName?: Maybe<Scalars["String"]["output"]>;
  /** Acquisition Channel to specify how the user joined, such as "InboundOrganic", "OutboundSales", etc. */
  acquisitionChannel?: Maybe<AcquisitionChannel>;
  /** email */
  email?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier of an onboarding */
  id: Scalars["String"]["output"];
  /** Information regarding the Individual or the company to onboard */
  info: OnboardingAccountHolderInfo;
  /**
   * Language of the onboarding process.
   * - Accepted languages: `["en", "fr", "nl", "de", "it", "es", "pt", "fi"]`
   */
  language?: Maybe<AccountLanguage>;
  /** List of accepted identification level for the legal representative */
  legalRepresentativeAcceptedIdentificationLevels: Array<Maybe<IdentificationLevel>>;
  /** Extra parameters provided by partner */
  oAuthRedirectParameters?: Maybe<OAuthRedirectParameters>;
  /** Redirect the legal representative of a new account holder to this URL to start the onboarding process */
  onboardingUrl: Scalars["String"]["output"];
  /** Project infos you set in the dashboard */
  projectInfo?: Maybe<ProjectInfo>;
  /** Status (valid/invalid/finalized) and details of errors on fields */
  statusInfo: OnboardingStatusInfo;
  /** Supporting document collection related to onboarding. */
  supportingDocumentCollection: SupportingDocumentCollection;
  /** Swan TCU URL */
  tcuUrl: Scalars["String"]["output"];
};

/** StatusInfo when onboarding has still at least one incorrect field */
export type OnboardingInvalidStatusInfo = OnboardingStatusInfo & {
  __typename: "OnboardingInvalidStatusInfo";
  errors: Array<ValidationError>;
  status: OnboardingStatus;
};

/** Field we can use when ordering that can be applied when listing onboardings */
export type OnboardingOrderByFieldInput = "createdAt" | "finalizedAt" | "updatedAt";

/** Order that can be applied when listing onboardings */
export type OnboardingOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<OnboardingOrderByFieldInput>;
};

/** Possible values for onboarding status */
export type OnboardingStatus =
  /** When the onboarding is finalized */
  | "Finalized"
  /** when the onboarding is invalid. Final status */
  | "Invalid"
  /** When the onboarding is valid. Final status */
  | "Valid";

/** Object containing details about onboarding status (valid/invalid and why it is invalid/already finalized) */
export type OnboardingStatusInfo = {
  /** Current onboarding status. Onboarding can only be finalized if status is "valid" */
  status: OnboardingStatus;
};

/** StatusInfo when onboarding has all onboarding fields are correctly filled */
export type OnboardingValidStatusInfo = OnboardingStatusInfo & {
  __typename: "OnboardingValidStatusInfo";
  status: OnboardingStatus;
};

export type OrderByDirection = "Asc" | "Desc";

export type OtherAdditionalInformation = {
  __typename: "OtherAdditionalInformation";
  description: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type OtherAdditionalInformationInput = {
  description: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type OtherAdditionalInformationRequirements = {
  __typename: "OtherAdditionalInformationRequirements";
  otherAdditionalInformation: Array<Scalars["String"]["output"]>;
};

/** Reason codes for returning an outgoing transfer */
export type OutgoingInternationalCreditTransferReturnReasonCode =
  | "AccountBlocked"
  | "AccountClosed"
  | "AccountDoesNotExist"
  | "AccountFrozen"
  | "AccountLimitReached"
  | "BusinessPaymentsForbidden"
  | "CannotAcceptFrom3RdParty"
  | "CreditingAccountForbidden"
  | "DuplicateEntry"
  | "FundsNotExpectedReturned"
  | "MandateNotFilledIn"
  | "ReasonNotSpecified"
  | "TaxIdNotMatching"
  | "TaxIdSuspended"
  | "WrongAccountDetails"
  | "WrongAccountNumber"
  | "WrongAccountType"
  | "WrongBankCode"
  | "WrongBranchCode"
  | "WrongCardNumber"
  | "WrongCardType"
  | "WrongCurrency"
  | "WrongIdNumber"
  | "WrongName"
  | "WrongPaymentPurpose"
  | "WrongPhoneNumber"
  | "WrongReference"
  | "WrongRutNumber";

/** Implements PageInfo from the Relay Connections Specification - information about a page in the pagination mechanism */
export type PageInfo = {
  __typename: "PageInfo";
  /** Opaque identifier pointing to the last node of the page */
  endCursor?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether more edges exist following this page */
  hasNextPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether more edges exist preceding this page */
  hasPreviousPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** Opaque identifier pointing to the first node of the page */
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

/** Partnership Status Accepted */
export type PartnershipAcceptedStatusInfo = PartnershipStatusInfo & {
  __typename: "PartnershipAcceptedStatusInfo";
  /** Accepted date of the partnership for this account */
  acceptedDate: Scalars["DateTime"]["output"];
  /** Partnership status (always Accepted for type PartnershipAcceptedStatusInfo) */
  status: PartnershipStatus;
};

/** Partnership Status canceled */
export type PartnershipCanceledStatusInfo = PartnershipStatusInfo & {
  __typename: "PartnershipCanceledStatusInfo";
  /** Accepted date of the partnership for this account */
  acceptedDate: Scalars["DateTime"]["output"];
  /** Canceled date of the partnership for this account */
  canceledDate: Scalars["DateTime"]["output"];
  /** Reason of the cancelation */
  reason: Scalars["String"]["output"];
  /** Partnership status (always Canceled for type PartnershipCanceledStatusInfo) */
  status: PartnershipStatus;
};

/** Partnership Status currently cancelling */
export type PartnershipCancelingStatusInfo = PartnershipStatusInfo & {
  __typename: "PartnershipCancelingStatusInfo";
  /** Accepted date of the partnership for this account */
  acceptedDate: Scalars["DateTime"]["output"];
  /** Canceled date of the partnership for this account */
  canceledAfter: Scalars["DateTime"]["output"];
  /** Partnership status (always Canceling for type PartnershipCancelingStatusInfo) */
  status: PartnershipStatus;
};

export type PartnershipStatus =
  /** When the partnership is accepted by the account holder for this account */
  | "Accepted"
  /** When the partnership was canceled by you or the account holder */
  | "Canceled"
  /** When you decide to stop the partnership, you have 2 months notice */
  | "Canceling";

/** Partnership Status information */
export type PartnershipStatusInfo = {
  /** Status of the partnership for this account */
  status: PartnershipStatus;
};

/** The document corresponding to a passport */
export type PassportDocument = {
  __typename: "PassportDocument";
  /** The date at which the passport expires */
  expiryDate?: Maybe<Scalars["Date"]["output"]>;
  /** List of the associated files */
  files: Array<PassportDocumentFile>;
  /** Unique identifier of the passport document */
  id: Scalars["String"]["output"];
  /** The date at which the passport was issued */
  issueDate?: Maybe<Scalars["Date"]["output"]>;
  /** Machine-readable zone code of the passport */
  mrz?: Maybe<Scalars["String"]["output"]>;
  /** Number of the passport */
  number?: Maybe<Scalars["String"]["output"]>;
  /** The type of the document */
  type: DocumentType;
};

/** The file associated to the passport document */
export type PassportDocumentFile = DocumentFile & {
  __typename: "PassportDocumentFile";
  /** The file's temporary download url */
  downloadUrl: Scalars["String"]["output"];
  /** From which side the passport's picture was taken */
  side: DocumentFileSide;
};

export type PaymentAccountType =
  /** When the account holder if the account hasn't met KYC requirements */
  | "EMoney"
  /** When all KYC requirements are met */
  | "PaymentService";

export type PaymentDirectDebitMandate = {
  /** Unique identifier of the Direct Debit Payment Mandate */
  id: Scalars["ID"]["output"];
};

/** Payment Level of the account */
export type PaymentLevel =
  /** When the account is limited to 0€ within 30 days and with no IBAN */
  | "Limited"
  /** When the account holder is fully verified and then the account is unlimited with an IBAN */
  | "Unlimited";

export type PaymentMandate = {
  /** Account Holder information */
  accountHolder: AccountHolder;
  /** Creation date of the Payment Mandate */
  createdAt: Scalars["DateTime"]["output"];
  /** Date of the the last transaction executed for the concerned Payment Mandate */
  executedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Expiry date of the Payment Mandate */
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  /** Unique identifier of the Payment Mandate */
  id: Scalars["ID"]["output"];
  /** Custom name of the mandate */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Payment Mandate status information */
  statusInfo: PaymentMandateStatusInfo;
  /** Last Update date of the Payment Mandate */
  updatedAt: Scalars["DateTime"]["output"];
};

export type PaymentMandateCanceledReason =
  /** When the Payment Mandate is expired */
  | "MandateExpired"
  /** When the user requested to cancel the Payment Mandate */
  | "RequestedByUser";

/** Payment Mandate Canceled status information */
export type PaymentMandateCanceledStatusInfo = PaymentMandateStatusInfo & {
  __typename: "PaymentMandateCanceledStatusInfo";
  /** Date of Cancellation of the mandate. */
  canceledAt: Scalars["DateTime"]["output"];
  /** Reason behind the Payment Mandate Canceled status */
  reason: PaymentMandateCanceledReason;
  /** Payment Mandate status (always Canceled for type PaymentMandateCanceledStatusInfo). */
  status: PaymentMandateStatus;
};

/** Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type PaymentMandateConnection = Connection & {
  __typename: "PaymentMandateConnection";
  /** PaymentMandateEdge list */
  edges: Array<PaymentMandateEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of elements in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Payment Mandate Consent Pending status information */
export type PaymentMandateConsentPendingStatusInfo = PaymentMandateStatusInfo & {
  __typename: "PaymentMandateConsentPendingStatusInfo";
  /** Consent information required to enable the concerned Payment Mandate */
  consent: Consent;
  /** Payment Mandate status (always Enabled for type PaymentMandateEnableedStatusInfo). */
  status: PaymentMandateStatus;
};

export type PaymentMandateCreditor = {
  /** Creditor address */
  address: Address;
  /** Creditor UUID */
  id: Scalars["ID"]["output"];
  /** Creditor name */
  name: Scalars["String"]["output"];
};

export type PaymentMandateDebtor = {
  /** Debtor country */
  country: Scalars["CCA3"]["output"];
  /** Debtor e-mail */
  email?: Maybe<Scalars["String"]["output"]>;
  /** Debtor name */
  name: Scalars["String"]["output"];
};

/** Implements the Relay Edge interface */
export type PaymentMandateEdge = Edge & {
  __typename: "PaymentMandateEdge";
  /** Opaque identifier pointing to this onboarding node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The payment mandate */
  node: PaymentMandate;
};

/** Payment Mandate Enabled status information */
export type PaymentMandateEnabledStatusInfo = PaymentMandateStatusInfo & {
  __typename: "PaymentMandateEnabledStatusInfo";
  /** Payment Mandate status (always Enabled for type PaymentMandateEnabledStatusInfo). */
  status: PaymentMandateStatus;
};

/** Filter that can be passed to get the payment mandate in a specific data range */
export type PaymentMandateFiltersInput = {
  /** To filter on scheme values */
  scheme?: InputMaybe<Array<PaymentMandateScheme>>;
  /** To filter on status values */
  status?: InputMaybe<Array<PaymentMandateStatus>>;
};

/** Error returned if the payment mandate was not found */
export type PaymentMandateMandateNotFoundRejection = Rejection & {
  __typename: "PaymentMandateMandateNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Field we can use when ordering that can be applied when listing payment mandate results */
export type PaymentMandateOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing payment mandate results */
export type PaymentMandateOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<PaymentMandateOrderByFieldInput>;
};

/** Rejection returned if the payment mandate reference is already used for the same creditor */
export type PaymentMandateReferenceAlreadyUsedRejection = Rejection & {
  __typename: "PaymentMandateReferenceAlreadyUsedRejection";
  message: Scalars["String"]["output"];
};

/** Payment Mandate Rejected status information */
export type PaymentMandateRejectedStatusInfo = PaymentMandateStatusInfo & {
  __typename: "PaymentMandateRejectedStatusInfo";
  /** Payment Mandate status (always Rejected for type PaymentMandateSuspendedStatusInfo). */
  status: PaymentMandateStatus;
};

export type PaymentMandateScheme =
  /** Card Cartes Bancaires */
  | "CardCartesBancaires"
  /** Card Mastercard */
  | "CardMastercard"
  /** Card Visa */
  | "CardVisa"
  /** Internal Direct Debit B2B */
  | "InternalDirectDebitB2b"
  /** Internal Direct Debit Standard */
  | "InternalDirectDebitStandard"
  /** SEPA Direct Debit B2B */
  | "SepaDirectDebitB2b"
  /** SEPA Direct Debit Core */
  | "SepaDirectDebitCore";

/** Payment Mandate Sequence */
export type PaymentMandateSequence =
  /** The Payment Mandate can be used only once */
  | "OneOff"
  /** The Payment Mandate can be used for recurrent collections */
  | "Recurrent";

/** Payment Mandate status */
export type PaymentMandateStatus = "Canceled" | "ConsentPending" | "Enabled" | "Rejected";

/** Payment Mandate status information */
export type PaymentMandateStatusInfo = {
  /** Status of the payment mandate. */
  status: PaymentMandateStatus;
};

/** Rejection returned when a payment method is not compatible for the requested mutation */
export type PaymentMethodNotCompatibleRejection = Rejection & {
  __typename: "PaymentMethodNotCompatibleRejection";
  message: Scalars["String"]["output"];
};

/** Custom information for a PDF statement */
export type PdfStatement = StatementInfo & {
  __typename: "PdfStatement";
  /** date at which the link will not be useable anymore */
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** statement type */
  type?: Maybe<StatementType>;
  /** temporary public url on which the file can be accessed */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Describes an identification level that is pending for the process of the current identification, requiring an operation not related to the end-user to progress */
export type PendingIdentificationLevelStatusInfo = {
  __typename: "PendingIdentificationLevelStatusInfo";
  /** Always set to `Pending` */
  status: SwanIdentificationStatus;
};

/** PendingMerchantPaymentMethodStatusInfo */
export type PendingMerchantPaymentMethodStatusInfo = MerchantPaymentMethodStatusInfo & {
  __typename: "PendingMerchantPaymentMethodStatusInfo";
  status: MerchantPaymentMethodStatus;
};

/** PendingReviewMerchantProfileStatusInfo */
export type PendingReviewMerchantProfileStatusInfo = MerchantProfileStatusInfo & {
  __typename: "PendingReviewMerchantProfileStatusInfo";
  status: MerchantProfileStatus;
};

/** Pending Verification Information */
export type PendingReviewStatusInfo = AccountVerificationStatusInfo & {
  __typename: "PendingReviewStatusInfo";
  /** Account verification status (PendingReview) */
  status: AccountVerificationStatus;
};

/** Pending Verification Information */
export type PendingVerificationStatusInfo = AccountVerificationStatusInfo & {
  __typename: "PendingVerificationStatusInfo";
  /** Account verification status (PendingVerification) */
  status: AccountVerificationStatus;
};

/** Physical Card */
export type PhysicalCard = {
  __typename: "PhysicalCard";
  /** Masked Card Number */
  cardMaskedNumber: Scalars["String"]["output"];
  /** Custom Options */
  customOptions: PhysicalCardCustomOptions;
  /** Physical Card expiration date  with MM/YY string format */
  expiryDate?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier present on physical card, such identifier is null if the status is ToActivate or Canceled. This identifier is updated when a renewed card is activated */
  identifier?: Maybe<Scalars["String"]["output"]>;
  /** Offline Spending limit defined by Swan */
  offlineSpendingLimit: Amount;
  /** every previous Physical Card information */
  previousPhysicalCards: Array<BasicPhysicalCardInfo>;
  /** Physical Card status information */
  statusInfo: PhysicalCardStatusInfo;
};

/** Physical Card Activated Status Information */
export type PhysicalCardActivatedStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardActivatedStatusInfo";
  /** Physical Card status (always Activated for type PhysicalCardEnabledStatusInfo). */
  status: PhysicalCardStatus;
};

/** Physical Card Canceled Status Information */
export type PhysicalCardCanceledStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardCanceledStatusInfo";
  /** Reason why the card is canceled. */
  reason: Scalars["String"]["output"];
  /** Physical Card status (always Canceled for type PhysicalCardCanceledStatusInfo). */
  status: PhysicalCardStatus;
};

/** Physical Card Canceling Status Information */
export type PhysicalCardCancelingStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardCancelingStatusInfo";
  /** Reason why the card is canceled. */
  reason: Scalars["String"]["output"];
  /** Physical Card status (always Canceling for type PhysicalCardCancelingStatusInfo). */
  status: PhysicalCardStatus;
};

/** when the user has to authorize production of the physical card */
export type PhysicalCardConsentPendingStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardConsentPendingStatusInfo";
  /** The consent required to authorize production of the physical card */
  consent: Consent;
  /** Physical Card status (always ConsentPending for type PhysicalCardConsentPendingStatusInfo) */
  status: PhysicalCardStatus;
};

/** Custom options for physical card. */
export type PhysicalCardCustomOptions = {
  __typename: "PhysicalCardCustomOptions";
  /** Additional line embossed on the card. */
  additionalPrintedLine?: Maybe<Scalars["String"]["output"]>;
  /** Chosen shipping provider */
  chosenShippingProvider?: Maybe<Scalars["String"]["output"]>;
  /** Custom cardholder name */
  customCardHolderName?: Maybe<Scalars["String"]["output"]>;
};

/** when the physical card is in the process of being ready to use */
export type PhysicalCardProcessingStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardProcessingStatusInfo";
  /** Physical card status (always Processing for type PhysicalCardProcessingStatusInfo) */
  status: PhysicalCardStatus;
};

/** Input to simulate reception of a physical card */
export type PhysicalCardReceptionInput = {
  /** Unique identifier of a card */
  cardId: Scalars["ID"]["input"];
};

export type PhysicalCardReceptionPayload =
  | ForbiddenRejection
  | PhysicalCardReceptionSuccessPayload
  | SimulationRejection
  | ValidationRejection;

export type PhysicalCardReceptionSuccessPayload = {
  __typename: "PhysicalCardReceptionSuccessPayload";
  physicalCardIdentifier: Scalars["String"]["output"];
};

/** Possible physical card renewal status */
export type PhysicalCardRenewalStatus =
  /** Physical card is renewed but hasn’t made a transaction since renewal */
  | "Renewed"
  /** Physical card is in the process of being renewed */
  | "ToRenew";

/** Physical Card Renewed Status Information */
export type PhysicalCardRenewedStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardRenewedStatusInfo";
  /** address to deliver the physical card */
  address: Address;
  /** Estimated delivery date */
  estimatedDeliveryDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** `true` if PIN Code is available. */
  isPINReady: Scalars["Boolean"]["output"];
  /** New physical Card info */
  newPhysicalCard: BasicPhysicalCardInfo;
  /** Name of the shipping provider */
  shippingProvider?: Maybe<ShippingProvider>;
  /** Physical Card status (always Renewed for type PhysicalCardRenewedStatusInfo). */
  status: PhysicalCardStatus;
  /** Shipping tracking number */
  trackingNumber?: Maybe<Scalars["String"]["output"]>;
};

/** Physical Card Status */
export type PhysicalCardStatus =
  /** Physical card is activated and can be used */
  | "Activated"
  /** Physical card is canceled, can’t be used, and can’t be restored */
  | "Canceled"
  /** Physical card is in the process of being canceled; card can’t be used or restored */
  | "Canceling"
  /** Consent to authorize physical card production is pending */
  | "ConsentPending"
  /** Physical card is in processing and can’t be used yet */
  | "Processing"
  /** Physical card is renewed but hasn’t made a transaction since renewal */
  | "Renewed"
  /** Physical card is suspended and can’t be used */
  | "Suspended"
  /** Physical card needs to be activated by cardholder */
  | "ToActivate"
  /** Physical card is in the process of being renewed */
  | "ToRenew";

/** Physical Card Status Information */
export type PhysicalCardStatusInfo = {
  /** Status of the physical card. */
  status: PhysicalCardStatus;
};

/** Physical Card Suspended Status Information */
export type PhysicalCardSuspendedStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardSuspendedStatusInfo";
  /** Reason why the card is suspended. */
  reason: Scalars["String"]["output"];
  /** Physical Card status (always Suspended for type PhysicalCardSuspendedStatusInfo). */
  status: PhysicalCardStatus;
};

/** Physical Card To Activate Status Information */
export type PhysicalCardToActivateStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardToActivateStatusInfo";
  /** address to deliver the physical card */
  address: Address;
  /** Estimated delivery date */
  estimatedDeliveryDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** `true` if PIN Code is available. */
  isPINReady: Scalars["Boolean"]["output"];
  /** Name of the shipping provider */
  shippingProvider?: Maybe<ShippingProvider>;
  /** Physical Card status (always ToActivate for type PhysicalCardToActivateStatusInfo). */
  status: PhysicalCardStatus;
  /** Shipping tracking number */
  trackingNumber?: Maybe<Scalars["String"]["output"]>;
};

/** when the physical card is in the process of being renewed */
export type PhysicalCardToRenewStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardToRenewStatusInfo";
  /** registered address to deliver the new physical card */
  address: Address;
  /** Physical card status (always ToRenew for type PhysicalCardToRenewStatusInfo) */
  status: PhysicalCardStatus;
};

/** Rejection returned when the Physical Card is not the expected status */
export type PhysicalCardWrongStatusRejection = Rejection & {
  __typename: "PhysicalCardWrongStatusRejection";
  currentStatus: PhysicalCardStatus;
  expectedStatus: PhysicalCardStatus;
  identifier: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type PreferredNotificationChannel =
  /** Use In-App notification */
  | "App"
  /** Use Swan SMS */
  | "Sms";

/** Type of product sold. Gifts and donations can be club subscription or collection of donations (for associations), tips collection, contributions for local authorities */
export type ProductType = "GiftsAndDonations" | "Goods" | "Services" | "VirtualGoods";

/** Thrown when a plan already has a subscription */
export type ProjectAlreadyHasSubscriptionRejection = Rejection & {
  __typename: "ProjectAlreadyHasSubscriptionRejection";
  message: Scalars["String"]["output"];
};

export type ProjectForbiddenRejection = Rejection & {
  __typename: "ProjectForbiddenRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the Project Funding has been exceeded */
export type ProjectFundingLimitExceededRejection = Rejection & {
  __typename: "ProjectFundingLimitExceededRejection";
  message: Scalars["String"]["output"];
};

/** Public information of a `Project` */
export type ProjectInfo = {
  __typename: "ProjectInfo";
  B2BMembershipIDVerification?: Maybe<Scalars["Boolean"]["output"]>;
  /** Your accent color, used in white label interfaces. Most of the time for call to actions */
  accentColor?: Maybe<Scalars["String"]["output"]>;
  /** Flag that determines if desktop authentication is enabled for this project */
  allowsDesktopAuthentication: Scalars["Boolean"]["output"];
  /** Your custom subdomain used in consents */
  customConsentSubdomain?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier of the project */
  id: Scalars["ID"]["output"];
  /** URL of your logo */
  logoUri?: Maybe<Scalars["String"]["output"]>;
  /** Your project name displayed in white label interfaces and in the terms and conditions */
  name: Scalars["String"]["output"];
  /** Your OAuth client id */
  oAuthClientId?: Maybe<Scalars["String"]["output"]>;
  /** The related project settings */
  projectSettingsId: Scalars["ID"]["output"];
  requireSupportingDocumentsDuringOnboarding?: Maybe<Scalars["Boolean"]["output"]>;
  requireUbosDuringOnboarding?: Maybe<Scalars["Boolean"]["output"]>;
  /** Project status */
  status: ProjectStatus;
  /** Unique id of your current Terms and Conditions of Use */
  tcuDocumentId: Scalars["String"]["output"];
  /** URL to your Terms and Conditions of Use document depending on the provided language */
  tcuDocumentUri: Scalars["String"]["output"];
  /** The type of your project */
  type: ProjectType;
  /** Web banking settings */
  webBankingSettings?: Maybe<WebBankingSettings>;
};

/** Public information of a `Project` */
export type ProjectInfoTcuDocumentUriArgs = {
  language: Scalars["String"]["input"];
};

/** Rejection returned when the Project Instant Funding limit has been exceeded */
export type ProjectInstantFundingLimitExceededRejection = Rejection & {
  __typename: "ProjectInstantFundingLimitExceededRejection";
  message: Scalars["String"]["output"];
};

export type ProjectInvalidStatusRejection = Rejection & {
  __typename: "ProjectInvalidStatusRejection";
  message: Scalars["String"]["output"];
};

export type ProjectNotFound = Rejection & {
  __typename: "ProjectNotFound";
  message: Scalars["String"]["output"];
};

export type ProjectSettingsForbiddenError = Rejection & {
  __typename: "ProjectSettingsForbiddenError";
  message: Scalars["String"]["output"];
};

export type ProjectSettingsNotFound = Rejection & {
  __typename: "ProjectSettingsNotFound";
  message: Scalars["String"]["output"];
};

export type ProjectSettingsStatusNotReachable = Rejection & {
  __typename: "ProjectSettingsStatusNotReachable";
  message: Scalars["String"]["output"];
};

export type ProjectStatus =
  | "BetaLiveAccess"
  | "Disabled"
  | "Enabled"
  | "FullLiveAccess"
  | "Initiated"
  | "LimitedLiveAccess"
  | "MeetingScheduled"
  | "PendingCompliance"
  | "PendingLiveReview"
  | "Rejected"
  | "Suspended"
  | "ToReview";

export type ProjectType =
  | "COMPANY"
  | "COMPANY_AND_CUSTOMERS"
  | "Company"
  | "CompanyAndCustomers"
  | "INDIVIDUAL"
  | "Individual";

export type PromoteAccountHolderToProjectOwnerInput = {
  /** Unique identifier of account holder */
  accountHolderId: Scalars["ID"]["input"];
};

export type PromoteAccountHolderToProjectOwnerPayload =
  | AccountHolderNotFoundRejection
  | ForbiddenRejection
  | PromoteAccountHolderToProjectOwnerSuccessPayload;

export type PromoteAccountHolderToProjectOwnerSuccessPayload = {
  __typename: "PromoteAccountHolderToProjectOwnerSuccessPayload";
  accountHolder: AccountHolder;
};

/** The different response that Swan can give to a provisioning request */
export type ProvisioningResponse =
  /** Provisioning request will be declined */
  | "Decline"
  /**
   * No OTP will be sent before validation
   * Can happen in Live if the cardHolder is trusted by the wallet provider (Adding a card to the watch after adding it to the iPhone)
   */
  | "NoOTP"
  /** An OTP will be sent to the cardHolder */
  | "OTP";

export type PurposeWithOperations = {
  __typename: "PurposeWithOperations";
  operations: Array<ConsentOperation>;
  purpose: ConsentPurpose;
};

export type Query = {
  __typename: "Query";
  /**
   * Returns sandbox user data of active user.
   * Active user is the user who runs the query with their token.
   * This query is restricted to a User access token
   */
  sandboxUser: SandboxUser;
  /**
   * Returns sandbox user data of provided user ID
   * This query is restricted to a User access token
   */
  sandboxUserById?: Maybe<SandboxUser>;
  /**
   * Returns a list of sandbox users data
   * This query is restricted to a User access token
   */
  sandboxUsers?: Maybe<SandboxUserConnection>;
};

export type QuerySandboxUserByIdArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerySandboxUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<SandboxUsersOrderByInput>;
};

export type RadioField = Field & {
  __typename: "RadioField";
  allowedValues: Array<AllowedValue>;
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  refreshDynamicFieldsOnChange: Scalars["Boolean"]["output"];
  required: Scalars["Boolean"]["output"];
};

/** Define a reason with a message */
export type Reason = {
  message?: Maybe<Scalars["String"]["output"]>;
};

/** Input version */
export type ReasonInput = {
  message?: InputMaybe<Scalars["String"]["input"]>;
};

/** Interface for Received Direct Debit Mandate */
export type ReceivedDirectDebitMandate = {
  /** Creation date of the received direct debit mandate */
  createdAt: Scalars["DateTime"]["output"];
  /** Date of the last direct debit transaction executed for the concerned received direct debit mandate */
  executedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Expiry date of the received direct debit mandate */
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  /** Unique identifier of the Payment Mandate */
  id: Scalars["ID"]["output"];
  /** Mandate name */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Date of signature of the received direct debit mandate */
  signatureDate?: Maybe<Scalars["Date"]["output"]>;
  /** Mandate status information of the received direct debit mandate */
  statusInfo: ReceivedDirectDebitMandateStatusInfo;
  /** Last Update date of the received direct debit mandate */
  updatedAt: Scalars["DateTime"]["output"];
  /** Version of the received direct debit mandate */
  version: Scalars["String"]["output"];
};

/** Rejection returned if the received direct debit mandate already exist */
export type ReceivedDirectDebitMandateAlreadyExistRejection = Rejection & {
  __typename: "ReceivedDirectDebitMandateAlreadyExistRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Received direct debit mandate is canceled and therefore can't be enabled/suspended or updated */
export type ReceivedDirectDebitMandateCanceledRejection = Rejection & {
  __typename: "ReceivedDirectDebitMandateCanceledRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type ReceivedDirectDebitMandateConnection = Connection & {
  __typename: "ReceivedDirectDebitMandateConnection";
  /** ReceivedDirectDebitMandateEdge list */
  edges: Array<ReceivedDirectDebitMandateEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of elements in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type ReceivedDirectDebitMandateEdge = Edge & {
  __typename: "ReceivedDirectDebitMandateEdge";
  /** Opaque identifier pointing to this onboarding node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The received direct debit mandate */
  node: ReceivedDirectDebitMandate;
};

/** Rejection returned if the received direct debit mandate is not a B2b mandate */
export type ReceivedDirectDebitMandateNotB2bRejection = Rejection & {
  __typename: "ReceivedDirectDebitMandateNotB2bRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/**
 * Error returned if the received direct debit mandate was not found or if the user does not have the rights to receive information abo
 * ut the existence of the received direct debit mandate
 */
export type ReceivedDirectDebitMandateNotFoundRejection = Rejection & {
  __typename: "ReceivedDirectDebitMandateNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Received Direct Debit Mandate Scheme */
export type ReceivedDirectDebitMandateScheme =
  /** When the received direct debit mandate can only be used for SEPA B2B direct debit transactions */
  | "SepaDirectDebitB2b"
  /** When the received direct debit mandate can only be used for SEPA Core direct debit transactions */
  | "SepaDirectDebitCore";

/** Received Direct Debit Mandate Statuses */
export type ReceivedDirectDebitMandateStatus =
  /** When the received direct debit mandate is canceled */
  | "Canceled"
  /** When the received direct debit mandate requires the initiation of a consent process */
  | "ConsentInitiationPending"
  /** When the received direct debit mandate is pending consent completion */
  | "ConsentPending"
  /** When the received direct debit mandate is enabled */
  | "Enabled"
  /** When the received direct debit mandate is suspended */
  | "Suspended";

/** Received Direct Debit Mandate status information */
export type ReceivedDirectDebitMandateStatusInfo = {
  /** Received Direct Debit Mandate status */
  status: ReceivedDirectDebitMandateStatus;
};

/** Received Direct Debit Mandate Canceled status information */
export type ReceivedDirectDebitMandateStatusInfoCanceled = ReceivedDirectDebitMandateStatusInfo & {
  __typename: "ReceivedDirectDebitMandateStatusInfoCanceled";
  /** Date of cancellation */
  canceledAt: Scalars["DateTime"]["output"];
  /** Received Direct Debit Mandate status (always Canceled for type ReceivedDirectDebitMandateStatusInfoCanceled) */
  status: ReceivedDirectDebitMandateStatus;
};

/** Received Direct Debit Mandate ConsentInitiationPending status information */
export type ReceivedDirectDebitMandateStatusInfoConsentInitiationPending =
  ReceivedDirectDebitMandateStatusInfo & {
    __typename: "ReceivedDirectDebitMandateStatusInfoConsentInitiationPending";
    /** Received Direct Debit Mandate status (always ConsentInitiationPending for type ReceivedDirectDebitMandateStatusInfoConsentInitiationPending) */
    status: ReceivedDirectDebitMandateStatus;
  };

/** Received Direct Debit Mandate ConsentPending status information */
export type ReceivedDirectDebitMandateStatusInfoConsentPending =
  ReceivedDirectDebitMandateStatusInfo & {
    __typename: "ReceivedDirectDebitMandateStatusInfoConsentPending";
    /** The consent required to consent to a received direct debit mandate */
    consent: Consent;
    /** Received Direct Debit Mandate status (always ConsentInitiationPending for type ReceivedDirectDebitMandateStatusInfoConsentPending) */
    status: ReceivedDirectDebitMandateStatus;
  };

/** Received Direct Debit Mandate Enabled status information */
export type ReceivedDirectDebitMandateStatusInfoEnabled = ReceivedDirectDebitMandateStatusInfo & {
  __typename: "ReceivedDirectDebitMandateStatusInfoEnabled";
  /** Date at which the received direct debit mandate has been moved to the enabled status */
  enabledAt: Scalars["DateTime"]["output"];
  /** Received Direct Debit Mandate status (always Enabled for type ReceivedDirectDebitMandateStatusInfoEnabled) */
  status: ReceivedDirectDebitMandateStatus;
};

/** Received Direct Debit Mandate Suspended status information */
export type ReceivedDirectDebitMandateStatusInfoSuspended = ReceivedDirectDebitMandateStatusInfo & {
  __typename: "ReceivedDirectDebitMandateStatusInfoSuspended";
  /** Received Direct Debit Mandate status (always Suspended for type ReceivedDirectDebitMandateStatusInfoSuspended) */
  status: ReceivedDirectDebitMandateStatus;
  /** Date of the last time the received direct debit mandate has been moved to the suspended status */
  suspendedAt: Scalars["DateTime"]["output"];
};

/** RejectedMerchantPaymentMethodStatusInfo */
export type RejectedMerchantPaymentMethodStatusInfo = MerchantPaymentMethodStatusInfo & {
  __typename: "RejectedMerchantPaymentMethodStatusInfo";
  /** Merchant Payment Method rejected date */
  rejectedAt: Scalars["Date"]["output"];
  /** Merchant Payment Methode rejection reason */
  rejectionReason: MerchantPaymentMethodRejectionReason;
  status: MerchantPaymentMethodStatus;
};

/** RejectedMerchantProfileStatusInfo */
export type RejectedMerchantProfileStatusInfo = MerchantProfileStatusInfo & {
  __typename: "RejectedMerchantProfileStatusInfo";
  rejectedAt: Scalars["Date"]["output"];
  rejectionReason: MerchantProfileRejectionReason;
  status: MerchantProfileStatus;
};

/** Rejected Verification Reason */
export type RejectedVerificationReason = "HolderDidNotMatch";

/** Rejected Information */
export type RejectedVerificationStatusInfo = AccountVerificationStatusInfo & {
  __typename: "RejectedVerificationStatusInfo";
  /** Rejected Reason */
  reason: RejectedVerificationReason;
  /** Date at which the verification was rejected */
  rejectedAt: Scalars["DateTime"]["output"];
  /** Account verification status (Rejected) */
  status: AccountVerificationStatus;
};

export type Rejection = {
  message: Scalars["String"]["output"];
};

export type RejectionReasonMandatoryRejection = Rejection & {
  __typename: "RejectionReasonMandatoryRejection";
  message: Scalars["String"]["output"];
};

/** Success payload type */
export type ReleaseReservedBalanceSuccessPayload = {
  __typename: "ReleaseReservedBalanceSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

export type RepaymentCycle = {
  __typename: "RepaymentCycle";
  endDate: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  /** The current cycle's balance. */
  owedAmount: Amount;
  startDate: Scalars["Date"]["output"];
  /** The repayment's balance's status */
  status: RepaymentCycleStatus;
};

export type RepaymentCycleConnection = Connection & {
  __typename: "RepaymentCycleConnection";
  /** RepaymentCycleEdge list */
  edges: Array<RepaymentCycleEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type RepaymentCycleEdge = Edge & {
  __typename: "RepaymentCycleEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The Repayment Cycle entry */
  node: RepaymentCycle;
};

export type RepaymentCycleLength = MonthlyPeriod | WeeklyPeriod;

/** Rejection when a repayment cycle is not found */
export type RepaymentCycleNotFoundRejection = Rejection & {
  __typename: "RepaymentCycleNotFoundRejection";
  message: Scalars["String"]["output"];
};

export type RepaymentCyclePeriod = "Monthly" | "Weekly";

export type RepaymentCycleStatus = "Due" | "Overdue" | "Repaid" | "Submitted";

export type RepaymentMethod = SepaDirectDebitB2b;

export type RepaymentMethodType = "SepaDirectDebitB2b";

/** Rejection when a repayment is not found */
export type RepaymentNotFoundRejection = Rejection & {
  __typename: "RepaymentNotFoundRejection";
  message: Scalars["String"]["output"];
};

export type RepaymentSettings = {
  __typename: "RepaymentSettings";
  /** The period between two reimbursement. */
  repaymentCycleLength: RepaymentCycleLength;
  /** The repayment method used for the reimbursement. */
  repaymentMethod: RepaymentMethod;
};

/** Repayment status */
export type RepaymentStatus = "Confirmed" | "Failed" | "Success";

/** Rejection when a repayment is not found */
export type RepaymentWrongStatusRejection = Rejection & {
  __typename: "RepaymentWrongStatusRejection";
  message: Scalars["String"]["output"];
};

/** Rejection when a repayment is not found */
export type RepaymentWrongStatusTransitionRejection = Rejection & {
  __typename: "RepaymentWrongStatusTransitionRejection";
  message: Scalars["String"]["output"];
};

/** The document corresponding to a identification report */
export type ReportDocument = {
  __typename: "ReportDocument";
  /** List of the associated files */
  files: Array<ReportDocumentFile>;
  /** Unique identifier of the report document */
  id: Scalars["String"]["output"];
  /** The type of the document */
  type: DocumentType;
};

/** The file associated to the report document */
export type ReportDocumentFile = DocumentFile & {
  __typename: "ReportDocumentFile";
  /** The file's temporary download url */
  downloadUrl: Scalars["String"]["output"];
};

export type Representative = CompanyRepresentative | IndividualRepresentative;

export type RepresentativeInput = {
  /** Birth city of the representative. Length must be between 0 and 100 characters. */
  birthCity?: InputMaybe<Scalars["String"]["input"]>;
  /** Postal code of the birth city. Length must be between 0 and 50 characters. */
  birthCityPostalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Birth country code of the representative. Must be a valid alpha-3 country code (ISO 3166). */
  birthCountryCode?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Birth date of the representative. Must be a valid date in the YYYY/MM/DD format. */
  birthDate?: InputMaybe<Scalars["String"]["input"]>;
  /** Email of the representative. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Legal entity name of the representative (for Company type). */
  entityName?: InputMaybe<Scalars["String"]["input"]>;
  /** First name of the representative. */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /** Gender of the representative (Male, Female, or Unknown). */
  gender?: InputMaybe<Gender>;
  /** Last name of the representative. */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /** Legal form of the representative's legal entity. */
  legalForm?: InputMaybe<Scalars["String"]["input"]>;
  /** Nationality of the representative. Must be a valid alpha-3 country code (ISO 3166). */
  nationality?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Preferred first name of the representative. */
  preferredFirstName?: InputMaybe<Scalars["String"]["input"]>;
  /** Registration number of the representative’s legal entity. */
  registrationNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Residency address of the representative. */
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
  /** List of representative roles. */
  roles?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Type of representative (Individual or Company). */
  type: RepresentativeType;
};

export type RepresentativeType = "Company" | "Individual";

/** Request Update Merchant Profile */
export type RequestMerchantProfileUpdate = {
  __typename: "RequestMerchantProfileUpdate";
  /** Additional information about the merchant profile */
  additionalInformation: Array<AdditionalInformation>;
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Where the payer are generally based. */
  customerRegion?: Maybe<MerchantProfileCustomerRegion>;
  /** expected average basket value. */
  expectedAverageBasket?: Maybe<Amount>;
  /** Expected annual activity volumes for all payment method */
  expectedMonthlyMerchantProcessingVolume?: Maybe<ExpectedMonthlyMerchantProcessingVolume>;
  /**
   * Expected annual activity volumes for all payment method
   * @deprecated use expectedMonthlyMerchantProcessingVolume instead
   */
  expectedMonthlyPaymentVolume?: Maybe<Amount>;
  /** The Request ID */
  id: Scalars["ID"]["output"];
  /**
   * Url of an example typical invoice issued by the merchant.
   * @deprecated Unused, will be removed in future versions
   */
  invoiceExampleUrl?: Maybe<Scalars["String"]["output"]>;
  /** Url of the merchant's logo */
  merchantLogoUrl?: Maybe<Scalars["String"]["output"]>;
  /** Business name of the merchant, i.e. name that will be displayed on debtors' bank statements */
  merchantName?: Maybe<Scalars["String"]["output"]>;
  /** The Merchant Profile ID to update */
  merchantProfileId: Scalars["ID"]["output"];
  /**
   * Url of the merchant's website
   * @deprecated Use merchantWebsiteUrl instead
   */
  merchantWebsite?: Maybe<Scalars["String"]["output"]>;
  /** Url of the merchant's website */
  merchantWebsiteUrl?: Maybe<Scalars["String"]["output"]>;
  /** The type of payments accepted by the merchant. Can be OneOff (no returning payers in general), Recurrent (returning payers), or a mix of both OneOffAndRecurrent. */
  paymentFrequency?: Maybe<MerchantProfilePaymentFrequency>;
  /** Type of product sold. List of value: Goods, Services, VirtualGoods, GiftsAndDonations. Gifts and donations can be club subscription or collection of donations (for associations), tips collection, contributions for local authorities */
  productType?: Maybe<ProductType>;
  /**
   * The URL of the main social network of the merchant.
   * @deprecated use socialNetworkUrl instead
   */
  socialNetwork?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the main social network of the merchant. */
  socialNetworkUrl?: Maybe<Scalars["String"]["output"]>;
  /** The status of the request */
  status: RequestMerchantProfileUpdateStatus;
  /**
   * The URL of the support website or help center of the merchant.
   * @deprecated use supportWebsiteUrl instead
   */
  supportWebsite?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the support website or help center of the merchant. */
  supportWebsiteUrl?: Maybe<Scalars["String"]["output"]>;
  /**
   * The URL of the terms and conditions of the merchant.
   * @deprecated use termsAndConditionsUrl instead
   */
  termsAndConditions?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the terms and conditions of the merchant. */
  termsAndConditionsUrl?: Maybe<Scalars["String"]["output"]>;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Request Merchant Profile Update Statuses */
export type RequestMerchantProfileUpdateStatus =
  /** A Request that has been canceled by the user */
  | "Canceled"
  /** A Request that has already been approved */
  | "Enabled"
  /** A Request is created in the PendingReview status */
  | "PendingReview"
  /** A Request that has already been rejected */
  | "Rejected";

/** Request Outcome Merchant Profile Status Input */
export type RequestOutcomeMerchantPaymentMethodInput = {
  methodType: MerchantPaymentMethodType;
  /** Status to which to move the related payment product */
  status: MerchantPaymentMethodStatus;
};

export type RequestSupportingDocumentsInput = {
  requiredSupportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
  supportingDocumentCollectionId: Scalars["ID"]["input"];
};

export type RequestSupportingDocumentsPayload =
  | AccountHolderNotFoundRejection
  | ForbiddenRejection
  | InternalErrorRejection
  | RequestSupportingDocumentsSuccessPayload
  | SupportingDocumentCollectionNotFoundRejection;

export type RequestSupportingDocumentsSuccessPayload = {
  __typename: "RequestSupportingDocumentsSuccessPayload";
  supportingDocumentCollection: SupportingDocumentCollection;
};

export type RequestedThreeDsStatusInfo = ThreeDsStatusInfo & {
  __typename: "RequestedThreeDsStatusInfo";
  status: IncomingThreeDsStatus;
};

/** The document corresponding to a residence permit */
export type ResidencePermitDocument = {
  __typename: "ResidencePermitDocument";
  /** The date at which the residence permit expires */
  expiryDate?: Maybe<Scalars["Date"]["output"]>;
  /** List of the associated files */
  files: Array<ResidencePermitDocumentFile>;
  /** Unique identifier of the residence permit document */
  id: Scalars["String"]["output"];
  /** The date at which the residence permit was issued */
  issueDate?: Maybe<Scalars["Date"]["output"]>;
  /** Machine-readable zone code of the residence permit */
  mrz?: Maybe<Scalars["String"]["output"]>;
  /** Number of the residence permit */
  number?: Maybe<Scalars["String"]["output"]>;
  /** The type of the document */
  type: DocumentType;
};

/** The file associated to the resident permit document */
export type ResidencePermitDocumentFile = DocumentFile & {
  __typename: "ResidencePermitDocumentFile";
  /** The file's temporary download url */
  downloadUrl: Scalars["String"]["output"];
  /** From which side the residence permit's picture was taken */
  side: DocumentFileSide;
};

export type ResidencyAddressInput = {
  /** Address line 1. Length must be from 0 to 255 characters */
  addressLine1?: InputMaybe<Scalars["String"]["input"]>;
  /** AddressLine2. Length must be from 0 to 255 characters */
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  /** City. Length must be from 0 to 100 characters */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** Country */
  country?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Postal code. Length must be from 0 to 50 characters */
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** State of residency. Length must be from 0 to 100 characters */
  state?: InputMaybe<Scalars["String"]["input"]>;
};

/** The channels that can be used to send the OTP and the end of provisioning message */
export type ResponseChannel = "SMS";

/** Account membership restricted to */
export type RestrictedTo = {
  __typename: "RestrictedTo";
  /** birth date */
  birthDate?: Maybe<Scalars["Date"]["output"]>;
  /** first name */
  firstName: Scalars["String"]["output"];
  /** last name */
  lastName: Scalars["String"]["output"];
  /**
   * phone number
   * We're introducing more flexibility in the process to invite & bind new account members (cf [public roadmap](https://swanio.notion.site/Swan-Public-Roadmap-385e4b2e91b3409786a6c8e885654a22?p=a59db00a478e4faaaefbd901e1ed7ed3&pm=s) on notion).
   * For some use cases, it would be possible to invite an account member without their mobile phone number.
   * Please note that the phone number will remain mandatory at the invitation (despite being optional in the Graph) until the new flow is delivered. It is hidden behind a feature toggle
   */
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Percentage over a number of business days, that is applied to all funds collected to compute a Reserved amount
 * This amount cannot be used over the corresponding business days
 */
export type RollingReserve = {
  __typename: "RollingReserve";
  /** Percentage of the funding amount to be reserved */
  percentage: Scalars["Int"]["output"];
  /** Number of business days the computed amount is reserved */
  rollingDays: Scalars["Int"]["output"];
};

export type SepaDirectDebitMandate = {
  /** Unique identifier of the received direct debit mandate, generated by Swan */
  id: Scalars["ID"]["output"];
};

/** Payment direct debit mandate for SEPA */
export type SepaPaymentDirectDebitMandate = PaymentDirectDebitMandate &
  PaymentMandate &
  SepaDirectDebitMandate & {
    __typename: "SEPAPaymentDirectDebitMandate";
    /** Account Holder information */
    accountHolder: AccountHolder;
    /** Creation date of the SEPA Direct Debit Payment Mandate */
    createdAt: Scalars["DateTime"]["output"];
    /** SEPA Direct Debit Payment Mandate creditor information */
    creditor: SepaPaymentMandateCreditor;
    /** SEPA Direct Debit Payment Mandate debtor information */
    debtor: SepaPaymentMandateDebtor;
    /** Date of the the last transaction executed for the concerned SEPA Direct Debit Payment Mandate */
    executedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Expiry date of the SEPA Direct Debit Payment Mandate */
    expiredAt?: Maybe<Scalars["Date"]["output"]>;
    /** Unique identifier of the SEPA Direct Debit Payment Mandate */
    id: Scalars["ID"]["output"];
    /** SEPA Direct Debit Payment Mandate PDF document URL */
    mandateDocumentUrl: Scalars["String"]["output"];
    /** Custom name of the mandate */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Unique reference of the SEPA Direct Debit Payment Mandate */
    reference: Scalars["String"]["output"];
    /** SEPA Direct Debit Payment Mandate scheme */
    scheme: SepaPaymentMandateScheme;
    /** SEPA Direct Debit Payment Mandate sequence */
    sequence: PaymentMandateSequence;
    /** Signature date of the SEPA Direct Debit Payment Mandate */
    signatureDate?: Maybe<Scalars["Date"]["output"]>;
    /** SEPA Direct Debit Payment Mandate status information */
    statusInfo: PaymentMandateStatusInfo;
    /** SEPA direct debit ultimate creditor name */
    ultimateCreditorName?: Maybe<Scalars["String"]["output"]>;
    /** Last Update date of the SEPA Direct Debit Payment Mandate */
    updatedAt: Scalars["DateTime"]["output"];
  };

export type SepaPaymentMandateCreditor = PaymentMandateCreditor & {
  __typename: "SEPAPaymentMandateCreditor";
  /** SEPA Direct Debit Payment Mandate creditor address */
  address: Address;
  /** SEPA Direct Debit Payment Mandate creditor UUID */
  id: Scalars["ID"]["output"];
  /** SEPA Direct Debit Payment Mandate Sepa Creditor Idenfier (SCI) */
  identifier: Scalars["SepaCreditorIdentifier"]["output"];
  /** SEPA Direct Debit Payment Mandate creditor name */
  name: Scalars["String"]["output"];
};

export type SepaPaymentMandateDebtor = PaymentMandateDebtor & {
  __typename: "SEPAPaymentMandateDebtor";
  /** SEPA Direct Debit Payment Mandate debtor address. Mandatory for non EEA Countries */
  address?: Maybe<Address>;
  /** SEPA Direct Debit Payment Mandate debtor country */
  country: Scalars["CCA3"]["output"];
  /** SEPA Direct Debit Payment Mandate debtor e-mail */
  email?: Maybe<Scalars["String"]["output"]>;
  /** SEPA Direct Debit Payment Mandate debtor IBAN */
  iban: Scalars["IBAN"]["output"];
  /** SEPA Direct Debit Payment Mandate debtor name */
  name: Scalars["String"]["output"];
};

export type SepaPaymentMandateScheme =
  /** SEPA Direct Debit B2B */
  | "SepaDirectDebitB2b"
  /** SEPA Direct Debit Core */
  | "SepaDirectDebitCore";

/** Received direct debit mandate for SEPA */
export type SepaReceivedDirectDebitMandate = ReceivedDirectDebitMandate &
  SepaDirectDebitMandate & {
    __typename: "SEPAReceivedDirectDebitMandate";
    /** Account of the received SEPA direct debit mandate debtor */
    account?: Maybe<Account>;
    /** Creation date of the received SEPA direct debit mandate */
    createdAt: Scalars["DateTime"]["output"];
    /** Received SEPA direct debit creditor */
    creditor: SepaReceivedDirectDebitMandateCreditor;
    /** Date of the last SEPA direct debit transaction executed for the concerned received SEPA direct debit mandate */
    executedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Expiry date of the received SEPA direct debit mandate, computed automatically (36 months from the executedAt date) */
    expiredAt?: Maybe<Scalars["Date"]["output"]>;
    /** Iban of the received SEPA direct debit mandate debtor */
    iban: Scalars["IBAN"]["output"];
    /** Unique identifier of the Card Payment Mandate */
    id: Scalars["ID"]["output"];
    /** Mandate name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Received SEPA direct debit Unique Mandate Reference (UMR) */
    reference: Scalars["String"]["output"];
    /** Received SEPA direct debit mandate scheme */
    scheme: SepaReceivedDirectDebitMandateScheme;
    /** Received SEPA direct debit mandate sequence */
    sequence: SepaReceivedDirectDebitMandateSequence;
    /** Date of signature of the received SEPA direct debit mandate */
    signatureDate?: Maybe<Scalars["Date"]["output"]>;
    /** Mandate status information of the received SEPA direct debit mandate */
    statusInfo: ReceivedDirectDebitMandateStatusInfo;
    /** Received SEPA direct debit ultimate creditor name */
    ultimateCreditorName?: Maybe<Scalars["String"]["output"]>;
    /** Last Update date of the received SEPA direct debit mandate */
    updatedAt: Scalars["DateTime"]["output"];
    /** Version of the received SEPA direct debit mandate */
    version: Scalars["String"]["output"];
  };

/** SEPA received direct debit mandate creditor */
export type SepaReceivedDirectDebitMandateCreditor = {
  __typename: "SEPAReceivedDirectDebitMandateCreditor";
  /** Address of the SEPA creditor */
  address: Address;
  /** SEPA Creditor identifier (SCI) */
  identifier: Scalars["String"]["output"];
  /** Name of the SEPA creditor */
  name: Scalars["String"]["output"];
};

/** Received SEPA direct debit mandate scheme */
export type SepaReceivedDirectDebitMandateScheme =
  /** When the received SEPA direct debit mandate can only be used for SEPA B2B direct debit transactions */
  | "SepaDirectDebitB2b"
  /** When the received SEPA direct debit mandate can only be used for SEPA Core direct debit transactions */
  | "SepaDirectDebitCore";

/** SEPA received direct debit mandate sequence */
export type SepaReceivedDirectDebitMandateSequence =
  /** When the authorisation is given once by the SEPA Debtor to collect only one single SEPA direct debit */
  | "OneOff"
  /** When the authorisation by the Debtor can be used for regular SEPA direct debits initiated by the Creditor */
  | "Recurrent";

/** Received SEPA direct debit mandate type */
export type SepaReceivedDirectDebitMandateType =
  /** When the received SEPA direct debit mandate can only be used for SEPA B2B direct debit transactions */
  | "B2B"
  /** When the received SEPA direct debit mandate can only be used for SEPA Core direct debit transactions */
  | "Core";

export type SandboxIdentification = {
  __typename: "SandboxIdentification";
  /** Unique identifier of the identification */
  id: Scalars["String"]["output"];
};

export type SandboxIdentificationNotFoundRejection = Rejection & {
  __typename: "SandboxIdentificationNotFoundRejection";
  message: Scalars["String"]["output"];
};

/**
 * To make your integration with Swan as seamless as possible, we allow you to create as many Sandbox users as you want from Swan.
 * Sandbox users make it possible to simulate the different processes you may encounter with your real users, once you go live.
 * You can simulate different onboarding scenarios and processes, or practice managing the user rights of your accounts.
 *
 * Read more about sandbox users [on the documentation](https://docs.swan.io/concept/user#sandbox-users)
 */
export type SandboxUser = {
  __typename: "SandboxUser";
  /** List of first names */
  allFirstNames?: Maybe<Array<Scalars["String"]["output"]>>;
  /**
   * Saves you considerable time during the development phase,
   * by automatically allowing consent,
   * removing the need to repeatedly get consent.
   */
  autoConsent: Scalars["Boolean"]["output"];
  /** Birth City */
  birthCity?: Maybe<Scalars["String"]["output"]>;
  /** [Alpha-3 birth country representation](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3) */
  birthCountryCCA3?: Maybe<Scalars["CCA3"]["output"]>;
  /** Birth Date */
  birthDate?: Maybe<Scalars["Date"]["output"]>;
  /** Birth Place Postal Code */
  birthPlacePostalCode?: Maybe<Scalars["String"]["output"]>;
  /** First name */
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** Sandbox user ID */
  id: Scalars["ID"]["output"];
  /**
   * List of identification levels available for the user.
   *
   * Whenever TRUE, it means the identification was successful for the associated level.
   */
  identificationLevels?: Maybe<IdentificationLevels>;
  /** Indicates if sandbox user is logged or not */
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  /** Last name */
  lastName?: Maybe<Scalars["String"]["output"]>;
  /**
   * Mobile phone number with the international format
   * Example: +33689788967
   */
  mobilePhoneNumber?: Maybe<Scalars["PhoneNumber"]["output"]>;
  /**
   * [Alpha-3 nationality representation](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3)
   * Ex: FRA for french nationality
   */
  nationalityCCA3?: Maybe<Scalars["CCA3"]["output"]>;
  /**
   * Preferred notification channel
   *
   * When it is "null" it means that the preferences have not been updated. Default SMS in use
   */
  preferredNotificationChannel?: Maybe<PreferredNotificationChannel>;
};

/** Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)). */
export type SandboxUserConnection = Connection & {
  __typename: "SandboxUserConnection";
  /** SandboxUserEdge list. */
  edges: Array<SandboxUserEdge>;
  /** Information about the current, the previous and the next page. */
  pageInfo: PageInfo;
  /** Total number of element in the list. */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface. */
export type SandboxUserEdge = Edge & {
  __typename: "SandboxUserEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism. */
  cursor: Scalars["String"]["output"];
  /** The sandbox user. */
  node: SandboxUser;
};

/** Rejection returned when sandbox user doesn't exist */
export type SandboxUserNotFoundRejection = Rejection & {
  __typename: "SandboxUserNotFoundRejection";
  /** Rejection message */
  message: Scalars["String"]["output"];
  /** Sandbox user ID */
  userId: Scalars["String"]["output"];
};

/** Field we can use when ordering that can be applied when listing sandbox users results */
export type SandboxUsersOrderByFieldInput = "createdAt" | "updatedAt";

export type SandboxUsersOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<SandboxUsersOrderByFieldInput>;
};

/** Rejection returned when adding a B2B mandate with an Individual debtor */
export type SchemeWrongRejection = Rejection & {
  __typename: "SchemeWrongRejection";
  message: Scalars["String"]["output"];
};

export type SelectField = Field & {
  __typename: "SelectField";
  allowedValues: Array<AllowedValue>;
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  refreshDynamicFieldsOnChange: Scalars["Boolean"]["output"];
  required: Scalars["Boolean"]["output"];
};

/** Sepa beneficiary account */
export type SepaBeneficiaryInput = {
  /** beneficiary address */
  address?: InputMaybe<AddressInput>;
  /** International Bank Account Number */
  iban: Scalars["IBAN"]["input"];
  /**
   * `true` if this new beneficiary is the account holder himself in another financial institution.
   * *SOON TO BE DEPRECATED*
   * Not used. It will be removed soon.
   */
  isMyOwnIban?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Full name of the beneficiary (min 2 characters, max 70 characters). The name should not include any special characters. */
  name: Scalars["String"]["input"];
  /** `true` if this new beneficiary will be saved to the beneficiary list of the debited account. */
  save?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** List of Recall reasons */
export type SepaCreditTransferRecallReasonCodeEnum =
  | "BeneficiaryAccountIncorrect"
  | "NotSpecifiedByOriginator"
  | "TechnicalIssueOccurred"
  | "TransactionAmountIncorrect"
  | "TransactionDuplicated"
  | "TransactionFraudulent";

/** List of recalled reasons */
export type SepaCreditTransferRecalledReasonCodeEnum =
  | "BeneficiaryAccountIncorrect"
  | "NotSpecifiedByOriginator"
  | "TransactionAmountIncorrect";

/** List of rejection reasons */
export type SepaCreditTransferRejectionReasonCodeEnum =
  | "AccountClosed"
  | "AccountHolderDeceased"
  | "AccountLimited"
  | "AccountSuspended"
  | "AccountUnknown"
  | "AmountExceedsSettlementLimit"
  | "BankOperationCodeInvalid"
  | "BeneficiaryBankBicInvalid"
  | "BeneficiaryBankBicNotFound"
  | "BeneficiaryBankNotReachable"
  | "CreditorAddressMissing"
  | "CreditorAgentSuspended"
  | "CreditorBankOffline"
  | "CreditorBankTechnicalErrorOccurred"
  | "CreditorBankTimeout"
  | "CreditorNameOrAddressMissing"
  | "DebtorAccountOrIdMissing"
  | "DebtorBankTimeout"
  | "DebtorNameOrAddressMissing"
  | "InsufficientFunds"
  | "InvalidTransferDate"
  | "PaymentNotReceived"
  | "ReasonNotSpecifiedByBank"
  | "ReasonNotSpecifiedByCreditor"
  | "RejectedByCompliance"
  | "TransactionAmountLimitExceeded"
  | "TransactionDuplicated"
  | "TransactionOnAccountTypeNotAllowed";

/** List of return reasons */
export type SepaCreditTransferReturnReasonCodeEnum = "NotSpecifiedByBeneficiary";

/** List of return reasons */
export type SepaCreditTransferReturnedReasonCodeEnum =
  | "BankOperationCodeInvalid"
  | "BeneficiaryAccountBlocked"
  | "BeneficiaryAccountClosed"
  | "BeneficiaryAccountNotFound"
  | "BeneficiaryAddressMissing"
  | "BeneficiaryBankEriNotAllowed"
  | "BeneficiaryBankNotRegisteredCsm"
  | "BeneficiaryDeceased"
  | "BeneficiaryNameOrAddressInsufficientByRegulatory"
  | "BicIncorrect"
  | "NotSpecified"
  | "NotSpecifiedByBeneficiary"
  | "OriginatorAccountOrIdInsufficientByRegulatory"
  | "OriginatorNameOrAddressInsufficientByRegulatory"
  | "PotentialHitBeneficiaryByRegulatory"
  | "TransactionDuplicated"
  | "TransactionNotAllowedOnAccountType";

/** SDD Account input */
export type SepaDirectDebitAccount = {
  /** Address input */
  address?: InputMaybe<AddressInput>;
  /** Your Swan IBAN if you want to receive or send a credit transfer in or from your Swan account */
  iban: Scalars["IBAN"]["input"];
  /** SEPA creditor identifier */
  identifier: Scalars["SepaCreditorIdentifier"]["input"];
  /** Name of the account holder */
  name: Scalars["String"]["input"];
  /** Creditor ultime name */
  ultimateName?: InputMaybe<Scalars["String"]["input"]>;
};

/** SepaDirectDebitB2BMerchantPaymentMethod */
export type SepaDirectDebitB2BMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** The Merchant Payment Method payment amount limit */
  paymentAmountLimit?: Maybe<Amount>;
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** When the above is false, the value of the Sepa Creditor Identifier used */
  sepaCreditorIdentifier?: Maybe<Scalars["String"]["output"]>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  updateRequest?: Maybe<SepaDirectDebitPaymentMethodUpdateRequest>;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Whether this payment method uses the Swan Sepa Creditor Identifier */
  useSwanSepaCreditorIdentifier: Scalars["Boolean"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

export type SepaDirectDebitB2b = {
  __typename: "SepaDirectDebitB2b";
  /** The mandate used for the Sepa Direct Debit B2B. */
  mandate?: Maybe<ReceivedDirectDebitMandate>;
};

/** List of SDD cancel reasons */
export type SepaDirectDebitCancelReasonCodeEnum =
  | "AgentIncorrect"
  | "InvestigationRequestReceived"
  | "NotSpecifiedByOriginator"
  | "PaymentUndue"
  | "TransactionDuplicated";

/** SepaDirectDebitCoreMerchantPaymentMethod */
export type SepaDirectDebitCoreMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** The Merchant Payment Method payment amount limit */
  paymentAmountLimit?: Maybe<Amount>;
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** When the above is false, the value of the Sepa Creditor Identifier used */
  sepaCreditorIdentifier?: Maybe<Scalars["String"]["output"]>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  updateRequest?: Maybe<SepaDirectDebitPaymentMethodUpdateRequest>;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Whether this payment method uses the Swan Sepa Creditor Identifier */
  useSwanSepaCreditorIdentifier: Scalars["Boolean"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

export type SepaDirectDebitMerchantPayment = MerchantPayment & {
  __typename: "SepaDirectDebitMerchantPayment";
  /** amount */
  amount: Amount;
  /**
   * Authorized date
   * @deprecated use authorizedAt in statusInfo instead
   */
  authorizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  balance: MerchantBalance;
  /** The billing address associated to the payment */
  billingAddress?: Maybe<Address>;
  /**
   * Canceled date
   * @deprecated use canceledAt in statusInfo instead
   */
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Captured date
   * @deprecated use capturedAt in statusInfo instead
   */
  capturedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Created date
   * @deprecated use createdAt in statusInfo instead
   */
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Disputed date
   * @deprecated use disputedAt in statusInfo instead
   */
  disputedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** an arbitrary identifier that was defined by you when you created this payment */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of a merchant payment */
  id: Scalars["ID"]["output"];
  /** Label */
  label?: Maybe<Scalars["String"]["output"]>;
  /** merchant profile associated to the merchant payment */
  merchantProfile: MerchantProfile;
  /** payment link associated to the merchant payment */
  paymentLink?: Maybe<MerchantPaymentLink>;
  /** payment link associated to the merchant payment */
  paymentMandate: PaymentMandate;
  /** payment method associated to the merchant payment */
  paymentMethod: MerchantPaymentMethod;
  reference?: Maybe<Scalars["String"]["output"]>;
  /**
   * Refunded date
   * @deprecated use refundedAt in statusInfo instead
   */
  refundedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Rejected date
   * @deprecated use rejectedAt in statusInfo instead
   */
  rejectedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** status information */
  statusInfo: MerchantPaymentStatusInfo;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

export type SepaDirectDebitPaymentMethodUpdateRequest = MerchantPaymentMethodUpdateRequest & {
  __typename: "SepaDirectDebitPaymentMethodUpdateRequest";
  id: Scalars["ID"]["output"];
  /** Your own SCI - Mandatory if the useSwanCreditorIdentifier is set to false */
  sepaCreditorIdentifier?: Maybe<Scalars["String"]["output"]>;
  /** If `true`, the transaction will be created with the Swan Creditor Identifier */
  useSwanSepaCreditorIdentifier: Scalars["Boolean"]["output"];
};

/** List of SDD reject reasons */
export type SepaDirectDebitRejectReasonCodeEnum = "NotSpecifiedByPayer";

/** List of SDD return reasons */
export type SepaDirectDebitReturnReasonCodeEnum =
  | "DebtorAccountBlocked"
  | "DebtorAccountClosed"
  | "MandateInvalid"
  | "NotSpecifiedByBank"
  | "NotSpecifiedByPayer"
  | "RefundRequestedByDebtor"
  | "RegulatorReason"
  | "TransactionDuplicated"
  | "TransactionNotAllowedOnAccountType";

/** List of SDD reverse reasons */
export type SepaDirectDebitReverseReasonCodeEnum =
  | "NotSpecifiedByBank"
  | "NotSpecifiedByOriginator"
  | "TransactionDuplicated";

/** Shareholder of a company creating a Capital Deposit Case */
export type Shareholder = {
  __typename: "Shareholder";
  /** Unique identifier of the shareholder account. */
  accountId?: Maybe<Scalars["String"]["output"]>;
  /** Amount the shareholder has to deposit. */
  capitalDepositAmount: Amount;
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Shareholder documents for the capital deposit case */
  documents: Array<CapitalDepositDocument>;
  /** Unique identifier of a shareholder. */
  id: Scalars["ID"]["output"];
  /** Extra information about the shareholder */
  info: ShareholderInfo;
  /** Onboarding information of the shareholder. */
  onboarding?: Maybe<Onboarding>;
  /** Information about capital deposit case. */
  relatedCapitalDepositCase: CapitalDepositCase;
  /** Status of the shareholder during the process with Swan. */
  status: ShareholderStatus;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Shareholder information. */
export type ShareholderInfo = CompanyShareholder | IndividualShareholder;

/** Status of the shareholder during the process with Swan. */
export type ShareholderStatus =
  /** When the capital deposit of the shareholder is canceled. */
  | "CapitalDepositCanceled"
  /** When the shareholder's capital is wired to the notary. */
  | "CapitalFundsWiredToNotary"
  /** When the shareholder has wired their share of the capital. */
  | "CapitalTransferred"
  /** Waiting for the shareholder to finalize their onboarding. */
  | "PendingOnboarding"
  /** Waiting for the shareholder to wire their share of the capital on their temporary Swan account. */
  | "WaitingForTransfer"
  /** Waiting for Swan compliance team to verify the shareholder. */
  | "WaitingForVerification";

/** Shareholder type to identify individuals and companies. */
export type ShareholderType =
  /** Company shareholder type. */
  | "Company"
  /** Individual shareholder type. */
  | "Individual";

export type ShippingProvider =
  | "CorreosTracked"
  | "CorreosUntracked"
  | "DHL"
  | "LaPosteTracked"
  | "LaPosteUntracked"
  | "NACEX";

/** Inputs to approve a capital deposit case. */
export type SimulateApproveCapitalDepositCaseInput = {
  /** Identifier of capital deposit case to validated. */
  capitalDepositCaseId: Scalars["String"]["input"];
};

export type SimulateApproveCapitalDepositCasePayload =
  | CouldNotFindCapitalDepositCaseRejection
  | SimulateApproveCapitalDepositCaseSuccessPayload;

export type SimulateApproveCapitalDepositCaseSuccessPayload = {
  __typename: "SimulateApproveCapitalDepositCaseSuccessPayload";
  id: Scalars["String"]["output"];
};

/**
 * Inputs to update a capital deposit document status.
 * Automatically uploads the document if the document status in input is UPLOADED.
 */
export type SimulateCapitalDepositDocumentStatusInput = {
  /** Identifier of capital deposit document. */
  documentId: Scalars["String"]["input"];
  /** Document refusal reason code for refused capital deposit document. */
  documentRefusalReasonCode?: InputMaybe<DocumentReasonCode>;
  /** Status of capital deposit document. */
  documentStatus: CapitalDepositDocumentStatus;
};

export type SimulateCapitalDepositDocumentStatusPayload =
  | CouldNotFindCapitalDepositCaseRejection
  | CouldNotFindCapitalDepositDocumentRejection
  | CouldNotRejectCapitalDepositDocumentRejection
  | CouldNotUpdateCapitalDepositDocumentStatusRejection
  | CouldNotUploadCapitalDepositDocumentRejection
  | SimulateCapitalDepositDocumentStatusSuccessPayload;

export type SimulateCapitalDepositDocumentStatusSuccessPayload = {
  __typename: "SimulateCapitalDepositDocumentStatusSuccessPayload";
  id: Scalars["String"]["output"];
};

/** Input of simulateCardTransactionEnrichment mutation */
export type SimulateCardTransactionEnrichmentInput = {
  /** Merchant address, if nothing entered genereted randomly */
  address?: InputMaybe<Scalars["String"]["input"]>;
  /** Transaction carbon footprint in micrograms of CO2 emitted, if nothing entered genereted randomly */
  carbonFootprint?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant category, if nothing entered default to 'Other' */
  category?: InputMaybe<MerchantCategory>;
  /** Merchant city, if nothing entered genereted randomly */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant email, if nothing entered default to 'noreply@swan.io' */
  contactEmail?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant phone number, if nothing entered default to '+33123456789' */
  contactPhone?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant website, if nothing entered default to 'https://www.swan.io/contact' */
  contactWebsite?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant country, if nothing entered genereted randomly */
  country?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Enhanced merchant name, if nothing entered genereted randomly */
  enrichedMerchantName?: InputMaybe<Scalars["String"]["input"]>;
  /** Is transaction a subcription, if nothing entered default to false */
  isSubscription?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Merchant latitude, if nothing entered genereted randomly */
  latitude?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant longitude, if nothing entered genereted randomly */
  longitude?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant postal code, if nothing entered genereted randomly */
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant subcategory, if nothing entered default to 'Other' */
  subcategory?: InputMaybe<MerchantSubCategory>;
  /** Card transaction id */
  transactionId: Scalars["ID"]["input"];
};

export type SimulateCardTransactionEnrichmentPayload =
  | ForbiddenRejection
  | SimulateCardTransactionEnrichmentRejection
  | SimulateCardTransactionEnrichmentSuccessPayload;

export type SimulateCardTransactionEnrichmentRejection = Rejection & {
  __typename: "SimulateCardTransactionEnrichmentRejection";
  message: Scalars["String"]["output"];
};

export type SimulateCardTransactionEnrichmentSuccessPayload = {
  __typename: "SimulateCardTransactionEnrichmentSuccessPayload";
  enrichedData: EnrichedTransactionInfo;
  transactionId: Scalars["ID"]["output"];
};

/** A rejection returned when the simulation couldn't be performed because of a functional error */
export type SimulateCreditLimitUpdatedRejection = {
  __typename: "SimulateCreditLimitUpdatedRejection";
  code: SimulateCreditLimitUpdatedRejectionCode;
  message: Scalars["String"]["output"];
};

export type SimulateCreditLimitUpdatedRejectionCode =
  | "AccountHolder_NotFound"
  | "BadRequest_Error"
  | "CreditLimitSettingsNotFound_Error"
  | "CreditLimitSettingsRequestNotFound_Error"
  | "Forbidden_Error"
  | "Technical";

/** The response to a simulation call. */
export type SimulateCreditLimitUpdatedResponse =
  | SimulateCreditLimitUpdatedRejection
  | SimulateCreditLimitUpdatedSuccessResponse;

export type SimulateCreditLimitUpdatedStatus = "Accepted" | "Refused" | "Revised";

/** A successful response to a credit limit simulation call. */
export type SimulateCreditLimitUpdatedSuccessResponse = {
  __typename: "SimulateCreditLimitUpdatedSuccessResponse";
  /** Will alway be true and mean that the simulation was successfully executed */
  noop?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Inputs to request a credit limit */
export type SimulateCreditLimitUpdatedWebhookInput = {
  /** The accountId which will benefits of the credit limits */
  accountId: Scalars["String"]["input"];
  authorizedAmount?: InputMaybe<AmountInput>;
  status: SimulateCreditLimitUpdatedStatus;
};

export type SimulateIncomingCardAuthorizationAuthorization = {
  rejectedReasonCode?: InputMaybe<SimulationFailedCardMerchantPaymentRejectedReason>;
  /** Set this to "Authorized" to simulate a successful payment, and to "Rejected" to simulate a failed payment. You can't authorize a payment successfully with a failed 3DS. However, the authorization can be rejected even if 3DS succeed. */
  status: SimulateIncomingCardAuthorizationStatus;
};

export type SimulateIncomingCardAuthorizationCardCategory = "Commercial" | "Consumer";

export type SimulateIncomingCardAuthorizationCardDetails = {
  /** The category of the card used for the payment, eg, Commercial or Consumer. */
  category: SimulateIncomingCardAuthorizationCardCategory;
  /** The 3-letters code indicating the country of the card used for the payment. */
  country: Scalars["String"]["input"];
  /** The scheme of the card used for the payment, eg, Visa, Mastercard or CartesBancaires. */
  scheme: SimulateIncomingCardAuthorizationCardScheme;
  /** The type of the card used for the payment, eg, Credit, Debit, Prepaid, Charge or DeferredDebit. */
  type: SimulateIncomingCardAuthorizationCardType;
};

export type SimulateIncomingCardAuthorizationCardScheme = "CartesBancaires" | "Mastercard" | "Visa";

export type SimulateIncomingCardAuthorizationCardType =
  | "Charge"
  | "Credit"
  | "Debit"
  | "DeferredDebit"
  | "Prepaid";

export type SimulateIncomingCardAuthorizationInput = {
  /** The status of the authorization returned by the issuing bank. Use this to simulate the success or failure of a payment. This can't be set to "Authorized" if 3DS status is set to "Failed". However, the authorization can be rejected even if 3DS succeed. */
  authorization: SimulateIncomingCardAuthorizationAuthorization;
  /** The details of the card used for the payment. Use this to simulate using a specific card for the payment. */
  cardDetails: SimulateIncomingCardAuthorizationCardDetails;
  /** ID of the related payment link */
  paymentLinkId: Scalars["ID"]["input"];
  /** The status of the payer authentication returned by the issuing bank. Use this to simulate the success or failure of the 3DS authentication. This can't be set to "Failed" if the Authorization status is set to "Authorized". */
  threeDS: SimulateIncomingCardAuthorizationThreeDs;
};

/** SimulateIncomingCardAuthorizationPayload */
export type SimulateIncomingCardAuthorizationPayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | NotFoundRejection
  | SimulateIncomingCardAuthorizationSuccessPayload
  | ValidationRejection;

export type SimulateIncomingCardAuthorizationStatus = "Authorized" | "Rejected";

/** SimulateIncomingCardAuthorizationSuccessPayload */
export type SimulateIncomingCardAuthorizationSuccessPayload = {
  __typename: "SimulateIncomingCardAuthorizationSuccessPayload";
  cardMandateId: Scalars["ID"]["output"];
  paymentId: Scalars["ID"]["output"];
  paymentLinkId: Scalars["ID"]["output"];
};

export type SimulateIncomingCardAuthorizationThreeDs = {
  rejectedReasonCode?: InputMaybe<SimulationFailedThreeDsReason>;
  status: SimulateIncomingCardAuthorizationThreeDsStatus;
};

/** Set this to "Successful" to simulate a successful authentication, and to "Failed" to simulate a failed authentication. You can't authorize a payment successfully with a failed 3DS. However, the authorization can be rejected even if 3DS succeed. */
export type SimulateIncomingCardAuthorizationThreeDsStatus = "Failed" | "Successful";

/** Book an incoming card transaction simulation input */
export type SimulateIncomingCardBookingInput = {
  /** Transaction ID to be booked */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingCardBookingPayload =
  | ForbiddenRejection
  | SimulateIncomingCardBookingSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateIncomingCardBookingSuccessPayload = {
  __typename: "SimulateIncomingCardBookingSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Book an incoming check simulation input */
export type SimulateIncomingCheckBookingInput = {
  /** Transaction ID to be booked */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingCheckBookingPayload =
  | ForbiddenRejection
  | SimulateIncomingCheckBookingSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateIncomingCheckBookingSuccessPayload = {
  __typename: "SimulateIncomingCheckBookingSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

export type SimulateIncomingCheckRejectionErrorPayload = {
  __typename: "SimulateIncomingCheckRejectionErrorPayload";
  reason: Scalars["String"]["output"];
};

/** Reject incoming Check simulation input */
export type SimulateIncomingCheckRejectionInput = {
  /** Rejection reason code */
  reasonCode?: InputMaybe<IncomingCheckRejectionReasonCodeEnum>;
  /** Transaction ID to be Rejected */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingCheckRejectionPayload =
  | ForbiddenRejection
  | SimulateIncomingCheckRejectionErrorPayload
  | SimulateIncomingCheckRejectionSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateIncomingCheckRejectionSuccessPayload = {
  __typename: "SimulateIncomingCheckRejectionSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Return a booked incoming check simulation input */
export type SimulateIncomingCheckReturnInput = {
  /** Return reason code */
  reasonCode?: InputMaybe<CheckReturnReasonCodeEnum>;
  /** Transaction ID to be booked */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingCheckReturnPayload =
  | ForbiddenRejection
  | SimulateIncomingCheckReturnSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateIncomingCheckReturnSuccessPayload = {
  __typename: "SimulateIncomingCheckReturnSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Book an outgoing transfer simulation input */
export type SimulateIncomingInternalDirectDebitBookingInput = {
  /** Transaction ID to be booked */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingInternalDirectDebitBookingPayload =
  | ForbiddenRejection
  | SimulateIncomingInternalDirectDebitBookingSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateIncomingInternalDirectDebitBookingSuccessPayload = {
  __typename: "SimulateIncomingInternalDirectDebitBookingSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

export type SimulateIncomingInternalDirectDebitRejectionErrorPayload = {
  __typename: "SimulateIncomingInternalDirectDebitRejectionErrorPayload";
  reason: Scalars["String"]["output"];
};

/** Reject incoming SEPA Direct Debit simulation input */
export type SimulateIncomingInternalDirectDebitRejectionInput = {
  /** Rejection reason code */
  reasonCode?: InputMaybe<IncomingInternalDirectDebitRejectionReasonCodeEnum>;
  /** Transaction ID to be Rejected */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingInternalDirectDebitRejectionPayload =
  | ForbiddenRejection
  | SimulateIncomingInternalDirectDebitRejectionErrorPayload
  | SimulateIncomingInternalDirectDebitRejectionSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateIncomingInternalDirectDebitRejectionSuccessPayload = {
  __typename: "SimulateIncomingInternalDirectDebitRejectionSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

export type SimulateIncomingInternalDirectDebitReturnErrorPayload = {
  __typename: "SimulateIncomingInternalDirectDebitReturnErrorPayload";
  reason: Scalars["String"]["output"];
};

/** Return incoming SEPA Direct Debit simulation input */
export type SimulateIncomingInternalDirectDebitReturnInput = {
  /** Return reason code */
  reasonCode: IncomingInternalDirectDebitReturnReasonCodeEnum;
  /** Transaction ID to be Returned */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingInternalDirectDebitReturnPayload =
  | ForbiddenRejection
  | SimulateIncomingInternalDirectDebitReturnErrorPayload
  | SimulateIncomingInternalDirectDebitReturnSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateIncomingInternalDirectDebitReturnSuccessPayload = {
  __typename: "SimulateIncomingInternalDirectDebitReturnSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

export type SimulateIncomingInternationalCreditTransferInput = {
  /** Amount of the incoming credit transfer */
  amount: AmountInput;
  /** Creditor IBAN. Your Swan IBAN if you want to receive a credit transfer in your Swan account */
  creditorIban: Scalars["IBAN"]["input"];
  /** Creditor name */
  creditorName: Scalars["String"]["input"];
  /** Debtor IBAN. It should be a valid IBAN */
  debtorIban: Scalars["IBAN"]["input"];
  /** Debtor name */
  debtorName: Scalars["String"]["input"];
  /** Label */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** External identifier of the transaction */
  reference?: InputMaybe<Scalars["String"]["input"]>;
};

/** SimulateIncomingInternationalCreditTransferPayload */
export type SimulateIncomingInternationalCreditTransferPayload =
  | AccountNotFoundRejection
  | ForbiddenRejection
  | SimulateIncomingInternationalCreditTransferSuccessPayload;

/** Return an incoming transfer simulation input */
export type SimulateIncomingInternationalCreditTransferReturnInput = {
  /** Reason of the return */
  reasonCode: IncomingInternationalCreditTransferReturnReasonCode;
  /** Transaction ID to return */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingInternationalCreditTransferReturnPayload =
  | ForbiddenRejection
  | IncorrectTransactionTypeRejection
  | SimulateIncomingInternationalCreditTransferReturnSuccessPayload
  | TransactionAlreadyReturnedRejection
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateIncomingInternationalCreditTransferReturnSuccessPayload = {
  __typename: "SimulateIncomingInternationalCreditTransferReturnSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** SimulateIncomingInternationalCreditTransferSuccessPayload */
export type SimulateIncomingInternationalCreditTransferSuccessPayload = {
  __typename: "SimulateIncomingInternationalCreditTransferSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Recall an incoming transfer simulation input */
export type SimulateIncomingSepaCreditTransferAcceptedRecallInput = {
  /** Reason code for incoming transfer recall */
  reasonCode: SepaCreditTransferRecallReasonCodeEnum;
  /** Transaction ID to be recalled */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingSepaCreditTransferAcceptedRecallPayload =
  | ForbiddenRejection
  | SimulateIncomingSepaCreditTransferAcceptedRecallSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateIncomingSepaCreditTransferAcceptedRecallSuccessPayload = {
  __typename: "SimulateIncomingSepaCreditTransferAcceptedRecallSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingSepaCreditTransferReceptionPayload =
  | ForbiddenRejection
  | SimulateIncomingSepaCreditTransferReceptionSuccessPayload;

/** Success payload type */
export type SimulateIncomingSepaCreditTransferReceptionSuccessPayload = {
  __typename: "SimulateIncomingSepaCreditTransferReceptionSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Return an incoming transfer simulation input */
export type SimulateIncomingSepaCreditTransferReturnInput = {
  /** Reason code for incoming transfer return */
  reasonCode: SepaCreditTransferReturnReasonCodeEnum;
  /** Transaction ID to be returned */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingSepaCreditTransferReturnPayload =
  | ForbiddenRejection
  | SimulateIncomingSepaCreditTransferReturnSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateIncomingSepaCreditTransferReturnSuccessPayload = {
  __typename: "SimulateIncomingSepaCreditTransferReturnSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Book an outgoing transfer simulation input */
export type SimulateIncomingSepaDirectDebitBookingInput = {
  /** Transaction ID to be booked */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingSepaDirectDebitBookingPayload =
  | ForbiddenRejection
  | SimulateIncomingSepaDirectDebitBookingSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateIncomingSepaDirectDebitBookingSuccessPayload = {
  __typename: "SimulateIncomingSepaDirectDebitBookingSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

export type SimulateIncomingSepaDirectDebitRejectionErrorPayload = {
  __typename: "SimulateIncomingSepaDirectDebitRejectionErrorPayload";
  reason: Scalars["String"]["output"];
};

/** Reject incoming SEPA Direct Debit simulation input */
export type SimulateIncomingSepaDirectDebitRejectionInput = {
  /** Rejection reason code */
  reasonCode?: InputMaybe<IncomingSepaDirectDebitRejectionReasonCodeEnum>;
  /** Transaction ID to be Rejected */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingSepaDirectDebitRejectionPayload =
  | ForbiddenRejection
  | SimulateIncomingSepaDirectDebitRejectionErrorPayload
  | SimulateIncomingSepaDirectDebitRejectionSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateIncomingSepaDirectDebitRejectionSuccessPayload = {
  __typename: "SimulateIncomingSepaDirectDebitRejectionSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

export type SimulateIncomingSepaDirectDebitReturnErrorPayload = {
  __typename: "SimulateIncomingSepaDirectDebitReturnErrorPayload";
  reason: Scalars["String"]["output"];
};

/** Return incoming SEPA Direct Debit simulation input */
export type SimulateIncomingSepaDirectDebitReturnInput = {
  /** Return reason code */
  reasonCode?: InputMaybe<IncomingSepaDirectDebitReturnReasonCodeEnum>;
  /** Transaction ID to be returned */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateIncomingSepaDirectDebitReturnPayload =
  | ForbiddenRejection
  | SimulateIncomingSepaDirectDebitReturnErrorPayload
  | SimulateIncomingSepaDirectDebitReturnSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateIncomingSepaDirectDebitReturnSuccessPayload = {
  __typename: "SimulateIncomingSepaDirectDebitReturnSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Input to enable an insurance subscription */
export type SimulateInsuranceSubscriptionEnablementInput = {
  /** Unique identifier of a card contract */
  cardId: Scalars["ID"]["input"];
};

/** Union of all possible payloads for insurance subscription enablement process */
export type SimulateInsuranceSubscriptionEnablementPayload =
  | BadRequestRejection
  | ForbiddenRejection
  | SimulateInsuranceSubscriptionEnablementSuccessPayload;

export type SimulateInsuranceSubscriptionEnablementSuccessPayload = {
  __typename: "SimulateInsuranceSubscriptionEnablementSuccessPayload";
  /** Unique identifier of the enabled insurance contract */
  insuranceSubscriptionId: Scalars["ID"]["output"];
};

export type SimulateInvoiceGenerationInput = {
  /** ID of the account for which we want to generate an invoice */
  accountId: Scalars["ID"]["input"];
};

export type SimulateInvoiceGenerationPayload =
  | AccountNotEligibleRejection
  | AccountNotFoundRejection
  | ForbiddenRejection
  | SimulateInvoiceGenerationSuccessPayload;

export type SimulateInvoiceGenerationPayloadStatus = "Pending" | "Succeeded";

export type SimulateInvoiceGenerationSuccessPayload = {
  __typename: "SimulateInvoiceGenerationSuccessPayload";
  /** The generated invoice */
  invoice?: Maybe<Invoice>;
  status: SimulateInvoiceGenerationPayloadStatus;
};

/** Input to simulate a manual banking fee */
export type SimulateManualBankingFeeInput = {
  /** ID of the account for which we want add a banking fee manually */
  accountId: Scalars["ID"]["input"];
  /**
   * Related due amount
   * Used when the banking fee is a percentage of initial amount
   */
  dueAmount?: InputMaybe<AmountInput>;
  /**
   * When is it booked ?
   * cf. https://docs.swan.io/concept/account/billing
   */
  effectiveDate: Scalars["DateTime"]["input"];
  /** Type of banking fee to add */
  type: ManualBankingFee;
};

export type SimulateManualBankingFeePayload =
  | AccountNotEligibleRejection
  | AccountNotFoundRejection
  | ForbiddenRejection
  | SimulateManualBankingFeeSuccessPayload;

export type SimulateManualBankingFeeSuccessPayload = {
  __typename: "SimulateManualBankingFeeSuccessPayload";
  /** amount to debit on the account */
  debitedAmount?: Maybe<Amount>;
  /** internal ID of this usage */
  id: Scalars["ID"]["output"];
};

export type SimulateMerchantPaymentMethodRequestOutcomeInput = {
  merchantPaymentMethodId: Scalars["ID"]["input"];
  /** In case status is Rejected, merchantPaymentMethodRejectionReason will soon be mandatory */
  merchantPaymentMethodRejectionReason?: InputMaybe<MerchantPaymentMethodRejectionReason>;
  merchantPaymentMethodStatus: MerchantPaymentMethodStatus;
  /** In case status is WaitingForInformation, at least one merchantVerificationRequirements is mandatory */
  merchantVerificationRequirements?: InputMaybe<MerchantVerificationRequirementInput>;
};

/** SimulateMerchantPaymentMethodPayload */
export type SimulateMerchantPaymentMethodRequestOutcomePayload =
  | CardMerchantPaymentMethod
  | CheckMerchantPaymentMethod
  | ForbiddenRejection
  | InPersonCardMerchantPaymentMethod
  | InternalDirectDebitB2BMerchantPaymentMethod
  | InternalDirectDebitStandardMerchantPaymentMethod
  | InternalErrorRejection
  | MerchantPaymentMethodWrongStatusRejection
  | MerchantProfileUpdateRequestPendingRejection
  | NotFoundRejection
  | RejectionReasonMandatoryRejection
  | SepaDirectDebitB2BMerchantPaymentMethod
  | SepaDirectDebitCoreMerchantPaymentMethod
  | ValidationRejection
  | VerificationRequirementsMandatoryRejection;

export type SimulateMerchantPaymentMethodUpdateRequestOutcomeInput = {
  /** Whether the update is approved or not */
  requestedUpdateApproved: Scalars["Boolean"]["input"];
  /** ID of the Merchant PaymentMethod update request to simulate the outcome of */
  updateRequestId: Scalars["ID"]["input"];
};

/** SimulateMerchantPaymentMethodUpdateRequestOutcomePayload */
export type SimulateMerchantPaymentMethodUpdateRequestOutcomePayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | NotFoundRejection
  | SimulateMerchantPaymentMethodUpdateRequestOutcomeSuccessPayload;

/** SimulateMerchantPaymentMethodUpdateRequestOutcomeSuccessPayload */
export type SimulateMerchantPaymentMethodUpdateRequestOutcomeSuccessPayload = {
  __typename: "SimulateMerchantPaymentMethodUpdateRequestOutcomeSuccessPayload";
  updateRequestId: Scalars["ID"]["output"];
};

export type SimulateMerchantProfileRequestOutcomeInput = {
  /** ID of the Merchant Profile to update */
  merchantProfileId: Scalars["ID"]["input"];
  /** In case status is Rejected, merchantProfileRejectionReason is mandatory */
  merchantProfileRejectionReason?: InputMaybe<MerchantProfileRejectionReason>;
  /** Desired status of the Merchant Profile */
  merchantProfileStatus?: InputMaybe<MerchantProfileStatus>;
};

/** SimulateMerchantProfileRequestOutcomePayload */
export type SimulateMerchantProfileRequestOutcomePayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | MerchantProfileWrongStatusRejection
  | NotFoundRejection
  | RejectionReasonMandatoryRejection
  | SimulateMerchantProfileRequestOutcomeSuccessPayload;

/** SimulateMerchantProfileRequestOutcomeSuccessPayload */
export type SimulateMerchantProfileRequestOutcomeSuccessPayload = {
  __typename: "SimulateMerchantProfileRequestOutcomeSuccessPayload";
  merchantProfile: MerchantProfile;
};

export type SimulateMerchantProfileUpdateRequestOutcomeInput = {
  /** ID of the Merchant Profile update request to simulate the outcome of */
  merchantProfileId: Scalars["ID"]["input"];
  /** Whether the update is approved or not */
  requestedUpdateApproved: Scalars["Boolean"]["input"];
};

/** SimulateMerchantProfileUpdateRequestOutcomePayload */
export type SimulateMerchantProfileUpdateRequestOutcomePayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | NotFoundRejection
  | SimulateMerchantProfileUpdateRequestOutcomeSuccessPayload;

/** SimulateMerchantProfileUpdateRequestOutcomeSuccessPayload */
export type SimulateMerchantProfileUpdateRequestOutcomeSuccessPayload = {
  __typename: "SimulateMerchantProfileUpdateRequestOutcomeSuccessPayload";
  updateRequestId: Scalars["ID"]["output"];
};

/** Request a card advice simulation input */
export type SimulateOutgoingCardAdviceInput = {
  amount: AmountInput;
  /** Card transaction category */
  cardTransactionCategory?: InputMaybe<CardTransactionCategory>;
  /** Expiration date time */
  expirationDateTime?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Merchant */
  merchant?: InputMaybe<Merchant>;
  /** Original amount */
  originalAmount?: InputMaybe<AmountInput>;
  /** Authorization wanted outcome */
  outcome?: InputMaybe<CardAuthorizationOutcome>;
  /** Terminal ID */
  terminalId?: InputMaybe<Scalars["String"]["input"]>;
  /** Transaction ID */
  transactionId: Scalars["ID"]["input"];
  transactionTransportType?: InputMaybe<TransactionTransportType>;
};

/** Request a card authorization simulation input */
export type SimulateOutgoingCardAuthorizationInput = {
  allowsPartialAuthorization?: InputMaybe<Scalars["Boolean"]["input"]>;
  amount?: InputMaybe<AmountInput>;
  /** Authorization request type */
  authorizationType?: InputMaybe<CardAuthorizationType>;
  /** Card ID */
  cardId: Scalars["String"]["input"];
  /** Card transaction category */
  cardTransactionCategory?: InputMaybe<CardTransactionCategory>;
  /** Simulation card type */
  cardType?: InputMaybe<SimulationCardType>;
  /** Expiration date time */
  expirationDateTime?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Merchant */
  merchant?: InputMaybe<Merchant>;
  /** Operation type */
  operationType?: InputMaybe<CardAuthorizationOperationType>;
  /** Original amount */
  originalAmount?: InputMaybe<AmountInput>;
  /** Authorization wanted outcome */
  outcome?: InputMaybe<CardAuthorizationOutcome>;
  /** Terminal ID */
  terminalId?: InputMaybe<Scalars["String"]["input"]>;
  transactionTransportType?: InputMaybe<TransactionTransportType>;
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingCardAuthorizationPayload =
  | CardNotFoundRejection
  | ForbiddenRejection
  | SimulateOutgoingCardAuthorizationRejectPayload
  | SimulateOutgoingCardAuthorizationSuccessPayload;

/** Reject payload type */
export type SimulateOutgoingCardAuthorizationRejectPayload = {
  __typename: "SimulateOutgoingCardAuthorizationRejectPayload";
  rejectedReason: Scalars["String"]["output"];
  transactionId: Scalars["ID"]["output"];
};

/** Input to simulate a release of a card authorization */
export type SimulateOutgoingCardAuthorizationReleaseInput = {
  reason?: InputMaybe<CardAuthorizationReleaseReason>;
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingCardAuthorizationReleasePayload =
  | ForbiddenRejection
  | SimulateOutgoingCardAuthorizationReleaseSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingCardAuthorizationReleaseSuccessPayload = {
  __typename: "SimulateOutgoingCardAuthorizationReleaseSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Success payload type */
export type SimulateOutgoingCardAuthorizationSuccessPayload = {
  __typename: "SimulateOutgoingCardAuthorizationSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Credit a card simulation input */
export type SimulateOutgoingCardCreditInput = {
  /** Amount */
  amount: AmountInput;
  /** Card ID */
  cardId: Scalars["String"]["input"];
  /** Card type */
  cardType?: InputMaybe<SimulationCardType>;
  /** Merchant Category Code */
  merchantCategoryCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant City */
  merchantCity?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant Country */
  merchantCountry?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Merchant Id */
  merchantId?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant Name */
  merchantName?: InputMaybe<Scalars["String"]["input"]>;
  /** Merchant Postal Code */
  merchantPostalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Origin Transaction ID */
  originTransactionId?: InputMaybe<Scalars["String"]["input"]>;
  /** Original amount */
  originalAmount?: InputMaybe<AmountInput>;
  /** Terminal Id */
  terminalId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingCardCreditPayload =
  | CardNotFoundRejection
  | ForbiddenRejection
  | SimulateOutgoingCardCreditSuccessPayload;

/** Reverse a credit simulation input */
export type SimulateOutgoingCardCreditReverseInput = {
  /** Amount */
  amount?: InputMaybe<AmountInput>;
  /** Original amount */
  originalAmount?: InputMaybe<AmountInput>;
  /** Transaction ID to be reversed */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingCardCreditReversePayload =
  | ForbiddenRejection
  | SimulateOutgoingCardCreditReverseSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingCardCreditReverseSuccessPayload = {
  __typename: "SimulateOutgoingCardCreditReverseSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Success payload type */
export type SimulateOutgoingCardCreditSuccessPayload = {
  __typename: "SimulateOutgoingCardCreditSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Debit a card simulation input */
export type SimulateOutgoingCardDebitInput = {
  /** Amount */
  amount?: InputMaybe<AmountInput>;
  /** Originalmount */
  originalAmount?: InputMaybe<AmountInput>;
  /** Transaction ID to be debited */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingCardDebitPayload =
  | CardNotFoundRejection
  | ForbiddenRejection
  | SimulateOutgoingCardDebitSuccessPayload
  | TransactionNotFoundRejection;

/** Debit Reversal simulation input */
export type SimulateOutgoingCardDebitReverseInput = {
  /** Amount */
  amount?: InputMaybe<AmountInput>;
  /** Originalmount */
  originalAmount?: InputMaybe<AmountInput>;
  /** Transaction ID to be reversed */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingCardDebitReversePayload =
  | ForbiddenRejection
  | SimulateOutgoingCardDebitReverseSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingCardDebitReverseSuccessPayload = {
  __typename: "SimulateOutgoingCardDebitReverseSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Success payload type */
export type SimulateOutgoingCardDebitSuccessPayload = {
  __typename: "SimulateOutgoingCardDebitSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Book an outgoing transfer simulation input */
export type SimulateOutgoingInternationalCreditTransferBookingInput = {
  /** Transaction ID to be booked */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingInternationalCreditTransferBookingPayload =
  | ForbiddenRejection
  | SimulateOutgoingInternationalCreditTransferBookingSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingInternationalCreditTransferBookingSuccessPayload = {
  __typename: "SimulateOutgoingInternationalCreditTransferBookingSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Reject an outgoing transfer simulation input */
export type SimulateOutgoingInternationalCreditTransferRejectionInput = {
  /** Transaction ID to be booked */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingInternationalCreditTransferRejectionPayload =
  | ForbiddenRejection
  | SimulateOutgoingInternationalCreditTransferRejectionSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingInternationalCreditTransferRejectionSuccessPayload = {
  __typename: "SimulateOutgoingInternationalCreditTransferRejectionSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Return an outgoing transfer simulation input */
export type SimulateOutgoingInternationalCreditTransferReturnInput = {
  /** Reason of the return */
  reasonCode: OutgoingInternationalCreditTransferReturnReasonCode;
  /** Transaction ID to return */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingInternationalCreditTransferReturnPayload =
  | ForbiddenRejection
  | SimulateOutgoingInternationalCreditTransferReturnSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingInternationalCreditTransferReturnSuccessPayload = {
  __typename: "SimulateOutgoingInternationalCreditTransferReturnSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Recall an outgoing transfer simulation input */
export type SimulateOutgoingSepaCreditTransferAcceptedRecallInput = {
  /** Recall reason code */
  reasonCode: SepaCreditTransferRecalledReasonCodeEnum;
  /** Transaction ID to be recalled */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingSepaCreditTransferAcceptedRecallPayload =
  | ForbiddenRejection
  | SimulateOutgoingSepaCreditTransferAcceptedRecallSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingSepaCreditTransferAcceptedRecallSuccessPayload = {
  __typename: "SimulateOutgoingSepaCreditTransferAcceptedRecallSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Book an outgoing transfer simulation input */
export type SimulateOutgoingSepaCreditTransferBookingInput = {
  /** Transaction ID to be booked */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingSepaCreditTransferBookingPayload =
  | ForbiddenRejection
  | SimulateOutgoingSepaCreditTransferBookingSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingSepaCreditTransferBookingSuccessPayload = {
  __typename: "SimulateOutgoingSepaCreditTransferBookingSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Reject an outgoing transfer simulation input */
export type SimulateOutgoingSepaCreditTransferRejectionInput = {
  /** Rejection reason code */
  reasonCode: SepaCreditTransferRejectionReasonCodeEnum;
  /** Transaction ID to be rejected */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingSepaCreditTransferRejectionPayload =
  | ForbiddenRejection
  | SimulateOutgoingSepaCreditTransferRejectionSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingSepaCreditTransferRejectionSuccessPayload = {
  __typename: "SimulateOutgoingSepaCreditTransferRejectionSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Return an outgoing transfer simulation input */
export type SimulateOutgoingSepaCreditTransferReturnInput = {
  /** Return reason code */
  reasonCode: SepaCreditTransferReturnedReasonCodeEnum;
  /** Transaction ID to be returned */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingSepaCreditTransferReturnPayload =
  | ForbiddenRejection
  | SimulateOutgoingSepaCreditTransferReturnSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingSepaCreditTransferReturnSuccessPayload = {
  __typename: "SimulateOutgoingSepaCreditTransferReturnSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Cancel a direct debit instruction simulation input */
export type SimulateOutgoingSepaDirectDebitCancelInput = {
  /** Cancelation reason code */
  reasonCode: SepaDirectDebitCancelReasonCodeEnum;
  /** Transaction ID to be cancelled */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingSepaDirectDebitCancelPayload =
  | ForbiddenRejection
  | SimulateOutgoingSepaDirectDebitCancelSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingSepaDirectDebitCancelSuccessPayload = {
  __typename: "SimulateOutgoingSepaDirectDebitCancelSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Receive a direct debit instruction simulation input */
export type SimulateOutgoingSepaDirectDebitReceptionInput = {
  /** Amount */
  amount: AmountInput;
  /** Creditor account */
  creditor: SepaDirectDebitAccount;
  /** Debtor IBAN. It should be your Swan IBAN */
  debtorIban: Scalars["IBAN"]["input"];
  /** SEPA end to end reference */
  endToEndId?: InputMaybe<Scalars["SepaReference"]["input"]>;
  /**
   * Requested execution date with date time format (ISO 8601 with time information). It can't be in the past
   * ex: 2021-04-12T16:28:22.867Z
   */
  executionDate: Scalars["DateTime"]["input"];
  /** Displayed label in Swan account */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Mandate amendment info */
  mandateAmendment?: InputMaybe<MandateAmendment>;
  /** SEPA mandate reference */
  mandateReference: Scalars["SepaReference"]["input"];
  /** SEPA direct debit mandate sequence */
  mandateSequence: SepaReceivedDirectDebitMandateSequence;
  /** Received SEPA direct debit mandate type */
  mandateType: SepaReceivedDirectDebitMandateType;
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingSepaDirectDebitReceptionPayload =
  | ForbiddenRejection
  | SimulateOutgoingSepaDirectDebitReceptionSuccessPayload;

/** Success payload type */
export type SimulateOutgoingSepaDirectDebitReceptionSuccessPayload = {
  __typename: "SimulateOutgoingSepaDirectDebitReceptionSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Reject a received direct debit instruction simulation input */
export type SimulateOutgoingSepaDirectDebitRejectInput = {
  /** Rejection reason code */
  reasonCode: SepaDirectDebitRejectReasonCodeEnum;
  /** Transaction ID to be rejected */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingSepaDirectDebitRejectPayload =
  | ForbiddenRejection
  | SimulateOutgoingSepaDirectDebitRejectSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingSepaDirectDebitRejectSuccessPayload = {
  __typename: "SimulateOutgoingSepaDirectDebitRejectSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Request a direct debit refund simulation */
export type SimulateOutgoingSepaDirectDebitReturnInput = {
  /** Refund reason code */
  reasonCode: SepaDirectDebitReturnReasonCodeEnum;
  /** Transaction ID to be returned */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingSepaDirectDebitReturnPayload =
  | ForbiddenRejection
  | SimulateOutgoingSepaDirectDebitReturnSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingSepaDirectDebitReturnSuccessPayload = {
  __typename: "SimulateOutgoingSepaDirectDebitReturnSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Receive a direct debit reversal simulation */
export type SimulateOutgoingSepaDirectDebitReverseInput = {
  /** Reversal reason code */
  reasonCode: SepaDirectDebitReverseReasonCodeEnum;
  /** Transaction ID to be reversed */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateOutgoingSepaDirectDebitReversePayload =
  | ForbiddenRejection
  | SimulateOutgoingSepaDirectDebitReverseSuccessPayload
  | TransactionNotFoundRejection;

/** Success payload type */
export type SimulateOutgoingSepaDirectDebitReverseSuccessPayload = {
  __typename: "SimulateOutgoingSepaDirectDebitReverseSuccessPayload";
  transactionId: Scalars["ID"]["output"];
};

/** Input to simulate delivery of a physical card */
export type SimulatePhysicalCardDeliveryInput = {
  /** Unique identifier of a card */
  cardId: Scalars["ID"]["input"];
  /** Alphanumeric string with the tracking identifier of the delivery supplier. */
  trackingNumber?: InputMaybe<Scalars["String"]["input"]>;
};

/** Inputs to simulate physical card renewal process */
export type SimulatePhysicalCardRenewalProcessInput = {
  /** Unique identifier of a card */
  cardId: Scalars["ID"]["input"];
  /** Desired status to simulate part of the physical card renewal process */
  status: PhysicalCardRenewalStatus;
};

/** Union of all possible payloads for simulate physical card renewal process */
export type SimulatePhysicalCardRenewalProcessPayload =
  | CardNotFoundRejection
  | ForbiddenRejection
  | PhysicalCardWrongStatusRejection
  | SimulatePhysicalCardRenewalProcessSuccessPayload;

/** Simulate physical card renewal process success payload */
export type SimulatePhysicalCardRenewalProcessSuccessPayload = {
  __typename: "SimulatePhysicalCardRenewalProcessSuccessPayload";
  /** The physical card updated */
  physicalCard: PhysicalCard;
};

/** Release reserved balance input */
export type SimulateReleaseReservedBalanceInput = {
  /** Transaction ID to be release */
  transactionId: Scalars["ID"]["input"];
};

/** Union of Success payload and potential rejections */
export type SimulateReleaseReservedBalancePayload =
  | ForbiddenRejection
  | ReleaseReservedBalanceSuccessPayload
  | TransactionNotFoundRejection;

/** Input to request a repayment */
export type SimulateRepaymentInput = {
  /** The accountId related to the creditLimitSettings */
  accountId: Scalars["String"]["input"];
};

/** The response to a simulation call. */
export type SimulateRepaymentResponse =
  | AccountHolderNotFoundRejection
  | AccountNotFoundRejection
  | CreditLimitSettingsNotFoundRejection
  | ForbiddenRejection
  | SimulateRepaymentSuccessResponse;

/** A successful response to a repayment simulation call. */
export type SimulateRepaymentSuccessResponse = {
  __typename: "SimulateRepaymentSuccessResponse";
  /** The amount that will be repaid */
  amount?: Maybe<Amount>;
  /** The repayment internal id */
  repaymentId: Scalars["String"]["output"];
};

/** Input to request a repayment updated */
export type SimulateRepaymentUpdatedInput = {
  /** The accountId related to the creditLimitSettings */
  accountId: Scalars["String"]["input"];
  /** The repamyentId of the repayment target */
  repaymentId: Scalars["String"]["input"];
  /** The new repayment status */
  status: RepaymentStatus;
};

/** The response to a simulation call. */
export type SimulateRepaymentUpdatedResponse =
  | AccountHolderNotFoundRejection
  | AccountNotFoundRejection
  | CreditLimitSettingsNotFoundRejection
  | ForbiddenRejection
  | RepaymentNotFoundRejection
  | RepaymentWrongStatusRejection
  | RepaymentWrongStatusTransitionRejection
  | SimulateRepaymentUpdatedSuccessResponse;

/** A successful response to a repayment updated simulation call. */
export type SimulateRepaymentUpdatedSuccessResponse = {
  __typename: "SimulateRepaymentUpdatedSuccessResponse";
  /** Will alway be true and mean that the simulation was successfully executed */
  noop?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SimulateStartProjectBillingInput = {
  /** Name of the company to bill */
  companyName: Scalars["String"]["input"];
  /** E-mail which will receive the generated invoices each month */
  email: Scalars["String"]["input"];
};

export type SimulateStartProjectBillingPayload =
  | ForbiddenRejection
  | ProjectAlreadyHasSubscriptionRejection
  | SimulateStartProjectBillingSuccessPayload;

export type SimulateStartProjectBillingSuccessPayload = {
  __typename: "SimulateStartProjectBillingSuccessPayload";
  /** ID of the project billed */
  projectId: Scalars["ID"]["output"];
};

export type SimulateToRepayLoanInput = {
  /** The associated payoutLabel */
  payoutLabel: Scalars["String"]["input"];
  /** The transaction attached to the loan to be marked as toRepay */
  transactionId: Scalars["String"]["input"];
};

/** The response to a simulation call. */
export type SimulateToRepayLoanResponse =
  | ForbiddenRejection
  | SimulateToRepayLoanSuccessResponse
  | TransactionNotFoundRejection;

export type SimulateToRepayLoanSuccessResponse = {
  __typename: "SimulateToRepayLoanSuccessResponse";
  /** Will always be true and means that the simulation was successfully executed */
  noop?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SimulationCardType = "Physical" | "Virtual";

export type SimulationFailedCardMerchantPaymentRejectedReason =
  | "AmountInvalid"
  | "CardDetailsInvalid"
  | "CardExpired"
  | "InvalidPinAttemptsExceeded"
  | "RejectedByCardIssuer"
  | "SoftDecline3dsExpiration"
  | "SoftDecline3dsFailure"
  | "SoftDecline3dsNotSupported"
  | "SoftDecline3dsRequired"
  | "SoftDeclineCardAmountLimitsExceeded"
  | "SoftDeclineCardDetailsInvalid"
  | "SoftDeclineCardExpired"
  | "SoftDeclineCardNotActivated"
  | "SoftDeclineCardNotSupported"
  | "SoftDeclineCvcCheckFailed"
  | "SoftDeclineCvcInvalid"
  | "SoftDeclineInsufficientFunds"
  | "SoftDeclineRefundTimeLimitExceeded"
  | "SoftDeclineRejectedByCardIssuer"
  | "SoftDeclineSwanTechnicalErrorOccurred"
  | "SoftDeclineTransactionAmountIncorrect"
  | "SwanRefused"
  | "SwanTechnicalErrorOccurred";

export type SimulationFailedThreeDsReason = "AuthenticationExpired" | "AuthenticationFailed";

/** A rejection returned when the simulation couldn't be performed because of a functional error */
export type SimulationRejection = {
  __typename: "SimulationRejection";
  code: SimulationRejectionCode;
  message: Scalars["String"]["output"];
};

export type SimulationRejectionCode =
  | "CouldNotObtainIdentifier"
  | "CouldNotProvisionCard"
  | "CouldNotUpdateDeliveryInformation";

/**
 * The response to a simulation call.
 * Will alway be true and mean that the simulation was successfully executed
 */
export type SimulationResponse =
  | ForbiddenRejection
  | SimulationRejection
  | SimulationSuccessfulResponse
  | ValidationRejection;

/**
 * The response to a simulation call.
 * Will alway be true and mean that the simulation was successfully executed
 */
export type SimulationSuccessfulResponse = {
  __typename: "SimulationSuccessfulResponse";
  noop?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Spending */
export type Spending = {
  __typename: "Spending";
  /** amount spent during the period */
  amount?: Maybe<Amount>;
  /** period concerned */
  period: SpendingLimitPeriod;
};

/** Spending limits */
export type SpendingLimit = {
  __typename: "SpendingLimit";
  /** sum of amount of spending authorized during the period */
  amount: Amount;
  /** period concerned */
  period: SpendingLimitPeriod;
  /** type of limit (defined by the Partner, defined by Swan, etc.) */
  type: SpendingLimitType;
};

export type SpendingLimitCalendarDayModeInput = {
  /** a starting hour for the spending limit (0 to 23). */
  startHour?: Scalars["Int"]["input"];
};

export type SpendingLimitCalendarModeInput = {
  /** a daily based calendar spending limit. */
  daily?: InputMaybe<SpendingLimitCalendarDayModeInput>;
  /** a monthly based calendar spending limit. */
  monthly?: InputMaybe<SpendingLimitCalendarMonthModeInput>;
  /** a weekly based calendar spending limit. */
  weekly?: InputMaybe<SpendingLimitCalendarWeekModeInput>;
};

export type SpendingLimitCalendarMonthModeInput = {
  /** a day in month for the spending limit (1 to 31). */
  startDay?: Scalars["Int"]["input"];
  /** a starting hour for the spending limit (0 to 23). */
  startHour?: Scalars["Int"]["input"];
};

export type SpendingLimitCalendarWeekModeInput = {
  /** a day of week enum. */
  startDay?: DayEnum;
  /** a starting hour for the spending limit (0 to 23). */
  startHour?: Scalars["Int"]["input"];
};

/** Inputs when editing spending limit configuration */
export type SpendingLimitInput = {
  /** sum of amount of spending authorized during the period */
  amount: AmountInput;
  /** period concerned */
  period: SpendingLimitPeriodInput;
};

export type SpendingLimitModeInput = {
  /** a fixed calendar period starting either at a given hour of day, a given hour and day in week/month */
  calendar?: InputMaybe<SpendingLimitCalendarModeInput>;
  /** a rolling period, defining a period of x days/weeks/months. */
  rolling?: InputMaybe<SpendingLimitRollingModeInput>;
};

/** Available period to compute spending limits */
export type SpendingLimitPeriod = "Always" | "Daily" | "Monthly" | "Weekly";

/** Available period to compute spending limits */
export type SpendingLimitPeriodInput = "Always" | "Daily" | "Monthly" | "Weekly";

export type SpendingLimitRollingModeInput = {
  /** a rolling value for a spending limit. For a monthly period, only 1 is valid. */
  rollingValue: Scalars["Int"]["input"];
};

/** Available type of spending limits */
export type SpendingLimitType =
  /** for the account holder - defined by the partner */
  | "AccountHolder"
  /** for the partner - defined by Swan */
  | "Partner";

/** Rejection returned when Standing Order is not found */
export type StandingOrderNotFoundRejection = Rejection & {
  __typename: "StandingOrderNotFoundRejection";
  message: Scalars["String"]["output"];
};

/** Describes an identification level that has started for the process of the current identification */
export type StartedIdentificationLevelStatusInfo = {
  __typename: "StartedIdentificationLevelStatusInfo";
  /** Always set to `Started` */
  status: SwanIdentificationStatus;
};

/** Custom information for a certain type of statement */
export type StatementInfo = {
  type?: Maybe<StatementType>;
};

/** The different periods of statement */
export type StatementPeriod = "Custom" | "Monthly";

/** The different statuses of statement */
export type StatementStatus = "Available" | "Failed" | "Pending";

/**
 * The different type of statement actually available
 * - PDF will be a PDF file with the statement information
 */
export type StatementType = "CSV" | "PDF";

export type SucceededThreeDsStatusInfo = ThreeDsStatusInfo & {
  __typename: "SucceededThreeDsStatusInfo";
  status: IncomingThreeDsStatus;
};

/** Supporting document used for compliance */
export type SupportingDocument = {
  __typename: "SupportingDocument";
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Unique identifier of the document */
  id: Scalars["String"]["output"];
  /** Supporting document status information */
  statusInfo: SupportingDocumentStatusInfo;
  /** Purpose of supporting document */
  supportingDocumentPurpose: SupportingDocumentPurposeEnum;
  /** Type of supporting Document */
  supportingDocumentType?: Maybe<SupportingDocumentType>;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

export type SupportingDocumentAccountHolder = {
  __typename: "SupportingDocumentAccountHolder";
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Collection of supporting documents used for compliance
 *
 * Fetching SupportingDocument is restricted to Project access token
 */
export type SupportingDocumentCollection = {
  __typename: "SupportingDocumentCollection";
  accountHolder: SupportingDocumentAccountHolder;
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Unique identifier of the supporting document collection */
  id: Scalars["String"]["output"];
  onboarding: SupportingDocumentOnboarding;
  projectInfo: ProjectInfo;
  /** List of required supporting document purposes for this supporting document collection */
  requiredSupportingDocumentPurposes: Array<SupportingDocumentPurpose>;
  /** Status of the supporting document collection */
  statusInfo: SupportingDocumentCollectionStatusInfo;
  /** SupportingDocumentCollection URL to Swan portal */
  supportingDocumentCollectionUrl: Scalars["String"]["output"];
  /** List of supported documents contained in the supporting document collection */
  supportingDocuments: Array<SupportingDocument>;
  transaction: SupportingDocumentTransaction;
  type: SupportingDocumentCollectionType;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** Verification renewal id */
  verificationRenewalId?: Maybe<Scalars["String"]["output"]>;
};

/** Supporting document collection with Approved status */
export type SupportingDocumentCollectionApprovedStatusInfo =
  SupportingDocumentCollectionStatusInfo & {
    __typename: "SupportingDocumentCollectionApprovedStatusInfo";
    /** Date on which the supporting document collection has been approved */
    approvedAt: Scalars["DateTime"]["output"];
    /** When the supporting document collection is approved */
    status: SupportingDocumentCollectionStatus;
  };

/** Supporting document collection with Canceled status */
export type SupportingDocumentCollectionCanceledStatusInfo =
  SupportingDocumentCollectionStatusInfo & {
    __typename: "SupportingDocumentCollectionCanceledStatusInfo";
    /** Date on which the supporting document collection has been canceled */
    canceledAt: Scalars["DateTime"]["output"];
    /** When the supporting document collection is canceled */
    status: SupportingDocumentCollectionStatus;
  };

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type SupportingDocumentCollectionConnection = Connection & {
  __typename: "SupportingDocumentCollectionConnection";
  /** SupportingDocumentCollectionEdge list */
  edges: Array<SupportingDocumentCollectionEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type SupportingDocumentCollectionEdge = Edge & {
  __typename: "SupportingDocumentCollectionEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The supporting document collection */
  node: SupportingDocumentCollection;
};

/** Filters that can be applied when listing supporting document collections */
export type SupportingDocumentCollectionFilterInput = {
  /** Supporting document collection status we're looking for */
  status?: InputMaybe<Array<SupportingDocumentCollectionStatus>>;
  /** Supporting document collection type/types we're looking for */
  type?: InputMaybe<Array<SupportingDocumentCollectionType>>;
};

/** Rejection returned if the supporting document collection was not found */
export type SupportingDocumentCollectionNotFoundRejection = Rejection & {
  __typename: "SupportingDocumentCollectionNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Supporting document collection with PendingReview status */
export type SupportingDocumentCollectionPendingReviewStatusInfo =
  SupportingDocumentCollectionStatusInfo & {
    __typename: "SupportingDocumentCollectionPendingReviewStatusInfo";
    /** When the supporting document collection is completed and in compliance review */
    status: SupportingDocumentCollectionStatus;
  };

/** Supporting document collection with Rejected status */
export type SupportingDocumentCollectionRejectedStatusInfo =
  SupportingDocumentCollectionStatusInfo & {
    __typename: "SupportingDocumentCollectionRejectedStatusInfo";
    /** Date on which the supporting document collection has been rejected */
    rejectedAt: Scalars["DateTime"]["output"];
    /** When the supporting document collection is rejected */
    status: SupportingDocumentCollectionStatus;
  };

/** Verification status of a supporting document collection */
export type SupportingDocumentCollectionStatus =
  /** When the supporting document collection is approved. Final status */
  | "Approved"
  /** When the supporting document collection is canceled. Final status */
  | "Canceled"
  /** When the supporting document collection is completed and in compliance review */
  | "PendingReview"
  /** When the supporting document collection is rejected. Final status */
  | "Rejected"
  /** When the supporting document collection is created and on going */
  | "WaitingForDocument";

/** Rejection returned if supporting document cannot be deleted because its supporting document collection status is not WaitingForDocument */
export type SupportingDocumentCollectionStatusDoesNotAllowDeletionRejection = Rejection & {
  __typename: "SupportingDocumentCollectionStatusDoesNotAllowDeletionRejection";
  message: Scalars["String"]["output"];
  supportingDocumentCollection: SupportingDocumentCollection;
  supportingDocumentCollectionStatus: SupportingDocumentCollectionStatus;
};

/** Rejection returned if supporting document cannot be updated because its supporting document collection status is not WaitingForDocument */
export type SupportingDocumentCollectionStatusDoesNotAllowUpdateRejection = Rejection & {
  __typename: "SupportingDocumentCollectionStatusDoesNotAllowUpdateRejection";
  message: Scalars["String"]["output"];
  supportingDocumentCollection: SupportingDocumentCollection;
  supportingDocumentCollectionStatus: SupportingDocumentCollectionStatus;
};

export type SupportingDocumentCollectionStatusInfo = {
  /** Status of the supporting document collection */
  status: SupportingDocumentCollectionStatus;
};

/** Rejection returned if the status transition is not allowed */
export type SupportingDocumentCollectionStatusNotAllowedRejection = Rejection & {
  __typename: "SupportingDocumentCollectionStatusNotAllowedRejection";
  message: Scalars["String"]["output"];
  newStatus: SupportingDocumentCollectionStatus;
  oldStatus: SupportingDocumentCollectionStatus;
};

export type SupportingDocumentCollectionType =
  | "AccountHolderVerificationRenewal"
  | "Merchant"
  | "Onboarding"
  | "Transaction";

/** Supporting document collection with WaitingForUpload status */
export type SupportingDocumentCollectionWaitingForDocumentStatusInfo =
  SupportingDocumentCollectionStatusInfo & {
    __typename: "SupportingDocumentCollectionWaitingForDocumentStatusInfo";
    /** When the Supporting Document Collection is created */
    status: SupportingDocumentCollectionStatus;
  };

/** Rejection returned if the supporting document was not found */
export type SupportingDocumentNotFoundRejection = Rejection & {
  __typename: "SupportingDocumentNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Supporting document with NotUploaded status. */
export type SupportingDocumentNotUploadedStatusInfo = SupportingDocumentStatusInfo & {
  __typename: "SupportingDocumentNotUploadedStatusInfo";
  /** When the document has not been updated on time. */
  status: SupportingDocumentStatus;
};

export type SupportingDocumentOnboarding = {
  __typename: "SupportingDocumentOnboarding";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type SupportingDocumentPostField = {
  __typename: "SupportingDocumentPostField";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/** Details of a supporting document purpose */
export type SupportingDocumentPurpose = {
  __typename: "SupportingDocumentPurpose";
  /** Corresponding supporting document types accepted for this supporting document purpose */
  acceptableSupportingDocumentTypes: Array<SupportingDocumentType>;
  /** Corresponding Supporting Document Purpose Description translation according to accept-language header */
  description: Scalars["String"]["output"];
  /** Corresponding Supporting Document Purpose Title translation according to accept-language header */
  label: Scalars["String"]["output"];
  /** Technical name of the purpose */
  name: SupportingDocumentPurposeEnum;
};

/** Supporting document purpose */
export type SupportingDocumentPurposeEnum =
  /** Decision of appointment of Administrator */
  | "AdministratorDecisionOfAppointment"
  /** Proof of association registration */
  | "AssociationRegistration"
  /** Banking */
  | "Banking"
  /** Proof of the company creation process */
  | "CompanyFormationRegistration"
  /** Company Obligations */
  | "CompanyObligations"
  /** Proof of company registration */
  | "CompanyRegistration"
  /** Company Treasury */
  | "CompanyTreasury"
  /** Donation */
  | "Donation"
  /** Financial Statements */
  | "FinancialStatements"
  /** Gambling Prize Winnings */
  | "GamblingPrizeWinnings"
  /** Minutes Of The General Assembly */
  | "GeneralAssemblyMinutes"
  /** Inheritance */
  | "Inheritance"
  /** Investment */
  | "Investment"
  /** Proof of identity of the legal representative */
  | "LegalRepresentativeProofOfIdentity"
  /** NIF Accreditation Card */
  | "NIFAccreditationCard"
  /** Other */
  | "Other"
  /** Politically exposed person declaration */
  | "PepDeclaration"
  /** Personal Income */
  | "PersonalIncome"
  /** Personal Savings */
  | "PersonalSavings"
  /** Signed power of attorney document to give the power to act on behalf. */
  | "PowerOfAttorney"
  /** Decision of appointment of the President */
  | "PresidentDecisionOfAppointment"
  /** Document demonstrating that the company is actively conducting business (e.g., invoices, contracts) */
  | "ProofOfBusinessActivity"
  /** Proof of company address */
  | "ProofOfCompanyAddress"
  /** Proof of company income */
  | "ProofOfCompanyIncome"
  /** Proof of identity */
  | "ProofOfIdentity"
  /** Proof of individual address */
  | "ProofOfIndividualAddress"
  /** Proof of individual income */
  | "ProofOfIndividualIncome"
  /** Proof of origin of funds */
  | "ProofOfOriginOfFunds"
  /** Real Estate Income */
  | "RealEstateIncome"
  /** Signed status */
  | "SignedStatus"
  /** Sworn statement */
  | "SwornStatement"
  /** Trade */
  | "Trade"
  /** UBO Declaration */
  | "UBODeclaration"
  /** Declaration form used to confirm whether an individual qualifies as a U.S. person */
  | "USPersonStatusDeclaration"
  /** Proof of address of the Ultimate Beneficial Owner */
  | "UltimateBeneficialOwnerProofOfAddress"
  /** Proof of identity of the Ultimate Beneficial Owner */
  | "UltimateBeneficialOwnerProofOfIdentity";

/** Refused supporting document reason code */
export type SupportingDocumentReasonCode =
  /** The quality of the document is really low. */
  | "BadDocumentQuality"
  /** The company name in document doesn’t match our records. */
  | "CompanyNameMismatch"
  /** The document must be dated less than 3 months ago. */
  | "ExpiredDocument"
  /** Full Document required. */
  | "FullDocumentRequired"
  /** The beneficiary IBAN on the document we received does not match the information requested for the transaction. */
  | "IbanMismatch"
  /** The address in document doesn’t match our records. */
  | "InvalidAddress"
  /** The document is not valid. */
  | "InvalidDocument"
  /** The name of shareholder is not clearly visible or some fields are not duely completed. */
  | "InvalidOrMissingData"
  /** The document appears to be inconsistent with the specified transaction. */
  | "InvalidTransaction"
  /** The document provided is missing essential details required to comprehend the transaction's nature. Please submit an additional supporting document to supplement the initial one. */
  | "MissingDescription"
  /** Documents are not signed or dated. */
  | "MissingSignature"
  /** Other */
  | "Other"
  /** The document must be in color. */
  | "ProviderColorIdDocumentRequired"
  /** The amount on the document we received does not match the information requested for the transaction. */
  | "TransactionAmountMismatch"
  /** The date on the document we received does not match the information requested for the transaction. */
  | "TransactionDateMismatch"
  /** The issuer or beneficiary name on the document we received does not match the information requested for the transaction. */
  | "TransactionNameMismatch"
  /** Document cannot be accepted for the requested document type. */
  | "UnacceptableDocument";

/** Supporting document with Refused status */
export type SupportingDocumentRefusedStatusInfo = SupportingDocumentStatusInfo & {
  __typename: "SupportingDocumentRefusedStatusInfo";
  /** Original file name */
  filename: Scalars["String"]["output"];
  /** Reason why the supporting document has been refused */
  reason: Scalars["String"]["output"];
  /** Reason code why the supporting document has been refused */
  reasonCode: SupportingDocumentReasonCode;
  /** Date on which the supporting document collection has been refused */
  refusedAt: Scalars["DateTime"]["output"];
  /** When the document has been refused by Swan */
  status: SupportingDocumentStatus;
};

export type SupportingDocumentRequirements = {
  __typename: "SupportingDocumentRequirements";
  supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
};

/** Verification status of a document */
export type SupportingDocumentStatus =
  /** Document has not been uploaded on time. */
  | "NotUploaded"
  /** Document has been refused by Swan. */
  | "Refused"
  /** Document has been uploaded but not verified by Swan yet. */
  | "Uploaded"
  /** Document has been uploaded and verified by Swan. */
  | "Validated"
  /** Document is not uploaded yet. */
  | "WaitingForUpload";

/** Rejection returned if supporting document cannot be deleted because of its status */
export type SupportingDocumentStatusDoesNotAllowDeletionRejection = Rejection & {
  __typename: "SupportingDocumentStatusDoesNotAllowDeletionRejection";
  message: Scalars["String"]["output"];
  status: SupportingDocumentStatus;
  supportingDocument: SupportingDocument;
};

/** Rejection returned if supporting document cannot be updated because of its status */
export type SupportingDocumentStatusDoesNotAllowUpdateRejection = Rejection & {
  __typename: "SupportingDocumentStatusDoesNotAllowUpdateRejection";
  message: Scalars["String"]["output"];
  status: SupportingDocumentStatus;
  supportingDocument: SupportingDocument;
};

export type SupportingDocumentStatusInfo = {
  /** Status of the supporting document */
  status: SupportingDocumentStatus;
};

/** Rejection returned if the status transition is not allowed */
export type SupportingDocumentStatusNotAllowedRejection = Rejection & {
  __typename: "SupportingDocumentStatusNotAllowedRejection";
  message: Scalars["String"]["output"];
  newStatus: SupportingDocumentStatus;
  oldStatus: SupportingDocumentStatus;
};

export type SupportingDocumentTransaction = {
  __typename: "SupportingDocumentTransaction";
  id?: Maybe<Scalars["ID"]["output"]>;
};

/** Specific type for document */
export type SupportingDocumentType =
  /** Account statement */
  | "AccountStatement"
  /** Legal document required for company’s formation */
  | "ArticlesOfIncorporation"
  /** Document with details such as bank name, address, account number and account holder */
  | "BankAccountDetails"
  /** Bank Statement */
  | "BankStatement"
  /** By Laws */
  | "ByLaws"
  /** Share Deposit Certificate */
  | "CapitalShareDepositCertificate"
  /** Official document confirming that an individual has voluntarily renounced their citizenship */
  | "CertificateOfLossOfNationality"
  /** Lease agreement in the name of the business or Proof of Individual Address if the company is hosted by one of the legal representative */
  | "CompanyLeaseAgreement"
  /** Document submitted to your tax bureau at the end of the last business period */
  | "CorporateIncomeTaxReturn"
  /** Decision of appointment */
  | "DecisionOfAppointment"
  /** Deed of donation */
  | "DeedOfDonation"
  /** Deed of sale */
  | "DeedOfSale"
  /** Deed of succession */
  | "DeedOfSuccession"
  /** Driving license */
  | "DrivingLicense"
  /** Financial Statements */
  | "FinancialStatements"
  /** Home Insurance contract */
  | "HomeInsurance"
  /** Income Tax return or tax-exemption certificate dating less than 2 years */
  | "IncomeTaxReturn"
  /** Invoice */
  | "Invoice"
  /** Association registration proof for french association */
  | "JOAFFEExtract"
  /** Loan contract */
  | "LoanContract"
  /** Meeting's minutes */
  | "MeetingMinutes"
  /** NIF Accreditation Card */
  | "NIFAccreditationCard"
  /** NationalIdCard */
  | "NationalIdCard"
  /** Notarial deed */
  | "NotarialDeed"
  /** Other */
  | "Other"
  /** Passport */
  | "Passport"
  /** A pay slip dating less than 3 months */
  | "PaySlip"
  /** Politically exposed person declaration */
  | "PepDeclaration"
  /** Telephone Bill issued within the last 3 months */
  | "PhoneBill"
  /** Signed power of attorney document to give the power to act on behalf */
  | "PowerOfAttorney"
  /** Commercial registry extract issued within the last 3 months */
  | "RegisterExtract"
  /** Rental Receipt issued within the last 3 months */
  | "RentReceipt"
  /** Resident permit */
  | "ResidentPermit"
  /** Selfie */
  | "Selfie"
  /** Sworn statement */
  | "SwornStatement"
  /** Ultimate Beneficial Owner Declaration */
  | "UBODeclaration"
  /** Water, Electricity or Gas Bill issued within the last 3 months */
  | "UtilityBill"
  /** IRS form used by non-U.S. persons to certify their foreign status and claim tax treaty benefits */
  | "W8"
  /** IRS form used to confirm a U.S. person's taxpayer identification number and tax status */
  | "W9"
  /** Winnings Certificate */
  | "WinningsCertificate";

export type SupportingDocumentUploadInfo = {
  __typename: "SupportingDocumentUploadInfo";
  fields: Array<SupportingDocumentPostField>;
  url: Scalars["String"]["output"];
};

/** Rejection returned if the supporting document collection cannot receive supporting documents anymore */
export type SupportingDocumentUploadNotAllowedRejection = Rejection & {
  __typename: "SupportingDocumentUploadNotAllowedRejection";
  message: Scalars["String"]["output"];
  supportingDocumentCollectionStatus: SupportingDocumentCollectionStatus;
};

/** Supporting document with Uploaded status */
export type SupportingDocumentUploadedStatusInfo = SupportingDocumentStatusInfo & {
  __typename: "SupportingDocumentUploadedStatusInfo";
  /** Original file name */
  filename: Scalars["String"]["output"];
  /** When the document has been uploaded but not verified by Swan yet */
  status: SupportingDocumentStatus;
};

/** Supporting document with Validated status */
export type SupportingDocumentValidatedStatusInfo = SupportingDocumentStatusInfo & {
  __typename: "SupportingDocumentValidatedStatusInfo";
  /** Original file name */
  filename: Scalars["String"]["output"];
  /** Reason why the supporting document has been validated */
  reason: Scalars["String"]["output"];
  /** When the document has been uploaded and verified by Swan */
  status: SupportingDocumentStatus;
  /** Date on which the supporting document has been validated */
  validatedAt: Scalars["DateTime"]["output"];
};

/** Supporting document with WaitingForUpload status */
export type SupportingDocumentWaitingForUploadStatusInfo = SupportingDocumentStatusInfo & {
  __typename: "SupportingDocumentWaitingForUploadStatusInfo";
  /** When the document is not uploaded yet */
  status: SupportingDocumentStatus;
  supportingDocumentId: Scalars["String"]["output"];
  /** Info to upload the document : url and fields to add along file in form (POST) */
  upload: SupportingDocumentUploadInfo;
};

/** Define a reason with a message and a specific type for suspend account action */
export type SuspendAccountReason = Reason & {
  __typename: "SuspendAccountReason";
  message?: Maybe<Scalars["String"]["output"]>;
  type: SuspendAccountReasonType;
};

/** Input version */
export type SuspendAccountReasonInput = {
  message?: InputMaybe<Scalars["String"]["input"]>;
  type: SuspendAccountReasonType;
};

/** Specific type for suspend account action */
export type SuspendAccountReasonType =
  /** Simple suspend request */
  "SuspendRequested";

/** SuspendAccountStatusReason */
export type SuspendAccountStatusReason = SuspendAccountReason;

/** StatusInfo when funding limit settings has been suspended */
export type SuspendedFundingLimitSettingsStatusInfo = FundingLimitSettingsStatusInfo & {
  __typename: "SuspendedFundingLimitSettingsStatusInfo";
  reason: Scalars["String"]["output"];
  status: FundingLimitSettingsStatus;
};

/** SuspendedMerchantPaymentMethodStatusInfo */
export type SuspendedMerchantPaymentMethodStatusInfo = MerchantPaymentMethodStatusInfo & {
  __typename: "SuspendedMerchantPaymentMethodStatusInfo";
  status: MerchantPaymentMethodStatus;
  /** Merchant Payment Method suspended date */
  suspendedAt: Scalars["Date"]["output"];
};

/** SuspendedMerchantProfileStatusInfo */
export type SuspendedMerchantProfileStatusInfo = MerchantProfileStatusInfo & {
  __typename: "SuspendedMerchantProfileStatusInfo";
  status: MerchantProfileStatus;
  suspendedAt: Scalars["Date"]["output"];
};

/** Swan account beneficiary */
export type SwanAccountBeneficiaryInput = {
  /** account number to be credited */
  accountNumber: Scalars["AccountNumber"]["input"];
  /** full name of the beneficiary  (max 70 characters) */
  name: Scalars["String"]["input"];
  /** `true` if this new beneficiary will be saved to the beneficiary list of the debited account. */
  save: Scalars["Boolean"]["input"];
};

/** Status values of an identification */
export type SwanIdentificationStatus =
  /** When the user canceled the identification process or the identification service was unavailable */
  | "Canceled"
  /** When the identification is no longer valid */
  | "Expired"
  /** When the identification is invalid */
  | "Invalid"
  /** When the identification hasn't been started yet */
  | "NotStarted"
  /** When the identification does not support an identification level */
  | "NotSupported"
  /** When the identification process is currently being treated by a manual or automatic process */
  | "Pending"
  /** When the identification has been started */
  | "Started"
  /** When the identification is valid */
  | "Valid";

export type TextField = Field & {
  __typename: "TextField";
  displayFormat?: Maybe<Scalars["String"]["output"]>;
  example?: Maybe<Scalars["String"]["output"]>;
  key: Scalars["String"]["output"];
  maxLength?: Maybe<Scalars["Int"]["output"]>;
  minLength?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
  refreshDynamicFieldsOnChange: Scalars["Boolean"]["output"];
  required: Scalars["Boolean"]["output"];
  validationRegex?: Maybe<Scalars["String"]["output"]>;
};

/** The details of the 3DS challenge associated to the payment. */
export type ThreeDs = {
  __typename: "ThreeDS";
  /** The status of the 3DS challenge */
  statusInfo: ThreeDsStatusInfo;
};

export type ThreeDsConsent = DetailedConsent & {
  __typename: "ThreeDsConsent";
  acceptedAt?: Maybe<Scalars["DateTime"]["output"]>;
  amount: AmountWithCurrency;
  branding: Branding;
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  challenge?: Maybe<Scalars["String"]["output"]>;
  channelName?: Maybe<Scalars["String"]["output"]>;
  consentOperations: Array<ConsentOperation>;
  consentResponses: Array<ConsentResponse>;
  createdAt: Scalars["DateTime"]["output"];
  env: EnvType;
  expiredAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  identityId: Scalars["String"]["output"];
  maskedCardNumber: Scalars["String"]["output"];
  merchantAppRedirectUrl?: Maybe<Scalars["String"]["output"]>;
  merchantCategoryCode?: Maybe<Scalars["String"]["output"]>;
  merchantId: Scalars["String"]["output"];
  merchantName: Scalars["String"]["output"];
  monextCardId: Scalars["String"]["output"];
  operationsSHA256HexDigest?: Maybe<Scalars["String"]["output"]>;
  projectId?: Maybe<Scalars["String"]["output"]>;
  purpose: DetailedConsentPurpose;
  /** the QR code in base64 representing the consent URL */
  qrCodeBase64?: Maybe<Scalars["String"]["output"]>;
  refusedAt?: Maybe<Scalars["DateTime"]["output"]>;
  requireSCA: Scalars["Boolean"]["output"];
  serviceToHook: Scalars["String"]["output"];
  startedAt?: Maybe<Scalars["DateTime"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  status: ConsentStatus;
  updatedAt: Scalars["DateTime"]["output"];
  userId?: Maybe<Scalars["String"]["output"]>;
};

export type ThreeDsStatusInfo = {
  status: IncomingThreeDsStatus;
};

/** Rejection returned if too many items are given */
export type TooManyItemsRejection = Rejection & {
  __typename: "TooManyItemsRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned if the transaction was already returned */
export type TransactionAlreadyReturnedRejection = Rejection & {
  __typename: "TransactionAlreadyReturnedRejection";
  message: Scalars["String"]["output"];
  returnTransactionId: Scalars["ID"]["output"];
};

/** Rejection returned if the transaction was not found */
export type TransactionNotFoundRejection = Rejection & {
  __typename: "TransactionNotFoundRejection";
  message: Scalars["String"]["output"];
  transactionId: Scalars["ID"]["output"];
};

export type TransactionSide = "Credit" | "Debit";

export type TransactionTransportType =
  | "AuthorizedAggregatedSplitClearing"
  | "DebtRecovery"
  | "Other"
  | "PostAuthorizedAggregated"
  | "PostAuthorizedAggregatedMaestro"
  | "Prefunded"
  | "RealTimeAuthorized";

/** Quality of the account holder doing the onboarding */
export type TypeOfRepresentation =
  /** The account holder is the legal representative */
  | "LegalRepresentative"
  /** The account holder has a power of attorney */
  | "PowerOfAttorney";

export type UboIdentityDocumentDetails = {
  __typename: "UBOIdentityDocumentDetails";
  /** Expiry date of the identity document */
  expiryDate?: Maybe<Scalars["String"]["output"]>;
  /** Issue date of the identity document */
  issueDate?: Maybe<Scalars["String"]["output"]>;
  /** Issuing authority of the identity document */
  issuingAuthority?: Maybe<Scalars["String"]["output"]>;
  /** Number of the identity document */
  number?: Maybe<Scalars["String"]["output"]>;
  /** Type of identity document */
  type?: Maybe<UboIdentityDocumentType>;
};

export type UboIdentityDocumentDetailsInput = {
  /** Expiry date of the identity document */
  expiryDate?: InputMaybe<Scalars["String"]["input"]>;
  /** Issue date of the identity document */
  issueDate?: InputMaybe<Scalars["String"]["input"]>;
  /** Issuing authority of the identity document */
  issuingAuthority?: InputMaybe<Scalars["String"]["input"]>;
  /** Number of the identity document */
  number?: InputMaybe<Scalars["String"]["input"]>;
  /** Type of identity document */
  type?: InputMaybe<UboIdentityDocumentType>;
};

export type UboIdentityDocumentType = "IdCard" | "Passport";

/** Input of the updateAccountHolderFundingLimits mutation */
export type UpdateAccountHolderFundingLimitsInput = {
  /** ID of the funding limit's account holder to update */
  accountHolderId: Scalars["ID"]["input"];
  /** Global funding amount authorized during the interval */
  fundingLimitAmount: AmountInput;
  /** Interval in number of calendar days where the limit is applied */
  fundingLimitRollingDays: Scalars["Int"]["input"];
  /** Instant funding amount authorized */
  instantFundingLimitAmount: AmountInput;
};

/** Response of the updateAccountHolderFundingLimits mutation */
export type UpdateAccountHolderFundingLimitsPayload =
  | InternalErrorRejection
  | UpdateAccountHolderFundingLimitsSuccessPayload;

export type UpdateAccountHolderFundingLimitsSuccessPayload = {
  __typename: "UpdateAccountHolderFundingLimitsSuccessPayload";
  accountHolderId: Scalars["ID"]["output"];
};

export type UpdateAccountHolderInput = {
  accountHolderId: Scalars["ID"]["input"];
  /** VerificationRequirements for the Account Holder, can only be used when verificationStatus is WaitingForInformation */
  verificationRequirements?: InputMaybe<Array<VerificationRequirementType>>;
  verificationStatus?: InputMaybe<VerificationStatus>;
};

export type UpdateAccountHolderPayload =
  | AccountHolderNotFoundRejection
  | UpdateAccountHolderSuccessPayload
  | ValidationRejection
  | VerificationRequirementsNotUpdatableRejection;

export type UpdateAccountHolderSuccessPayload = {
  __typename: "UpdateAccountHolderSuccessPayload";
  accountHolder: AccountHolder;
};

/** Inputs to update the account verification status */
export type UpdateAccountVerificationStatusInput = {
  /** The unique identifier of the account verification */
  accountVerificationId: Scalars["ID"]["input"];
  /** The new status that the account verification should take */
  newStatus: AccountVerificationStatus;
};

/** Union type return by the addReceivedSepaDirectDebitB2bMandate mutation */
export type UpdateAccountVerificationStatusPayload =
  | ForbiddenRejection
  | UpdateAccountVerificationStatusSuccessPayload;

/** Return type in case of a successful response of the updateAccountVerificationStatus mutation */
export type UpdateAccountVerificationStatusSuccessPayload = {
  __typename: "UpdateAccountVerificationStatusSuccessPayload";
  /** The updated account verification */
  accountVerification: AccountVerification;
};

export type UpdateFundingLimitSettingsChangeRequestInput = {
  approvedFundingLimit?: InputMaybe<FundingLimitAmountInput>;
  approvedInstantFundingLimit?: InputMaybe<FundingLimitAmountInput>;
  fundingLimitSettingsChangeRequestId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<FundingLimitSettingsChangeRequestStatus>;
};

export type UpdateFundingLimitSettingsChangeRequestPayload =
  | ForbiddenRejection
  | FundingLimitSettingsChangeRequestNotFoundRejection
  | FundingLimitSettingsChangeRequestStatusNotAllowedRejection
  | UpdateFundingLimitSettingsChangeRequestSuccessPayload
  | ValidationRejection;

export type UpdateFundingLimitSettingsChangeRequestSuccessPayload = {
  __typename: "UpdateFundingLimitSettingsChangeRequestSuccessPayload";
  fundingLimitSettingsChangeRequest: FundingLimitSettingsChangeRequest;
};

export type UpdateRequestNotPendingReviewRejection = Rejection & {
  __typename: "UpdateRequestNotPendingReviewRejection";
  message: Scalars["String"]["output"];
  requestUpdateId?: Maybe<Scalars["ID"]["output"]>;
};

/** Update sandbox identification input payload. */
export type UpdateSandboxIdentificationInput = {
  errorReasons?: InputMaybe<Array<IdentificationInvalidReason>>;
  identificationId: Scalars["String"]["input"];
  levels: IdentificationLevelStatusesInput;
  process: IdentificationProcess;
};

/** Union of success payload and possible rejections */
export type UpdateSandboxIdentificationPayload =
  | ForbiddenRejection
  | InvalidIdentificationErrorReasonsRejection
  | InvalidIdentificationLevelsRejection
  | SandboxIdentificationNotFoundRejection
  | UpdateSandboxIdentificationSuccessPayload;

/** Success payload type */
export type UpdateSandboxIdentificationSuccessPayload = {
  __typename: "UpdateSandboxIdentificationSuccessPayload";
  /** Updated sandbox identification */
  sandboxIdentification: SandboxIdentification;
};

export type UpdateSandboxUserInput = {
  /** List of first names */
  allFirstNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * Saves you considerable time during the development phase,
   * by automatically allowing consent,
   * removing the need to repeatedly get consent.
   */
  autoConsent: Scalars["Boolean"]["input"];
  /** [Alpha-3 birth country representation](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3) */
  birthCountryCCA3?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Birth date */
  birthDate: Scalars["Date"]["input"];
  /** First name */
  firstName: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  /** Last name */
  lastName: Scalars["String"]["input"];
  /**
   * [Alpha-3 nationality representation](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3)
   * Ex: FRA for french nationality
   */
  nationalityCCA3: Scalars["CCA3"]["input"];
};

export type UpdateSandboxUserPayload =
  | ForbiddenRejection
  | NationalityNotFoundRejection
  | SandboxUserNotFoundRejection
  | UpdateSandboxUserSuccessPayload;

export type UpdateSandboxUserSuccessPayload = {
  __typename: "UpdateSandboxUserSuccessPayload";
  sandboxUser: SandboxUser;
};

export type UpdateSupportingDocumentCollectionStatusInput = {
  status: SupportingDocumentCollectionStatus;
  supportingDocumentCollectionId: Scalars["ID"]["input"];
};

export type UpdateSupportingDocumentCollectionStatusPayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | SupportingDocumentCollectionNotFoundRejection
  | SupportingDocumentCollectionStatusNotAllowedRejection
  | UpdateSupportingDocumentCollectionStatusSuccessPayload
  | ValidationRejection;

export type UpdateSupportingDocumentCollectionStatusSuccessPayload = {
  __typename: "UpdateSupportingDocumentCollectionStatusSuccessPayload";
  supportingDocumentCollection: SupportingDocumentCollection;
};

export type UpdateSupportingDocumentStatusInput = {
  reasonCode?: InputMaybe<SupportingDocumentReasonCode>;
  status: SupportingDocumentStatus;
  supportingDocumentId: Scalars["ID"]["input"];
};

export type UpdateSupportingDocumentStatusPayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | SupportingDocumentCollectionNotFoundRejection
  | SupportingDocumentCollectionStatusDoesNotAllowUpdateRejection
  | SupportingDocumentNotFoundRejection
  | SupportingDocumentStatusDoesNotAllowUpdateRejection
  | UpdateSupportingDocumentStatusSuccessPayload
  | ValidationRejection;

export type UpdateSupportingDocumentStatusSuccessPayload = {
  __typename: "UpdateSupportingDocumentStatusSuccessPayload";
  supportingDocument: SupportingDocument;
};

/** The User is the unique user, natural person, of the Swan app. */
export type User = {
  __typename: "User";
  /**
   * The list of account memberships
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  accountMemberships: AccountMembershipConnection;
  /** list of first names */
  allFirstNames?: Maybe<Array<Scalars["String"]["output"]>>;
  /** the methods used to authenticate this user */
  authenticators?: Maybe<Array<Authenticator>>;
  /** birth city */
  birthCity?: Maybe<Scalars["String"]["output"]>;
  /** birth country */
  birthCountry?: Maybe<Scalars["CCA3"]["output"]>;
  /** birth date */
  birthDate?: Maybe<Scalars["Date"]["output"]>;
  /** Birth last name */
  birthLastName?: Maybe<Scalars["String"]["output"]>;
  /** Creation date of the user */
  createdAt: Scalars["DateTime"]["output"];
  /** first name */
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** full name : concatenation of firstName + [ birthLastName | lastName ] depending on preferredLastName setting */
  fullName?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of the user */
  id: Scalars["ID"]["output"];
  /**
   * List of identification levels available for the user.
   *
   * Whenever TRUE, it means the identification was successful for the associated level.
   */
  identificationLevels?: Maybe<IdentificationLevels>;
  /** last name */
  lastName?: Maybe<Scalars["String"]["output"]>;
  /** mobile phone number with the international format (Example: +33689788967) */
  mobilePhoneNumber?: Maybe<Scalars["PhoneNumber"]["output"]>;
  /** nationality */
  nationalityCCA3?: Maybe<Scalars["CCA3"]["output"]>;
  /** The last name that the user prefers to use */
  preferredLastName?: Maybe<Scalars["String"]["output"]>;
  /**
   * Preferred notification channel
   *
   * When it is "null" it means that the preferences have not been updated. Default SMS in use
   */
  preferredNotificationChannel?: Maybe<PreferredNotificationChannel>;
  /** Status of the user */
  status?: Maybe<UserStatus>;
  /** Last update date of the user */
  updatedAt: Scalars["DateTime"]["output"];
};

/** The User is the unique user, natural person, of the Swan app. */
export type UserAccountMembershipsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<AccountMembershipsFilterInput>;
  first?: Scalars["Int"]["input"];
};

/** Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type UserConnection = Connection & {
  __typename: "UserConnection";
  /** UserEdge list */
  edges: Array<UserEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

export type UserConsentSettings = {
  __typename: "UserConsentSettings";
  /** Preferred notification channel */
  preferredNotificationChannel: PreferredNotificationChannel;
  /** Project identifier */
  projectId: Scalars["String"]["output"];
  /** User identifier */
  userId: Scalars["String"]["output"];
};

/** Implements the Relay Edge interface */
export type UserEdge = Edge & {
  __typename: "UserEdge";
  /** Opaque identifier pointing to this consent node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The user */
  node: User;
};

export type UserNotFoundRejection = Rejection & {
  __typename: "UserNotFoundRejection";
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
};

export type UserStatus =
  /** Users with Active status are able to login & use Swan. */
  | "Active"
  /** Users in Blocked status are not able to login for security reason. Their phone number can't be reused. */
  | "Blocked"
  /** Users in Deactivated status don't use Swan anymore and won't ever be able to login. Their phone number can be reused as a new number. */
  | "Deactivated";

/** Describes a valid identification level for the process associated to this identification, and identification documents can be accessed */
export type ValidIdentificationLevelStatusInfo = {
  __typename: "ValidIdentificationLevelStatusInfo";
  /** Always set to `Valid` */
  status: SwanIdentificationStatus;
};

/** A detail of a validation error : what field is errored and why */
export type ValidationError = {
  __typename: "ValidationError";
  /** Human readable message explaining the errors */
  details?: Maybe<Scalars["String"]["output"]>;
  /** Constraints that are not matched on the Onboarding property */
  errors?: Maybe<Array<FieldValidationError>>;
  /** Onboarding property that is not matching requirements to allow a finalization */
  field: Scalars["String"]["output"];
};

export type ValidationFieldError = {
  __typename: "ValidationFieldError";
  code: ValidationFieldErrorCode;
  message: Scalars["String"]["output"];
  path: Array<Scalars["String"]["output"]>;
};

export type ValidationFieldErrorCode =
  | "InvalidString"
  | "InvalidType"
  | "TooLong"
  | "TooShort"
  | "UnrecognizedKeys";

/** Rejection returned if an input contains invalid data */
export type ValidationRejection = Rejection & {
  __typename: "ValidationRejection";
  fields: Array<ValidationFieldError>;
  message: Scalars["String"]["output"];
};

/**
 * Account Holder Verification Requirement
 *
 * It is a sub status for the Account Holder when his verification status is WaitingForInformation
 */
export type VerificationRequirement = {
  __typename: "VerificationRequirement";
  id: Scalars["ID"]["output"];
  type: VerificationRequirementType;
};

export type VerificationRequirementType =
  /** Swan is requesting for a 1st transfer */
  | "FirstTransferRequired"
  /** Swan is requesting some clarification on the legal representative or on the account member with legal representative permissions */
  | "LegalRepresentativeDetailsRequired"
  /** Swan is requesting some clarification on the organization */
  | "OrganizationDetailsRequired"
  /** Swan is requesting more information on the account holders */
  | "Other"
  /** Swan is requesting some Supporting Documents */
  | "SupportingDocumentsRequired"
  /** Swan is requesting some tax identifier */
  | "TaxIdRequired"
  /** Swan is requesting some clarification on the UBO */
  | "UboDetailsRequired";

export type VerificationRequirementsMandatoryRejection = Rejection & {
  __typename: "VerificationRequirementsMandatoryRejection";
  message: Scalars["String"]["output"];
};

export type VerificationRequirementsNotUpdatableRejection = Rejection & {
  __typename: "VerificationRequirementsNotUpdatableRejection";
  accountHolderId: Scalars["String"]["output"];
  accountHolderVerificationStatus: VerificationStatus;
  message: Scalars["String"]["output"];
};

/** Verification status of an account holder */
export type VerificationStatus =
  /** When the account holder has not started to answer the verification process. */
  | "NotStarted"
  /** When the verification process is pending. */
  | "Pending"
  /** When the account holder is refused. */
  | "Refused"
  /** When the account holder is verified. */
  | "Verified"
  /** When Swan is waiting for information about the account holder to continue the verification process. */
  | "WaitingForInformation";

/** Enabled Information */
export type VerifiedStatusInfo = AccountVerificationStatusInfo & {
  __typename: "VerifiedStatusInfo";
  /** Account verification status (Verified) */
  status: AccountVerificationStatus;
  /** Date at which the verification was verified */
  verifiedAt: Scalars["DateTime"]["output"];
};

/** Virtual IBAN can be used by the account holder to receive SCT (Sepa Credit Transfer) or to be debited by SDD (Sepa Direct Debit). */
export type VirtualIbanEntry = {
  __typename: "VirtualIBANEntry";
  /** Bank Identifier Code */
  BIC: Scalars["BIC"]["output"];
  /** International Bank Account Number */
  IBAN: Scalars["IBAN"]["output"];
  /** Download link to the virtual iban's bank details */
  bankDetails?: Maybe<Scalars["String"]["output"]>;
  /** `true` if the Virtual IBAN refuses all Sepa Direct Debit received */
  blockSDD: Scalars["Boolean"]["output"];
  /** Unique identifier of a Virtual IBAN entry */
  id: Scalars["ID"]["output"];
  /** Label (could be used to identify) */
  label?: Maybe<Scalars["String"]["output"]>;
  /** Status of the Iban */
  status: IbanStatus;
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type VirtualIbanEntryConnection = Connection & {
  __typename: "VirtualIBANEntryConnection";
  /** VirtualIBANEntryEdge list */
  edges: Array<VirtualIbanEntryEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type VirtualIbanEntryEdge = Edge & {
  __typename: "VirtualIBANEntryEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The virtual iban entry */
  node: VirtualIbanEntry;
};

/** Filters that can be applied when listing virtual iban entries */
export type VirtualIbanEntriesFilterInput = {
  /** unique identifiers of the virtual IBAN entries to fetch */
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** WaitingForInformationMerchantPaymentMethodStatusInfo */
export type WaitingForInformationMerchantPaymentMethodStatusInfo =
  MerchantPaymentMethodStatusInfo & {
    __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
    status: MerchantPaymentMethodStatus;
    /** List of requirements that should be fulfilled */
    verificationRequirements: Array<MerchantVerificationRequirements>;
    /** Merchant Payment Method waitingForInformation date */
    waitingForInformationAt: Scalars["Date"]["output"];
  };

/** Wallet Provider */
export type WalletProviderType = "ApplePay" | "GooglePay";

export type WebBankingSettings = {
  __typename: "WebBankingSettings";
  canAddNewMembers?: Maybe<Scalars["Boolean"]["output"]>;
  canCreateMerchantPaymentLinks?: Maybe<Scalars["Boolean"]["output"]>;
  canCreateMerchantProfile?: Maybe<Scalars["Boolean"]["output"]>;
  canInitiateCheckMerchantPayments?: Maybe<Scalars["Boolean"]["output"]>;
  canInitiatePaymentsToNewBeneficiaries?: Maybe<Scalars["Boolean"]["output"]>;
  canManageVirtualIbans?: Maybe<Scalars["Boolean"]["output"]>;
  canOpenAccount?: Maybe<Scalars["Boolean"]["output"]>;
  canOrderPhysicalCards?: Maybe<Scalars["Boolean"]["output"]>;
  canOrderVirtualCards?: Maybe<Scalars["Boolean"]["output"]>;
  canRequestChecksPaymentMethod?: Maybe<Scalars["Boolean"]["output"]>;
  canRequestInternalDirectDebitB2BPaymentMethod?: Maybe<Scalars["Boolean"]["output"]>;
  canRequestInternalDirectDebitCorePaymentMethod?: Maybe<Scalars["Boolean"]["output"]>;
  canRequestOnlineCardsPaymentMethod?: Maybe<Scalars["Boolean"]["output"]>;
  canRequestSepaDirectDebitB2BPaymentMethod?: Maybe<Scalars["Boolean"]["output"]>;
  canRequestSepaDirectDebitCorePaymentMethod?: Maybe<Scalars["Boolean"]["output"]>;
  canUpdateCards?: Maybe<Scalars["Boolean"]["output"]>;
  canViewAccountDetails?: Maybe<Scalars["Boolean"]["output"]>;
  canViewAccountStatement?: Maybe<Scalars["Boolean"]["output"]>;
  canViewMembers?: Maybe<Scalars["Boolean"]["output"]>;
  canViewPaymentList?: Maybe<Scalars["Boolean"]["output"]>;
};

export type WeeklyPeriod = {
  __typename: "WeeklyPeriod";
  dayOfWeek: DayEnum;
  weekCount: Scalars["Int"]["output"];
};

/** Rejection returned when a parameter has a wrong value */
export type WrongValueProvidedRejection = Rejection & {
  __typename: "WrongValueProvidedRejection";
  message: Scalars["String"]["output"];
  parameterName: Scalars["String"]["output"];
  valueProvided: Scalars["String"]["output"];
};

export type SandboxUsersQueryVariables = Exact<{
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  orderBy: SandboxUsersOrderByInput;
}>;

export type SandboxUsersQuery = {
  __typename: "Query";
  sandboxUser: {
    __typename: "SandboxUser";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
  };
  sandboxUsers?: {
    __typename: "SandboxUserConnection";
    totalCount: number;
    pageInfo: { __typename: "PageInfo"; hasNextPage?: boolean | null; endCursor?: string | null };
    edges: Array<{
      __typename: "SandboxUserEdge";
      cursor: string;
      node: {
        __typename: "SandboxUser";
        id: string;
        firstName?: string | null;
        lastName?: string | null;
      };
    }>;
  } | null;
};

export type SandboxUserQueryVariables = Exact<{ [key: string]: never }>;

export type SandboxUserQuery = {
  __typename: "Query";
  sandboxUser: {
    __typename: "SandboxUser";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
  };
};

export type EndorseSandboxUserMutationVariables = Exact<{
  input: EndorseSandboxUserInput;
}>;

export type EndorseSandboxUserMutation = {
  __typename: "Mutation";
  endorseSandboxUser:
    | { __typename: "EndorseSandboxUserSuccessPayload" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "SandboxUserNotFoundRejection" };
};

export const SandboxUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SandboxUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "SandboxUsersOrderByInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sandboxUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sandboxUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SandboxUsersQuery, SandboxUsersQueryVariables>;
export const SandboxUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SandboxUser" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sandboxUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SandboxUserQuery, SandboxUserQueryVariables>;
export const EndorseSandboxUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EndorseSandboxUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "EndorseSandboxUserInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "endorseSandboxUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EndorseSandboxUserMutation, EndorseSandboxUserMutationVariables>;
